var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/cloud/index.ts
var cloud_exports = {};
__export(cloud_exports, {
  AcceptPerformerRequestValidation: () => AcceptPerformerRequestValidation,
  AcknowledgeFareAssignationValidation: () => AcknowledgeFareAssignationValidation,
  AcknowledgeNotificationValidation: () => AcknowledgeNotificationValidation,
  AddBedsToNightAndWeekendBedListValidation: () => AddBedsToNightAndWeekendBedListValidation,
  AssignCleaningMissionValidation: () => AssignCleaningMissionValidation,
  AssignDashboardToSlotValidation: () => AssignDashboardToSlotValidation,
  AssignFareValidation: () => AssignFareValidation,
  CancelAccommodationRequestValidation: () => CancelAccommodationRequestValidation,
  CancelAccommodationValidation: () => CancelAccommodationValidation,
  CancelBedBlockValidation: () => CancelBedBlockValidation,
  CancelBiocleaningValidation: () => CancelBiocleaningValidation,
  CancelCleaningMissionValidation: () => CancelCleaningMissionValidation,
  CancelConfirmFareValidation: () => CancelConfirmFareValidation,
  CancelJourneyValidation: () => CancelJourneyValidation,
  CancelPerformerRequestAcceptationValidation: () => CancelPerformerRequestAcceptationValidation,
  CancelReservationValidation: () => CancelReservationValidation,
  ClearAnomalyValidation: () => ClearAnomalyValidation,
  ClearThesaurusValidation: () => ClearThesaurusValidation,
  CloseMultipleBedsValidation: () => CloseMultipleBedsValidation,
  CommentCleaningMissionValidation: () => CommentCleaningMissionValidation,
  ConfirmFareValidation: () => ConfirmFareValidation,
  CreateAccommodationRequestValidation: () => CreateAccommodationRequestValidation,
  CreateAreaValidation: () => CreateAreaValidation,
  CreateBedBlockValidation: () => CreateBedBlockValidation,
  CreateBedClosingReasonValidation: () => CreateBedClosingReasonValidation,
  CreateBiocleaningValidation: () => CreateBiocleaningValidation,
  CreateBionetValidation: () => CreateBionetValidation,
  CreateCapacityPeriodValidation: () => CreateCapacityPeriodValidation,
  CreateDashboardValidation: () => CreateDashboardValidation,
  CreateDirectAdmission: () => CreateDirectAdmission,
  CreateDirectAdmissionValidation: () => CreateDirectAdmissionValidation,
  CreateDischargeDestinationValidation: () => CreateDischargeDestinationValidation,
  CreateExternalAuthUnitRuleValidation: () => CreateExternalAuthUnitRuleValidation,
  CreateExternalSessionValidation: () => CreateExternalSessionValidation,
  CreateExternalTransportValidation: () => CreateExternalTransportValidation,
  CreateFareValidation: () => CreateFareValidation,
  CreateGamExportValidation: () => CreateGamExportValidation,
  CreateHealthCenterValidation: () => CreateHealthCenterValidation,
  CreateIncidentValidation: () => CreateIncidentValidation,
  CreateInteropMessageValidation: () => CreateInteropMessageValidation,
  CreateJourneyStepValidation: () => CreateJourneyStepValidation,
  CreateJourneyValidation: () => CreateJourneyValidation,
  CreatePartialPatientValidation: () => CreatePartialPatientValidation,
  CreatePathDefaultTimeValidation: () => CreatePathDefaultTimeValidation,
  CreatePerformerRequestValidation: () => CreatePerformerRequestValidation,
  CreatePractitionerValidation: () => CreatePractitionerValidation,
  CreateReservationValidation: () => CreateReservationValidation,
  CreateServiceConfigValidation: () => CreateServiceConfigValidation,
  CreateSpecialtyValidation: () => CreateSpecialtyValidation,
  CreateSpecificityValidation: () => CreateSpecificityValidation,
  CreateThesaurusItemValidation: () => CreateThesaurusItemValidation,
  CreateUnitManualOccupancyValidation: () => CreateUnitManualOccupancyValidation,
  CreateUnitValidation: () => CreateUnitValidation,
  CreateUserProfileValidation: () => CreateUserProfileValidation,
  CreateUserValidation: () => CreateUserValidation,
  CreateViewValidation: () => CreateViewValidation,
  DashboardWidgetValidation: () => DashboardWidgetValidation,
  DeactivateOrganizationValidation: () => DeactivateOrganizationValidation,
  DeclareBedCleanValidation: () => DeclareBedCleanValidation,
  DeclareBedDirtyValidation: () => DeclareBedDirtyValidation,
  DeleteAreaValidation: () => DeleteAreaValidation,
  DeleteBedClosingReasonValidation: () => DeleteBedClosingReasonValidation,
  DeleteBedClosuresValidation: () => DeleteBedClosuresValidation,
  DeleteBiocleaningValidation: () => DeleteBiocleaningValidation,
  DeleteCareSectorValidation: () => DeleteCareSectorValidation,
  DeleteDashboardSlotValidation: () => DeleteDashboardSlotValidation,
  DeleteDashboardValidation: () => DeleteDashboardValidation,
  DeleteDischargeDestinationValidation: () => DeleteDischargeDestinationValidation,
  DeleteExternalAuthUnitRuleValidation: () => DeleteExternalAuthUnitRuleValidation,
  DeleteSpecialtyValidation: () => DeleteSpecialtyValidation,
  DeleteSpecificityValidation: () => DeleteSpecificityValidation,
  DeleteUserProfileValidation: () => DeleteUserProfileValidation,
  EditThesaurusItemValidation: () => EditThesaurusItemValidation,
  ExcludeOrganizationValidation: () => ExcludeOrganizationValidation,
  ExportAphpF00024CapacityHistoryValidation: () => ExportAphpF00024CapacityHistoryValidation,
  ExportAphpNp10000BedSituationValidation: () => ExportAphpNp10000BedSituationValidation,
  ExportDashboardsValidation: () => ExportDashboardsValidation,
  ExportUserProfilesValidation: () => ExportUserProfilesValidation,
  FareTickValidation: () => FareTickValidation,
  FindActiveAreaAvailabilityPeriodsValidation: () => FindActiveAreaAvailabilityPeriodsValidation,
  FindActiveAreasValidation: () => FindActiveAreasValidation,
  FindStructureNodesValidation: () => FindStructureNodesValidation,
  FinishCleaningMissionValidation: () => FinishCleaningMissionValidation,
  GetAnsOrganizationValidation: () => GetAnsOrganizationValidation,
  GetAnsPractitionersValidation: () => GetAnsPractitionersValidation,
  GetBedResourcesValidation: () => GetBedResourcesValidation,
  GetCapacityValidation: () => GetCapacityValidation,
  GetConfigValidation: () => GetConfigValidation,
  GetEncounterIsolationSpecificitiesValidation: () => GetEncounterIsolationSpecificitiesValidation,
  GetHealthCenterEmergencyOccupanciesValidation: () => GetHealthCenterEmergencyOccupanciesValidation,
  GetMetabaseDashboardValidation: () => GetMetabaseDashboardValidation,
  GetMetabasePatientTransportDashboardValidation: () => GetMetabasePatientTransportDashboardValidation,
  GetMetabaseQaDashboardValidation: () => GetMetabaseQaDashboardValidation,
  GetNightAndWeekendBedListValidation: () => GetNightAndWeekendBedListValidation,
  GetOidcLogoutRequestValidation: () => GetOidcLogoutRequestValidation,
  GetOverviewStatisticsValidation: () => GetOverviewStatisticsValidation,
  GetPatientContextualLinkValidation: () => GetPatientContextualLinkValidation,
  GetPatientsByNameValidation: () => GetPatientsByNameValidation,
  GetPortersValidation: () => GetPortersValidation,
  GetRegionStatisticsValidation: () => GetRegionStatisticsValidation,
  GetSamlLoginRequestValidation: () => GetSamlLoginRequestValidation,
  GetSamlLogoutRequestValidation: () => GetSamlLogoutRequestValidation,
  GetSpecialtyOccupanciesValidation: () => GetSpecialtyOccupanciesValidation,
  HandleHl7MessageValidation: () => HandleHl7MessageValidation,
  HandleOidcCallbackValidation: () => HandleOidcCallbackValidation,
  ImportAphpStructureValidation: () => ImportAphpStructureValidation,
  ImportDashboardsValidation: () => ImportDashboardsValidation,
  ImportStructureValidation: () => ImportStructureValidation,
  ImportThesaurusValidation: () => ImportThesaurusValidation,
  ImportUserProfilesValidation: () => ImportUserProfilesValidation,
  ImportUsersFileValidation: () => ImportUsersFileValidation,
  ImportUsersValidation: () => ImportUsersValidation,
  ImportVisitValidation: () => ImportVisitValidation,
  IncludeOrganizationValidation: () => IncludeOrganizationValidation,
  InitiateOidcLoginValidation: () => InitiateOidcLoginValidation,
  InterruptCleaningMissionValidation: () => InterruptCleaningMissionValidation,
  LinkExternalUserValidation: () => LinkExternalUserValidation,
  LogoutPorterValidation: () => LogoutPorterValidation,
  ManageViewsValidation: () => ManageViewsValidation,
  MoveAreaValidation: () => MoveAreaValidation,
  QueryDashboardQuestionValidation: () => QueryDashboardQuestionValidation,
  ReactivateOrganizationValidation: () => ReactivateOrganizationValidation,
  ReadAllNotificationsValidation: () => ReadAllNotificationsValidation,
  RefreshVisitValidation: () => RefreshVisitValidation,
  RejectPerformerRequestValidation: () => RejectPerformerRequestValidation,
  RemoveBedFromNightAndWeekendBedListValidation: () => RemoveBedFromNightAndWeekendBedListValidation,
  RemoveCapacityPeriodValidation: () => RemoveCapacityPeriodValidation,
  RemoveFareAssignationValidation: () => RemoveFareAssignationValidation,
  RemovePractitionerValidation: () => RemovePractitionerValidation,
  RemoveUnitManualOccupancyValidation: () => RemoveUnitManualOccupancyValidation,
  ReplayInteropMessageValidation: () => ReplayInteropMessageValidation,
  ReplayPatientInteropMessagesValidation: () => ReplayPatientInteropMessagesValidation,
  RequestCleaningValidation: () => RequestCleaningValidation,
  ResetPorterAfterLogoutValidation: () => ResetPorterAfterLogoutValidation,
  SaveWebhookLinkValidation: () => SaveWebhookLinkValidation,
  SearchPatientValidation: () => SearchPatientValidation,
  SetCleaningInstructionsValidation: () => SetCleaningInstructionsValidation,
  SetConfigVersionValidation: () => SetConfigVersionValidation,
  SetPorterUnitsValidation: () => SetPorterUnitsValidation,
  StartCleaningMissionValidation: () => StartCleaningMissionValidation,
  StepSchedulingValidation: () => StepSchedulingValidation,
  TakeBreakValidation: () => TakeBreakValidation,
  TestWebhookLinkValidation: () => TestWebhookLinkValidation,
  UnassignCleaningMissionValidation: () => UnassignCleaningMissionValidation,
  UnreadNotificationValidation: () => UnreadNotificationValidation,
  UpdateAccommodationRequestValidation: () => UpdateAccommodationRequestValidation,
  UpdateAreaAvailabilityPeriodsValidation: () => UpdateAreaAvailabilityPeriodsValidation,
  UpdateAreaValidation: () => UpdateAreaValidation,
  UpdateBedBlockValidation: () => UpdateBedBlockValidation,
  UpdateBedClosingReasonValidation: () => UpdateBedClosingReasonValidation,
  UpdateBiocleaningValidation: () => UpdateBiocleaningValidation,
  UpdateBionetValidation: () => UpdateBionetValidation,
  UpdateCapacityPeriodValidation: () => UpdateCapacityPeriodValidation,
  UpdateCareSectorValidation: () => UpdateCareSectorValidation,
  UpdateDashboardValidation: () => UpdateDashboardValidation,
  UpdateDischargeDestinationValidation: () => UpdateDischargeDestinationValidation,
  UpdateEmergencyOccupancyValidation: () => UpdateEmergencyOccupancyValidation,
  UpdateExternalAuthUnitRuleValidation: () => UpdateExternalAuthUnitRuleValidation,
  UpdateExternalTransportValidation: () => UpdateExternalTransportValidation,
  UpdateFareValidation: () => UpdateFareValidation,
  UpdateHealthCenterValidation: () => UpdateHealthCenterValidation,
  UpdateInstallationValidation: () => UpdateInstallationValidation,
  UpdateJourneyStepValidation: () => UpdateJourneyStepValidation,
  UpdateJourneyValidation: () => UpdateJourneyValidation,
  UpdateNightAndWeekendBedCommentValidation: () => UpdateNightAndWeekendBedCommentValidation,
  UpdateOccupancyValidation: () => UpdateOccupancyValidation,
  UpdateOrganizationsParentValidation: () => UpdateOrganizationsParentValidation,
  UpdateOrganizationsVisibilityValidation: () => UpdateOrganizationsVisibilityValidation,
  UpdatePractitionerValidation: () => UpdatePractitionerValidation,
  UpdateReservationValidation: () => UpdateReservationValidation,
  UpdateServiceConfigValidation: () => UpdateServiceConfigValidation,
  UpdateSpecialtyValidation: () => UpdateSpecialtyValidation,
  UpdateSpecificitiesValidation: () => UpdateSpecificitiesValidation,
  UpdateSpecificityValidation: () => UpdateSpecificityValidation,
  UpdateUnitManualOccupancyValidation: () => UpdateUnitManualOccupancyValidation,
  UpdateUnitValidation: () => UpdateUnitValidation,
  UpdateUserConfigValidation: () => UpdateUserConfigValidation,
  UpdateUserProfileValidation: () => UpdateUserProfileValidation,
  UpdateUserValidation: () => UpdateUserValidation,
  UpsertAccommodationValidation: () => UpsertAccommodationValidation,
  WebhookLinkValidation: () => WebhookLinkValidation,
  acceptPerformerRequest: () => acceptPerformerRequest,
  acknowledgeFareAssignation: () => acknowledgeFareAssignation_default,
  acknowledgeNotification: () => acknowledgeNotification_default,
  addBedsToNightAndWeekendBedList: () => addBedsToNightAndWeekendBedList,
  aphpStructureKinds: () => aphpStructureKinds,
  assignCleaningMission: () => assignCleaningMission,
  assignCleaningMissionRoute: () => assignCleaningMissionRoute,
  assignDashboardToSlot: () => assignDashboardToSlot,
  assignDashboardToSlotRoute: () => assignDashboardToSlotRoute,
  assignFare: () => assignFare_default,
  cancelAccommodation: () => cancelAccommodation,
  cancelAccommodationRequest: () => cancelAccommodationRequest,
  cancelAccommodationRequestRoute: () => cancelAccommodationRequestRoute,
  cancelBedBlock: () => cancelBedBlock,
  cancelBedBlockRoute: () => cancelBedBlockRoute,
  cancelBiocleaning: () => cancelBiocleaning,
  cancelBiocleaningRoute: () => cancelBiocleaningRoute,
  cancelCleaningMission: () => cancelCleaningMission,
  cancelCleaningMissionRoute: () => cancelCleaningMissionRoute,
  cancelConfirmFare: () => cancelConfirmFare_default,
  cancelFare: () => cancelFare,
  cancelJourney: () => cancelJourney,
  cancelPerformerRequestAcceptation: () => cancelPerformerRequestAcceptation,
  cancelReservation: () => cancelReservation,
  cancelReservationRoute: () => cancelReservationRoute,
  capacityAxes: () => capacityAxes,
  clearAnomaly: () => clearAnomaly_default,
  clearThesaurus: () => clearThesaurus,
  clearThesaurusRoute: () => clearThesaurusRoute,
  closeMultipleBeds: () => closeMultipleBeds_default,
  commentCleaningMission: () => commentCleaningMission,
  commentCleaningMissionRoute: () => commentCleaningMissionRoute,
  confirmFare: () => confirmFare_default,
  createAccommodationRequest: () => createAccommodationRequest,
  createArea: () => createArea_default,
  createBedBlock: () => createBedBlock,
  createBedBlockRoute: () => createBedBlockRoute,
  createBedClosingReason: () => createBedClosingReason,
  createBiocleaning: () => createBiocleaning,
  createBiocleaningRoute: () => createBiocleaningRoute,
  createBionet: () => createBionet,
  createBionetRoute: () => createBionetRoute,
  createCapacityPeriod: () => createCapacityPeriod,
  createCapacityPeriodRoute: () => createCapacityPeriodRoute,
  createCareSector: () => createCareSector,
  createCareSectorValidation: () => createCareSectorValidation,
  createDashboard: () => createDashboard,
  createDashboardRoute: () => createDashboardRoute,
  createDirectAdmissionRoute: () => createDirectAdmissionRoute,
  createDischargeDestination: () => createDischargeDestination,
  createDischargeDestinationRoute: () => createDischargeDestinationRoute,
  createExternalAuthUnitRule: () => createExternalAuthUnitRule,
  createExternalSession: () => createExternalSession,
  createExternalTransport: () => createExternalTransport,
  createFare: () => createFare_default,
  createGamExport: () => createGamExport_default,
  createHeathCenter: () => createHealthCenter_default,
  createIncident: () => createIncident_default,
  createInteropMessage: () => createInteropMessage,
  createJourney: () => createJourney,
  createPartialPatient: () => createPartialPatient,
  createPartialPatientRoute: () => createPartialPatientRoute,
  createPathDefaultTime: () => createPathDefaultTime_default,
  createPerformerRequest: () => createPerformerRequest,
  createPractitioner: () => createPractitioner,
  createPractitionerRoute: () => createPractitionerRoute,
  createReservation: () => createReservation,
  createReservationRoute: () => createReservationRoute,
  createServiceConfig: () => createServiceConfig,
  createServiceConfigRoute: () => createServiceConfigRoute,
  createSpecialty: () => createSpecialty,
  createSpecificity: () => createSpecificity,
  createThesaurusItem: () => createThesaurusItem,
  createThesaurusItemRoute: () => createThesaurusItemRoute,
  createUnit: () => createUnit,
  createUnitManualOccupancy: () => createUnitManualOccupancy,
  createUser: () => createUser_default,
  createUserProfile: () => createUserProfile,
  createView: () => createView,
  createViewRoute: () => createViewRoute,
  deactivateOrganization: () => deactivateOrganization,
  deactivateOrganizationRoute: () => deactivateOrganizationRoute,
  declareBedClean: () => declareBedClean,
  declareBedCleanRoute: () => declareBedCleanRoute,
  declareBedDirty: () => declareBedDirty,
  declareBedDirtyRoute: () => declareBedDirtyRoute,
  deleteArea: () => deleteArea_default,
  deleteBedClosingReason: () => deleteBedClosingReason,
  deleteBedClosures: () => deleteBedClosures,
  deleteBedClosuresRoute: () => deleteBedClosuresRoute,
  deleteBiocleaning: () => deleteBiocleaning,
  deleteBiocleaningRoute: () => deleteBiocleaningRoute,
  deleteCareSector: () => deleteCareSector,
  deleteDashboard: () => deleteDashboard,
  deleteDashboardRoute: () => deleteDashboardRoute,
  deleteDashboardSlot: () => deleteDashboardSlot,
  deleteDashboardSlotRoute: () => deleteDashboardSlotRoute,
  deleteDischargeDestination: () => deleteDischargeDestination,
  deleteDischargeDestinationRoute: () => deleteDischargeDestinationRoute,
  deleteExternalAuthUnitRule: () => deleteExternalAuthUnitRule,
  deleteSpecialty: () => deleteSpecialty,
  deleteSpecificity: () => deleteSpecificity,
  deleteUserProfile: () => deleteUserProfile,
  dispatchFare: () => dispatchFare_default,
  editThesaurusItem: () => editThesaurusItem,
  editThesaurusItemRoute: () => editThesaurusItemRoute,
  excludeOrganization: () => excludeOrganization,
  excludeOrganizationRoute: () => excludeOrganizationRoute,
  exportAphpF00024CapacityHistory: () => exportAphpF00024CapacityHistory,
  exportAphpF00024CapacityHistoryRoute: () => exportAphpF00024CapacityHistoryRoute,
  exportAphpNp10000BedSituation: () => exportAphpNp10000BedSituation,
  exportAphpNp10000BedSituationRoute: () => exportAphpNp10000BedSituationRoute,
  exportDashboards: () => exportDashboards,
  exportDashboardsRoute: () => exportDashboardsRoute,
  exportUserProfiles: () => exportUserProfiles,
  exportUserProfilesRoute: () => exportUserProfilesRoute,
  externalTransportStatus: () => externalTransportStatus,
  fareTick: () => fareTick,
  findActiveAreaAvailabilityPeriods: () => findActiveAreaAvailabilityPeriods,
  findActiveAreaAvailabilityPeriodsRoute: () => findActiveAreaAvailabilityPeriodsRoute,
  findActiveAreas: () => findActiveAreas,
  findActiveAreasRoute: () => findActiveAreasRoute,
  findStructureNodes: () => findStructureNodes,
  findStructureNodesRoute: () => findStructureNodesRoute,
  finishCleaningMission: () => finishCleaningMission,
  finishCleaningMissionRoute: () => finishCleaningMissionRoute,
  getAnsOrganizations: () => getAnsOrganizations,
  getAnsPractitioners: () => getAnsPractitioners,
  getBedResources: () => getBedResources,
  getBedResourcesRoute: () => getBedResourcesRoute,
  getCapacity: () => getCapacity,
  getCapacityRoute: () => getCapacityRoute,
  getConfig: () => getConfig,
  getEncounterIsolationSpecificities: () => getEncounterIsolationSpecificities,
  getEncounterIsolationSpecificitiesRoute: () => getEncounterIsolationSpecificitiesRoute,
  getHealthCenterEmergencyOccupancies: () => getHealthCenterEmergencyOccupancies_default,
  getHealthCenterGroups: () => getHealthCenterGroups_default,
  getMetabaseDashboard: () => getMetabaseDashboard,
  getMetabaseDashboardRoute: () => getMetabaseDashboardRoute,
  getMetabasePatientTransportDashboard: () => getMetabasePatientTransportDashboard,
  getMetabasePatientTransportDashboardRoute: () => getMetabasePatientTransportDashboardRoute,
  getMetabaseQaDashboard: () => getMetabaseQaDashboard,
  getMetabaseQaDashboardRoute: () => getMetabaseQaDashboardRoute,
  getNightAndWeekendBedList: () => getNightAndWeekendBedList,
  getOidcLogoutRequest: () => getOidcLogoutRequest,
  getOverviewStatistics: () => getOverviewStatistics_default,
  getPatientContextualLink: () => getPatientContextualLink,
  getPatientsByName: () => getPatientsByName_default,
  getPorterDailyFares: () => getPorterDailyFares,
  getPorters: () => getPorters_default,
  getRegionStatistics: () => getRegionStatistics,
  getSamlLoginRequest: () => getSamlLoginRequest,
  getSamlLogoutRequest: () => getSamlLogoutRequest,
  getSpecialtyOccupancies: () => getSpecialtyOccupancies,
  getWebhookLink: () => getWebhookLink,
  getWebhookLinkRoute: () => getWebhookLinkRoute,
  handleHl7Message: () => handleHl7Message,
  handleOidcCallback: () => handleOidcCallback,
  importAphpStructure: () => importAphpStructure,
  importAphpStructureRoute: () => importAphpStructureRoute,
  importDashboards: () => importDashboards,
  importDashboardsRoute: () => importDashboardsRoute,
  importStructure: () => importStructure_default,
  importThesaurus: () => importThesaurus,
  importThesaurusRoute: () => importThesaurusRoute,
  importUserProfiles: () => importUserProfiles,
  importUserProfilesRoute: () => importUserProfilesRoute,
  importUsers: () => importUsers,
  importUsersFile: () => importUsersFile,
  importUsersFileRoute: () => importUsersFileRoute,
  importUsersRoute: () => importUsersRoute,
  importVisit: () => importVisit_default,
  includeOrganization: () => includeOrganization,
  includeOrganizationRoute: () => includeOrganizationRoute,
  initiateOidcLogin: () => initiateOidcLogin,
  interruptCleaningMission: () => interruptCleaningMission,
  interruptCleaningMissionRoute: () => interruptCleaningMissionRoute,
  leaveBreak: () => leaveBreak_default,
  legacyCleaningStatuses: () => legacyCleaningStatuses,
  linkExternalUser: () => linkExternalUser_default,
  logoutPorter: () => logoutPorter_default,
  manageViews: () => manageViews,
  manageViewsRoute: () => manageViewsRoute,
  moveArea: () => moveArea_default,
  queryDashboardQuestion: () => queryDashboardQuestion,
  queryDashboardQuestionRoute: () => queryDashboardQuestionRoute,
  reactivateOrganization: () => reactivateOrganization,
  reactivateOrganizationRoute: () => reactivateOrganizationRoute,
  readAllNotifications: () => readAllNotifications_default,
  refreshVisit: () => refreshVisit_default,
  rejectPerformerRequest: () => rejectPerformerRequest,
  removeBedFromNightAndWeekendBedList: () => removeBedFromNightAndWeekendBedList,
  removeCapacityPeriod: () => removeCapacityPeriod,
  removeCapacityPeriodRoute: () => removeCapacityPeriodRoute,
  removeFareAssignation: () => removeFareAssignation_default,
  removePractitioner: () => removePractitioner,
  removePractitionerRoute: () => removePractitionerRoute,
  removeUnitManualOccupancy: () => removeUnitManualOccupancy,
  removeWebhookLink: () => removeWebhookLink,
  removeWebhookLinkRoute: () => removeWebhookLinkRoute,
  replayInteropMessage: () => replayInteropMessage_default,
  replayPatientInteropMessages: () => replayPatientInteropMessages_default,
  reportTypes: () => reportTypes,
  requestCleaning: () => requestCleaning,
  requestCleaningRoute: () => requestCleaningRoute,
  resetPorterAfterLogout: () => resetPorterAfterLogout_default,
  saveWebhookLink: () => saveWebhookLink,
  saveWebhookLinkRoute: () => saveWebhookLinkRoute,
  searchPatient: () => searchPatient,
  setCleaningInstructions: () => setCleaningInstructions,
  setCleaningInstructionsRoute: () => setCleaningInstructionsRoute,
  setConfigVersion: () => setConfigVersion_default,
  setPorterUnits: () => setPorterUnits_default,
  startCleaningMission: () => startCleaningMission,
  startCleaningMissionRoute: () => startCleaningMissionRoute,
  stepScheduling: () => stepScheduling,
  structureAxes: () => structureAxes,
  takeBreak: () => takeBreak_default,
  testWebhookLink: () => testWebhookLink,
  testWebhookLinkRoute: () => testWebhookLinkRoute,
  toggleAutodispatch: () => toggleAutodispatch_default,
  unassignCleaningMission: () => unassignCleaningMission,
  unassignCleaningMissionRoute: () => unassignCleaningMissionRoute,
  unreadNotification: () => unreadNotification_default,
  updateAccommodationRequest: () => updateAccommodationRequest,
  updateArea: () => updateArea_default,
  updateAreaAvailabilityPeriods: () => updateAreaAvailabilityPeriods_default,
  updateBedBlock: () => updateBedBlock,
  updateBedBlockRoute: () => updateBedBlockRoute,
  updateBedClosingReason: () => updateBedClosingReason,
  updateBiocleaning: () => updateBiocleaning,
  updateBiocleaningRoute: () => updateBiocleaningRoute,
  updateBionet: () => updateBionet,
  updateBionetRoute: () => updateBionetRoute,
  updateCapacityPeriod: () => updateCapacityPeriod,
  updateCapacityPeriodRoute: () => updateCapacityPeriodRoute,
  updateCareSector: () => updateCareSector,
  updateDashboard: () => updateDashboard,
  updateDashboardRoute: () => updateDashboardRoute,
  updateDischargeDestination: () => updateDischargeDestination,
  updateDischargeDestinationRoute: () => updateDischargeDestinationRoute,
  updateEmergencyOccupancy: () => updateEmergencyOccupancy_default,
  updateExternalAuthUnitRule: () => updateExternalAuthUnitRule,
  updateExternalTransport: () => updateExternalTransport,
  updateFare: () => updateFare_default,
  updateHealthCenter: () => updateHealthCenter_default,
  updateInstallation: () => updateInstallation_default,
  updateJourney: () => updateJourney,
  updateNightAndWeekendBedComment: () => updateNightAndWeekendBedComment,
  updateOccupancy: () => updateOccupancy,
  updateOccupancyRoute: () => updateOccupancyRoute,
  updateOrganizationsParent: () => updateOrganizationsParent,
  updateOrganizationsParentRoute: () => updateOrganizationsParentRoute,
  updateOrganizationsVisibility: () => updateOrganizationsVisibility,
  updateOrganizationsVisibilityRoute: () => updateOrganizationsVisibilityRoute,
  updatePractitioner: () => updatePractitioner,
  updatePractitionerRoute: () => updatePractitionerRoute,
  updateReservation: () => updateReservation,
  updateReservationRoute: () => updateReservationRoute,
  updateServiceConfig: () => updateServiceConfig,
  updateServiceConfigRoute: () => updateServiceConfigRoute,
  updateSpecialty: () => updateSpecialty,
  updateSpecificities: () => updateSpecificities,
  updateSpecificitiesRoute: () => updateSpecificitiesRoute,
  updateSpecificity: () => updateSpecificity,
  updateUnit: () => updateUnit,
  updateUnitManualOccupancy: () => updateUnitManualOccupancy,
  updateUser: () => updateUser_default,
  updateUserConfig: () => updateUserConfig,
  updateUserProfile: () => updateUserProfile,
  updateVisit: () => updateVisit_default,
  updateVisitValidation: () => updateVisitValidation,
  upsertAccommodation: () => upsertAccommodation,
  userTick: () => userTick_default
});

// src/cloud/api/createExternalSession.ts
import * as Yup from "yup";

// src/parse-instance.browser.ts
import * as ParseModule from "parse";
var Api = ParseModule.default ?? ParseModule;
var RESTController = Api.CoreManager.getRESTController();
RESTController.handleError = (response) => {
  if (response && typeof response === "object" && !("responseText" in response)) {
    return Promise.reject({ ...response });
  }
  let error;
  if (response && response.responseText) {
    try {
      error = JSON.parse(response.responseText);
    } catch (e) {
      error = "Received an error with invalid JSON from Parse";
    }
  } else {
    error = "XMLHttpRequest failed";
  }
  return Promise.reject({ ...error, statusCode: response.status });
};
Api.CoreManager.setRESTController(RESTController);
Api.Object.disableSingleInstance();
var parse_instance_browser_default = Api;

// src/cloud/api/createExternalSession.ts
var CreateExternalSessionValidation = Yup.object({
  healthCenterId: Yup.string().required()
});
var createExternalSession = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-external-session",
  params,
  options
);

// src/models/Specificity/AccommodationSpecificity.ts
var isolatedSpecificities = [
  "ISOLATED",
  // Deprecated Not available anymore
  "ISOLATED_AIR",
  "ISOLATED_CONTACT",
  "ISOLATED_DROPLET",
  "ISOLATED_PROTECTOR"
];
var accommodationSpecificities = [
  ...["COVID", ...isolatedSpecificities, "ACCOMMODATED", "WAITING_FOR_DOWNSTREAM_BED", "PRIVATE_ROOM"]
];

// src/models/Specificity/SpecificityQuickAccess.ts
var specificityQuickAccessFormTypes = ["hospitalization", "mutation", "directAdmission"];
var quickAccessSpecificityTypes = ["accommodation", "request"];
var supportsQuickAccess = (type) => quickAccessSpecificityTypes.includes(type);

// src/models/ParseClass.ts
var ParseClass = class extends parse_instance_browser_default.Object {
  constructor(className, attributes) {
    super(className, attributes);
  }
  Get(attr) {
    return this.get(attr);
  }
  Set(attr, val) {
    if (val === void 0) {
      return this.unset(attr);
    }
    return this.set(attr, val);
  }
  Unset(attr) {
    return this.unset(attr);
  }
};
var ParseUser = class extends parse_instance_browser_default.User {
  constructor(attributes) {
    super(attributes);
  }
  Get(attr) {
    return this.get(attr);
  }
  Set(attr, val) {
    if (val === void 0) {
      return this.unset(attr);
    }
    return this.set(attr, val);
  }
  Unset(attr) {
    return this.unset(attr);
  }
};

// src/models/Specificity/Specificity.ts
var Specificity = class extends ParseClass {
  constructor(attributes) {
    super("Specificity", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get icon() {
    return this.Get("icon");
  }
  set icon(val) {
    this.Set("icon", val);
  }
  get color() {
    return this.Get("color");
  }
  set color(val) {
    this.Set("color", val);
  }
  get description() {
    return this.Get("description");
  }
  set description(val) {
    this.Set("description", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get externalHl7Identifiers() {
    return this.Get("externalHl7Identifiers");
  }
  set externalHl7Identifiers(val) {
    this.Set("externalHl7Identifiers", val);
  }
  get isIsolation() {
    return this.Get("isIsolation");
  }
  set isIsolation(val) {
    this.Set("isIsolation", val);
  }
  get showInUnitStats() {
    return this.Get("showInUnitStats");
  }
  set showInUnitStats(val) {
    this.Set("showInUnitStats", val);
  }
  get showInHealthCenterStats() {
    return this.Get("showInHealthCenterStats");
  }
  set showInHealthCenterStats(val) {
    this.Set("showInHealthCenterStats", val);
  }
  get isPrivateRoom() {
    return this.Get("isPrivateRoom");
  }
  set isPrivateRoom(val) {
    this.Set("isPrivateRoom", val);
  }
  get quickAccess() {
    return this.Get("quickAccess");
  }
  set quickAccess(val) {
    this.Set("quickAccess", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Specificity", Specificity);

// src/models/Specificity/SpecificityObject.ts
var convertToSpecificityObject = (specificity) => ({
  id: specificity.id,
  name: specificity.name,
  color: specificity.color,
  // `quickAccess` reste volontairement absent : config admin, à ne pas figer dans les demandes.
  ...specificity.type != null ? { type: specificity.type } : {},
  ...specificity.icon != null ? { icon: specificity.icon } : {},
  ...specificity.description != null ? { description: specificity.description } : {},
  ...specificity.isIsolation != null ? { isIsolation: specificity.isIsolation } : {},
  ...specificity.isPrivateRoom != null ? { isPrivateRoom: specificity.isPrivateRoom } : {}
});

// src/models/Specificity/SpecificityType.ts
var specificityTypes = ["accommodation", "fare", "area", "request"];

// src/utils/specificity/specificity.utils.ts
var specificitiesOrder = {
  COVID: 1,
  ISOLATED: 2,
  ISOLATED_AIR: 3,
  ISOLATED_CONTACT: 4,
  ISOLATED_DROPLET: 5,
  ISOLATED_PROTECTOR: 6,
  ACCOMMODATED: 7,
  WAITING_FOR_DOWNSTREAM_BED: 8,
  PRIVATE_ROOM: 9
};
var nativeSpecificitiesSorter = (a, b) => specificitiesOrder[a] - specificitiesOrder[b];
var isCustomSpecificity = (specificity) => typeof specificity === "object" && "id" in specificity;
var isNativeSpecificity = (specificity) => typeof specificity === "string" && accommodationSpecificities.includes(specificity);
var isIsolatedSpecificity = (specificity) => {
  if (isNativeSpecificity(specificity)) {
    return isolatedSpecificities.includes(specificity);
  }
  return !!specificity.isIsolation;
};
var isPrivateRoomSpecificity = (specificity) => {
  if (isNativeSpecificity(specificity)) {
    return specificity === "PRIVATE_ROOM";
  }
  return !!specificity.isPrivateRoom;
};
var getSpecificityCategory = (specificity) => {
  if (isIsolatedSpecificity(specificity)) {
    return "isolation";
  }
  if (isPrivateRoomSpecificity(specificity)) {
    return "privateRoom";
  }
  return "standard";
};
var categoryOrder = {
  isolation: 0,
  privateRoom: 1,
  standard: 2
};
var getSpecificityName = (specificity) => {
  if (isNativeSpecificity(specificity)) {
    return specificity;
  }
  return specificity.name;
};
var compareSpecificities = (a, b) => {
  const groupA = categoryOrder[getSpecificityCategory(a)];
  const groupB = categoryOrder[getSpecificityCategory(b)];
  if (groupA !== groupB) {
    return groupA - groupB;
  }
  return getSpecificityName(a).localeCompare(getSpecificityName(b));
};
var sortSpecificities = (specificities = []) => {
  return specificities.slice().sort(compareSpecificities);
};
var isFilteredBySpecificities = (specificitiesFilter, specificities, customSpecificities) => {
  return specificitiesFilter.some(
    (specificity) => isNativeSpecificity(specificity) && specificities?.includes(specificity) || customSpecificities?.map((spec) => spec.id).includes(specificity)
  );
};
var excludeRequestScoped = (specificities = []) => specificities.filter((specificity) => specificity.type !== "request");
var partitionByScope = (specificities = []) => {
  const byName = (a, b) => a.name.localeCompare(b.name);
  return {
    accommodation: specificities.filter((specificity) => specificity.type !== "request").sort(byName),
    request: specificities.filter((specificity) => specificity.type === "request").sort(byName)
  };
};
var sortByQuickAccess = (specificities = [], formType) => specificities.filter((specificity) => specificity.quickAccess?.[formType] !== void 0).slice().sort((a, b) => {
  const indexA = a.quickAccess?.[formType]?.index;
  const indexB = b.quickAccess?.[formType]?.index;
  if (indexA != null && indexB != null) {
    return indexA - indexB || a.name.localeCompare(b.name);
  }
  if (indexA != null) {
    return -1;
  }
  if (indexB != null) {
    return 1;
  }
  return a.name.localeCompare(b.name);
});
var categories = ["isolation", "privateRoom", "standard"];
var groupSpecificities = (specificities) => {
  return categories.map((category) => ({
    category,
    specificities: sortSpecificities(specificities.filter((s) => getSpecificityCategory(s) === category))
  })).filter((group) => group.specificities.length > 0);
};
var SpecificityUtils = {
  sort: sortSpecificities,
  nativeSpecificitiesSorter,
  isCustomSpecificity,
  isNativeSpecificity,
  isFilteredBySpecificities,
  isIsolatedSpecificity,
  isPrivateRoomSpecificity,
  getSpecificityCategory,
  groupSpecificities,
  excludeRequestScoped,
  partitionByScope,
  sortByQuickAccess
};

// src/utils/date.utils.ts
function subMonths(date46, amount) {
  date46.setMonth(date46.getMonth() - amount);
  return date46;
}
function addMonths(date46, amount) {
  date46.setMonth(date46.getMonth() + amount);
  return date46;
}
var maxDate = /* @__PURE__ */ new Date(41023584e5);
var minDate = /* @__PURE__ */ new Date(0);
var isWithoutEnd = (endAt) => !endAt || endAt.getTime() >= maxDate.getTime();
var DEFAULT_HEALTH_CENTER_TIMEZONE = "Europe/Paris";

// src/models/Accommodation/Accommodation.ts
var Accommodation = class extends ParseClass {
  constructor(attributes) {
    super("Accommodation", attributes);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get specificities() {
    return this.Get("specificities")?.sort(SpecificityUtils.nativeSpecificitiesSorter);
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get customSpecificities() {
    return this.Get("customSpecificities")?.sort((a, b) => a.name.localeCompare(b.name));
  }
  set customSpecificities(val) {
    this.Set("customSpecificities", val);
  }
  get isEstimatedEnd() {
    return this.Get("isEstimatedEnd");
  }
  set isEstimatedEnd(val) {
    this.Set("isEstimatedEnd", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get bedClosingExternalId() {
    return this.Get("bedClosingExternalId");
  }
  set bedClosingExternalId(val) {
    this.Set("bedClosingExternalId", val);
  }
  get bed() {
    return this.Get("bed");
  }
  set bed(val) {
    this.Set("bed", val);
  }
  get bedHistory() {
    return this.Get("bedHistory");
  }
  set bedHistory(val) {
    this.Set("bedHistory", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get responsibleUnit() {
    return this.Get("responsibleUnit");
  }
  set responsibleUnit(val) {
    this.Set("responsibleUnit", val);
  }
  get responsibleNursingUnit() {
    return this.Get("responsibleNursingUnit");
  }
  set responsibleNursingUnit(val) {
    this.Set("responsibleNursingUnit", val);
  }
  get isAccommodated() {
    return this.Get("isAccommodated");
  }
  set isAccommodated(val) {
    this.Set("isAccommodated", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get basedOn() {
    return this.Get("basedOn");
  }
  set basedOn(val) {
    this.Set("basedOn", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    const endAt = this.Get("endAt");
    if (endAt && endAt.getTime() >= maxDate.getTime()) {
      return void 0;
    }
    return endAt;
  }
  set endAt(val) {
    this.Set("endAt", val || maxDate);
  }
  get thesaurusComputedEndAt() {
    return this.Get("thesaurusComputedEndAt");
  }
  set thesaurusComputedEndAt(val) {
    this.Set("thesaurusComputedEndAt", val);
  }
  get startAtHistory() {
    return this.Get("startAtHistory");
  }
  set startAtHistory(val) {
    this.Set("startAtHistory", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get practitioners() {
    return this.Get("practitioners");
  }
  set practitioners(val) {
    this.Set("practitioners", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get bedClosingReason() {
    return this.Get("bedClosingReason");
  }
  set bedClosingReason(val) {
    this.Set("bedClosingReason", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get endAtHistory() {
    return this.Get("endAtHistory");
  }
  set endAtHistory(val) {
    this.Set("endAtHistory", val);
  }
  get targetAccommodation() {
    return this.Get("targetAccommodation");
  }
  set targetAccommodation(val) {
    this.Set("targetAccommodation", val);
  }
  get origin() {
    return this.Get("origin");
  }
  set origin(val) {
    this.Set("origin", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Accommodation", Accommodation);
var occupiesNoInstant = (accommodation) => !!accommodation?.startAt && !!accommodation.endAt && accommodation.startAt.getTime() >= accommodation.endAt.getTime();

// src/models/Accommodation/BedBlock.ts
var BedBlock = class extends Accommodation {
  constructor(params) {
    super();
    this.type = "BED_BLOCK";
    this.status = "COMPLETED";
    this.isEstimatedEnd = false;
    if (params?.bed !== void 0) {
      this.bed = params?.bed;
    }
    if (params?.healthCenter !== void 0) {
      this.healthCenter = params?.healthCenter;
    }
    if (params?.unit !== void 0) {
      this.unit = params?.unit;
    }
    if (params?.startAt !== void 0) {
      this.startAt = params?.startAt;
    }
    if (params?.endAt !== void 0) {
      this.endAt = params?.endAt;
    }
    if (params?.comment !== void 0) {
      this.comment = params?.comment;
    }
    if (params?.customSpecificities !== void 0) {
      this.customSpecificities = params?.customSpecificities;
    }
    if (params?.reason !== void 0) {
      this.reason = params?.reason;
    }
  }
};
var isBedBlock = (accommodation) => accommodation.type === "BED_BLOCK";

// src/models/Accommodation/AccommodationStatus.ts
var accommodationStatus = [...["PLANNED", "CANCELLED", "IN_PROGRESS", "COMPLETED"]];

// src/models/Accommodation/AccommodationType.ts
var ACCOMMODATION_TYPES = [
  "ACCOMMODATION",
  "BED_CLOSURE",
  "BED_BLOCK",
  "LEAVE_OF_ABSENCE",
  "RESERVATION"
];

// src/models/Accommodation/Reservation.ts
var Reservation = class extends Accommodation {
  constructor(params) {
    super({ ...params, type: "RESERVATION", status: "PLANNED", isEstimatedEnd: false });
  }
};
var isReservation = (accommodation) => accommodation.type === "RESERVATION";
var isSystemReservation = (accommodation) => accommodation?.type === "RESERVATION" && (accommodation.origin === "INTEROP" || accommodation.origin === "DELAY");
var isEmptyReservation = (accommodation) => accommodation?.type === "RESERVATION" && occupiesNoInstant(accommodation);

// src/models/AccommodationHistory.ts
var AccommodationHistory = class extends ParseClass {
  constructor(attributes) {
    super("AccommodationHistory", attributes);
  }
  get accommodation() {
    return this.Get("accommodation");
  }
  set accommodation(val) {
    this.Set("accommodation", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get origin() {
    return this.Get("origin");
  }
  set origin(val) {
    this.Set("origin", val);
  }
  get specificities() {
    return this.Get("specificities")?.sort(SpecificityUtils.nativeSpecificitiesSorter);
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get customSpecificities() {
    return this.Get("customSpecificities")?.sort((a, b) => a.name.localeCompare(b.name));
  }
  set customSpecificities(val) {
    this.Set("customSpecificities", val);
  }
  get isEstimatedEnd() {
    return this.Get("isEstimatedEnd");
  }
  set isEstimatedEnd(val) {
    this.Set("isEstimatedEnd", val);
  }
  get bed() {
    return this.Get("bed");
  }
  set bed(val) {
    this.Set("bed", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get responsibleUnit() {
    return this.Get("responsibleUnit");
  }
  set responsibleUnit(val) {
    this.Set("responsibleUnit", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get thesaurusItem() {
    return this.Get("thesaurusItem");
  }
  set thesaurusItem(val) {
    this.Set("thesaurusItem", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get thesaurusComputedEndAt() {
    return this.Get("thesaurusComputedEndAt");
  }
  set thesaurusComputedEndAt(val) {
    this.Set("thesaurusComputedEndAt", val);
  }
  get practitioners() {
    return this.Get("practitioners");
  }
  set practitioners(val) {
    this.Set("practitioners", val);
  }
  get bedClosingReason() {
    return this.Get("bedClosingReason");
  }
  set bedClosingReason(val) {
    this.Set("bedClosingReason", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("AccommodationHistory", AccommodationHistory);

// src/models/AccommodationRequest/AccommodationRequest.ts
var AccommodationRequest = class extends ParseClass {
  constructor(attributes) {
    super("AccommodationRequest", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get statusRank() {
    return this.Get("statusRank");
  }
  set statusRank(val) {
    this.Set("statusRank", val);
  }
  get performerRequests() {
    return this.Get("performerRequests");
  }
  set performerRequests(val) {
    this.Set("performerRequests", val);
  }
  get specificities() {
    return this.Get("specificities");
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get customSpecificities() {
    return this.Get("customSpecificities")?.sort((a, b) => a.name.localeCompare(b.name));
  }
  set customSpecificities(val) {
    this.Set("customSpecificities", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get requestType() {
    return this.Get("requestType");
  }
  set requestType(val) {
    this.Set("requestType", val);
  }
  get directAdmissionOrigin() {
    return this.Get("directAdmissionOrigin");
  }
  set directAdmissionOrigin(val) {
    this.Set("directAdmissionOrigin", val);
  }
  get originAccommodation() {
    return this.Get("originAccommodation");
  }
  set originAccommodation(val) {
    this.Set("originAccommodation", val);
  }
  get occurrenceDate() {
    return this.Get("occurrenceDate");
  }
  set occurrenceDate(val) {
    this.Set("occurrenceDate", val);
  }
  get destinationUnit() {
    return this.Get("destinationUnit");
  }
  set destinationUnit(val) {
    this.Set("destinationUnit", val);
  }
  get destinationStartDate() {
    return this.Get("destinationStartDate");
  }
  set destinationStartDate(val) {
    this.Set("destinationStartDate", val);
  }
  get destinationStartDateHistory() {
    return this.Get("destinationStartDateHistory");
  }
  set destinationStartDateHistory(val) {
    this.Set("destinationStartDateHistory", val);
  }
  get destinationBed() {
    return this.Get("destinationBed");
  }
  set destinationBed(val) {
    this.Set("destinationBed", val);
  }
  get originUnit() {
    return this.Get("originUnit");
  }
  set originUnit(val) {
    this.Set("originUnit", val);
  }
  get orientation() {
    return this.Get("orientation");
  }
  set orientation(val) {
    this.Set("orientation", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get visitDischargedAt() {
    return this.Get("visitDischargedAt");
  }
  set visitDischargedAt(val) {
    this.Set("visitDischargedAt", val);
  }
  get canceledAt() {
    return this.Get("canceledAt");
  }
  set canceledAt(val) {
    this.Set("canceledAt", val);
  }
  get canceledBy() {
    return this.Get("canceledBy");
  }
  set canceledBy(val) {
    this.Set("canceledBy", val);
  }
  get canceledFrom() {
    return this.Get("canceledFrom");
  }
  set canceledFrom(val) {
    this.Set("canceledFrom", val);
  }
  get endCause() {
    return this.Get("endCause");
  }
  set endCause(val) {
    this.Set("endCause", val);
  }
  get completedAt() {
    return this.Get("completedAt");
  }
  set completedAt(val) {
    this.Set("completedAt", val);
  }
  get completedBy() {
    return this.Get("completedBy");
  }
  set completedBy(val) {
    this.Set("completedBy", val);
  }
  get carriedOverFrom() {
    return this.Get("carriedOverFrom");
  }
  set carriedOverFrom(val) {
    this.Set("carriedOverFrom", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("AccommodationRequest", AccommodationRequest);

// src/models/AccommodationRequest/AccommodationRequestType.ts
var ACCOMMODATION_REQUEST_TYPES = [
  "DIRECT_ADMISSION",
  "INTERNAL_MUTATION",
  "BED_MUTATION",
  "LEAVE_OF_ABSENCE",
  "RETURN_FROM_LEAVE_OF_ABSENCE"
];

// src/models/AccommodationRequest/RequestEndCause.ts
var REQUEST_END_CAUSES = ["ARRIVED_IN_REQUESTED_UNIT", "ARRIVED_IN_OTHER_UNIT"];

// src/models/AccommodationRequest/RequestStatus.ts
var REQUEST_STATUS_RANK = {
  TO_ROUTE: 0,
  REJECTED: 1,
  REQUESTED: 2,
  ACCEPTED: 3,
  VALIDATED: 4,
  COMPLETED: 5,
  REVOKED: 6,
  CANCELLED: 7
};

// src/models/Anomaly.ts
var anomalyType = [
  "OVERLAPPING_STEPS",
  "OUTDATED_PREVISIONAL_END",
  "OUTDATED_VALIDATED_END",
  "OUTDATED_START"
];
var anomalyStatus = ["OPENED", "RESOLVED"];
var Anomaly = class extends ParseClass {
  constructor(attributes) {
    super("Anomaly", attributes);
  }
  get area() {
    return this.Get("area");
  }
  set area(val) {
    this.Set("area", val);
  }
  get accommodation() {
    return this.Get("accommodation");
  }
  set accommodation(val) {
    this.Set("accommodation", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get linkedWith() {
    return this.Get("linkedWith");
  }
  set linkedWith(val) {
    this.Set("linkedWith", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Anomaly", Anomaly);

// src/models/Appointment/Appointment.ts
var Appointment = class extends ParseClass {
  constructor(attributes) {
    super("Appointment", attributes);
  }
  get start() {
    return this.Get("start");
  }
  set start(val) {
    this.Set("start", val);
  }
  get end() {
    return this.Get("end");
  }
  set end(val) {
    this.Set("end", val);
  }
  set externalIds(value) {
    this.Set("externalIds", value && value.length === 0 ? void 0 : value);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  get location() {
    return this.Get("location");
  }
  set location(value) {
    this.Set("location", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get ipp() {
    return this.Get("ipp");
  }
  set ipp(val) {
    this.Set("ipp", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Appointment", Appointment);

// src/models/Appointment/AppointmentStatus.ts
var appointmentStatus = ["PLANNED", "CANCELLED", "IN_PROGRESS", "COMPLETED", "NOSHOW"];

// src/models/Area/Area.ts
var externalTypeCodes = [
  /*
   * Codes Silbo (organisationnels)
   */
  "hospital",
  // Hôpital
  "unit",
  // Unité
  "service",
  // Service
  /*
   * Emplacement physique — FHIR location-physical-type (display)
   * https://terminology.hl7.org/en/CodeSystem-location-physical-type.html
   */
  "site",
  // Site
  "building",
  // Bâtiment
  "wing",
  // Secteur
  "level",
  // Étage
  "room",
  // Chambre
  "bed"
  // Lit
];
var availabilityPeriodStatus = ["ACTIVE", "INACTIVE"];
var Area = class extends ParseClass {
  constructor(attributes) {
    super("Area", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get parent() {
    return this.Get("parent");
  }
  set parent(val) {
    this.Set("parent", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get isSearchable() {
    return this.Get("isSearchable");
  }
  set isSearchable(val) {
    this.Set("isSearchable", val);
  }
  get children() {
    return this.Get("children");
  }
  set children(val) {
    this.Set("children", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get externalTypeCode() {
    return this.Get("externalTypeCode");
  }
  set externalTypeCode(val) {
    this.Set("externalTypeCode", val);
  }
  get nextSlotAt() {
    return this.Get("nextSlotAt");
  }
  set nextSlotAt(val) {
    this.Set("nextSlotAt", val);
  }
  get basedOn() {
    return this.Get("basedOn");
  }
  set basedOn(val) {
    this.Set("basedOn", val);
  }
  get excludedFromOccupancy() {
    return this.Get("excludedFromOccupancy");
  }
  set excludedFromOccupancy(val) {
    this.Set("excludedFromOccupancy", val);
  }
  get supernumerary() {
    return this.Get("supernumerary");
  }
  set supernumerary(val) {
    this.Set("supernumerary", val);
  }
  get careSector() {
    return this.Get("careSector");
  }
  set careSector(val) {
    this.Set("careSector", val);
  }
  get geoFiness() {
    return this.Get("geoFiness");
  }
  set geoFiness(val) {
    this.Set("geoFiness", val);
  }
  get managingOrganization() {
    return this.Get("managingOrganization");
  }
  set managingOrganization(val) {
    this.Set("managingOrganization", val);
  }
  get managingOrganizationAncestors() {
    return this.Get("managingOrganizationAncestors");
  }
  set managingOrganizationAncestors(val) {
    this.Set("managingOrganizationAncestors", val);
  }
  get specificities() {
    return this.Get("specificities");
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get ignoredAt() {
    return this.Get("ignoredAt");
  }
  set ignoredAt(val) {
    this.Set("ignoredAt", val);
  }
  get ignoredReasons() {
    return this.Get("ignoredReasons");
  }
  set ignoredReasons(val) {
    this.Set("ignoredReasons", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Area", Area);

// src/models/AreaAvailabilityPeriod/AreaAvailabilityPeriod.ts
var AreaAvailabilityPeriod = class extends ParseClass {
  constructor(attributes) {
    super("AreaAvailabilityPeriod", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get area() {
    return this.Get("area");
  }
  set area(val) {
    this.Set("area", val);
  }
  get start() {
    return this.Get("start");
  }
  set start(val) {
    this.Set("start", val);
  }
  get end() {
    return this.Get("end");
  }
  set end(val) {
    this.Set("end", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("AreaAvailabilityPeriod", AreaAvailabilityPeriod);

// src/models/AreaTree.ts
import hash from "object-hash";
var findAreaKeyWord = (a, wordList) => {
  const key = Object.keys(wordList).reduce(
    (savedWord, word) => a.name.toLowerCase().includes(word) ? wordList[word] < wordList[savedWord] ? word : savedWord : savedWord
  );
  return wordList[key];
};
var AreaTree = class {
  constructor(areas, units) {
    this.areas = areas;
    this.units = units || [];
    this.areaMap = {};
    this.root = void 0;
    this.selectedAreasHash = void 0;
    this.selectedAreas = [];
    this.recentChildren = [];
    this.areaIdUnitRecord = {};
    this.areaByExternalId = {};
    this.init(areas, units || []);
  }
  /**
   * Initialise l'arbre
   * @param areas
   */
  init(areas, units) {
    for (const area of areas) {
      this.areaMap[area.id] = area;
      if (!area.parent) {
        this.root = area;
      }
      for (const externalId of area.externalIds || []) {
        this.areaByExternalId[externalId] = area;
      }
    }
    for (const area of areas) {
      const currentArea = this.areaMap[area.id];
      if (area.parent && this.areaMap[area.parent.id]) {
        const parent = this.areaMap[area.parent.id];
        area.parent = parent;
        if (parent.children) {
          parent.children.push(currentArea);
        } else {
          parent.children = [currentArea];
        }
      }
    }
    for (const unit of units || []) {
      const unitAreas = unit.areas || [];
      const allChildren = [...this.getAllChildren(unitAreas.map((area) => area.id)), ...unitAreas];
      for (const area of allChildren) {
        this.areaIdUnitRecord[area.id] = unit;
      }
    }
  }
  /**
   * Retourne une unité à partir d'un area id
   * @param areaId
   * @returns Unit
   */
  getUnitFromAreaId(areaId) {
    return this.areaIdUnitRecord[areaId];
  }
  /**
   * Retourne une area à partir d'un externalId
   * @param externalId
   * @returns Area
   */
  getAreaByExternalId(externalId) {
    return this.areaByExternalId[externalId];
  }
  /**
   * Retourne un area à partir d'un id
   * @param id
   */
  getAreaById(id) {
    return this.areaMap[id];
  }
  /**
   * Retourne tous les enfants en flatMap d'une liste d'Area (non comprise)
   * @param areas
   */
  getAllChildren(areas) {
    if (!areas) {
      if (this.root) {
        const selectedAreas = [this.root];
        const selectedAreasHash = hash(selectedAreas.map((area) => area.id));
        if (selectedAreasHash === this.selectedAreasHash) {
          return this.recentChildren;
        } else {
          this.selectedAreasHash = selectedAreasHash;
          this.selectedAreas = selectedAreas;
        }
      } else {
        return [];
      }
    } else {
      const selectedAreas = [];
      for (const area of areas) {
        if (typeof area === "string") {
          const areaFromId = this.getAreaById(area);
          if (areaFromId) {
            selectedAreas.push(areaFromId);
          }
        } else {
          selectedAreas.push(area);
        }
      }
      const selectedAreasHash = hash(selectedAreas.map((area) => area.id));
      if (selectedAreasHash === this.selectedAreasHash) {
        return this.recentChildren;
      } else {
        this.selectedAreasHash = selectedAreasHash;
        this.selectedAreas = selectedAreas;
      }
    }
    const queue = [];
    for (const area of this.selectedAreas) {
      if (area.children) {
        queue.push(...area.children);
      }
    }
    const result = [];
    while (queue.length > 0) {
      const currentArea = queue.shift();
      if (!currentArea) {
        continue;
      }
      result.push(currentArea);
      if (currentArea.children) {
        queue.push(...currentArea.children);
      }
    }
    this.recentChildren = result;
    return this.recentChildren;
  }
  /**
   * Cette fonction retourne un tableau de chemin d'Area à partir d'un Area enfant.
   * Exemple si l'Area passé est un pousse-seringue localisé dans une chambre alors ça retournera
   * ["Chambre 2", "Lit 1", "Pousse-seringue"]
   * @param area Area[]
   * @returns Area[]
   */
  getBreadcrumb({ area, areaId }) {
    const currentArea = area || this.getAreaById(areaId || "");
    if (!currentArea) {
      return [];
    }
    if (currentArea.isSearchable) {
      return [currentArea];
    }
    const breadcrumb = [currentArea];
    while (!breadcrumb[0].isSearchable && breadcrumb[0].parent) {
      breadcrumb.unshift(breadcrumb[0].parent);
    }
    return breadcrumb;
  }
  /**
   * Cette fonction retourne toutes les paths possibles entre deux Area d'entrée
   * @param fromArea
   * @param toArea
   */
  getAllPaths(fromArea, toArea) {
    const localFromArea = this.getAreaById(fromArea.id);
    const localToArea = this.getAreaById(toArea.id);
    if (!localFromArea || !localToArea) {
      return [];
    }
    let fromBranchAreas = [];
    let toBranchAreas = [];
    let queue = [];
    queue.push({
      area: !localFromArea.children && localFromArea.parent ? localFromArea.parent : localFromArea,
      moves: 0,
      branch: "FROM"
    });
    queue.push({
      area: !localToArea.children && localToArea.parent ? localToArea.parent : localToArea,
      moves: 0,
      branch: "TO"
    });
    while (queue.length) {
      const current = queue.shift();
      if (!current) {
        continue;
      }
      const { area, moves, branch, direction } = current;
      let currentBranch = branch === "FROM" ? fromBranchAreas : toBranchAreas;
      let oppositeBranch = branch === "FROM" ? toBranchAreas : fromBranchAreas;
      if (!area) {
        continue;
      }
      if (!area.parent) {
        continue;
      }
      if (!area.children) {
        continue;
      }
      const commonArea = oppositeBranch.find((seenArea) => seenArea.area.id === area.id);
      if (commonArea) {
        if (branch === "FROM") {
          toBranchAreas = toBranchAreas.filter((seenArea) => seenArea.moves > commonArea.moves);
        } else {
          fromBranchAreas = fromBranchAreas.filter((seenArea) => seenArea.moves > commonArea.moves);
        }
        queue = queue.filter((queueObj) => queueObj.direction !== "UP");
        continue;
      }
      currentBranch.push({ area, moves });
      if (direction === "UP") {
        queue.push({ area: area.parent, moves: moves - 1, branch, direction: "UP" });
      } else if (direction === "DOWN") {
        queue.push(...area.children.map((area2) => ({ area: area2, moves: moves + 1, branch, direction: "DOWN" })));
      } else {
        queue.push({ area: area.parent, moves: moves - 1, branch, direction: "UP" });
        queue.push(...area.children.map((area2) => ({ area: area2, moves: moves + 1, branch, direction: "DOWN" })));
      }
    }
    return fromBranchAreas.reduce((acc, from) => {
      return [
        ...acc,
        ...toBranchAreas.map((to) => {
          return [from.area, to.area, Math.abs(from.moves) + Math.abs(to.moves)];
        })
      ];
    }, []);
  }
  // méthode pour un tri par ordre de fréquence des mots clés
  smartSort(query, limit = 20) {
    const lowerTextSearch = query.toLowerCase();
    const searchedAreas = [...this.recentChildren].filter((a) => a.name.toLowerCase().includes(lowerTextSearch));
    const lastWord = lowerTextSearch.match(/\b\w+\b/g)?.pop();
    if (!lastWord) {
      return [];
    }
    const regex = new RegExp(`${lowerTextSearch}[A-Za-z0-9_]*`, "g");
    const splitSearch = this.recentChildren.flatMap((area) => area.name.toLowerCase().match(regex));
    let words = {};
    for (const word of splitSearch) {
      if (word) {
        words[word] = words[word] ? words[word] + 1 : 1;
      }
    }
    const res = searchedAreas.sort((a, b) => {
      const bName = b.name.toLowerCase();
      const aName = a.name.toLowerCase();
      const bLastWord = bName.match(/\b\w+\b/g)?.pop();
      const aLastWord = aName.match(/\b\w+\b/g)?.pop();
      if (!aName.includes(lowerTextSearch) || bName === lowerTextSearch) {
        return 1;
      }
      if (!bName.includes(lowerTextSearch) || aName === lowerTextSearch) {
        return -1;
      }
      if (!aLastWord) {
        return 1;
      }
      if (!bLastWord) {
        return -1;
      }
      if (aLastWord === lastWord && bLastWord !== lastWord) {
        return -1;
      }
      if (bLastWord === lastWord && aLastWord !== lastWord) {
        return 1;
      }
      const na = findAreaKeyWord(a, words);
      const nb = findAreaKeyWord(b, words);
      return na - nb;
    });
    return res.slice(0, limit);
  }
  search(query, limit = 200) {
    const lowerTextSearch = query.toLowerCase();
    const searchedAreas = [...this.recentChildren].filter((a) => a.name.toLowerCase().includes(lowerTextSearch));
    const res = searchedAreas.sort((a, b) => {
      const aWords = a.name.split(" ");
      const bWords = b.name.split(" ");
      for (let i = 0; i < Math.min(aWords.length, bWords.length); i++) {
        const aWord = aWords[i];
        const bWord = bWords[i];
        const aNum = Number(aWord);
        const bNum = Number(bWord);
        if (isNaN(aNum) && isNaN(bNum)) {
          if (aWord < bWord) {
            return -1;
          }
          if (aWord > bWord) {
            return 1;
          }
        } else if (!isNaN(aNum) && !isNaN(bNum) && aNum !== bNum) {
          return aNum - bNum;
        } else if (isNaN(aNum) && !isNaN(bNum)) {
          return 1;
        } else if (!isNaN(aNum) && isNaN(bNum)) {
          return -1;
        }
      }
      return 0;
    });
    return res.slice(0, limit);
  }
};

// src/models/BedClosingReason.ts
var BED_REASON_TYPES = ["BED_BLOCK", "BED_CLOSURE", "CAPACITY_ADJUSTMENT", "RESERVATION"];
var BedClosingReason = class extends ParseClass {
  constructor(attributes) {
    super("BedClosingReason", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get description() {
    return this.Get("description");
  }
  set description(val) {
    this.Set("description", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get deletedAt() {
    return this.Get("deletedAt");
  }
  set deletedAt(val) {
    this.Set("deletedAt", val);
  }
  get deletedBy() {
    return this.Get("deletedBy");
  }
  set deletedBy(val) {
    this.Set("deletedBy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("BedClosingReason", BedClosingReason);

// src/models/CapacityPeriod/CapacityPeriod.ts
var CapacityPeriod = class extends ParseClass {
  constructor(attributes) {
    super("CapacityPeriod", attributes);
  }
  get organization() {
    return this.Get("organization");
  }
  set organization(value) {
    this.Set("organization", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(value) {
    this.Set("healthCenter", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get value() {
    return this.Get("value");
  }
  set value(value) {
    this.Set("value", value);
  }
  get startDate() {
    return this.Get("startDate");
  }
  set startDate(value) {
    this.Set("startDate", value);
  }
  get endDate() {
    return this.Get("endDate");
  }
  set endDate(value) {
    this.Set("endDate", value);
  }
  get slots() {
    return this.Get("slots");
  }
  set slots(value) {
    this.Set("slots", value);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(value) {
    this.Set("reason", value);
  }
  get reasonText() {
    return this.Get("reasonText");
  }
  set reasonText(value) {
    this.Set("reasonText", value);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(value) {
    this.Set("comment", value);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(value) {
    this.Set("externalId", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("CapacityPeriod", CapacityPeriod);

// src/models/CapacityPeriod/ICapacityPeriod.ts
var capacityPeriodTypes = ["standard", "override", "delta"];

// src/models/CapacityPeriod/WeeklySlot.ts
var MINUTES_PER_WEEK = 7 * 24 * 60;
var resolveSlotValue = (slots, baseValue, date46) => {
  if (!slots || slots.length === 0) {
    return baseValue;
  }
  const minute = minuteOfWeek(date46);
  return slots.find((slot) => slot.startMinuteOfWeek <= minute && minute < slot.endMinuteOfWeek)?.value ?? baseValue;
};
var minuteOfWeek = (date46) => {
  const dayFromMonday = (date46.getUTCDay() + 6) % 7;
  return dayFromMonday * 1440 + date46.getUTCHours() * 60 + date46.getUTCMinutes();
};

// src/models/CareSector.ts
var CareSector = class extends ParseClass {
  constructor(attributes) {
    super("CareSector", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("CareSector", CareSector);

// src/models/Config.ts
var Config = class extends ParseClass {
  constructor(attributes) {
    super("Config", attributes);
  }
  get key() {
    return this.Get("key");
  }
  set key(val) {
    this.Set("key", val);
  }
  get value() {
    return this.Get("value");
  }
  set value(val) {
    this.Set("value", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Config", Config);

// src/models/Dashboard/Dashboard.ts
var Dashboard = class extends ParseClass {
  constructor(attributes) {
    super("Dashboard", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get title() {
    return this.Get("title");
  }
  set title(val) {
    this.Set("title", val);
  }
  get widgets() {
    return this.Get("widgets");
  }
  set widgets(val) {
    this.Set("widgets", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Dashboard", Dashboard);

// src/models/Dashboard/DashboardWidget.ts
var WIDGET_DISPLAY_TYPES = [
  "table",
  "stat",
  "unitsStatisticsTable",
  "unitsStatisticsIndicators",
  "tabs",
  "select",
  "group"
];
var WIDGET_COL_SPAN = [
  "auto",
  "1/12",
  "2/12",
  "3/12",
  "4/12",
  "5/12",
  "6/12",
  "7/12",
  "8/12",
  "9/12",
  "10/12",
  "11/12",
  "12/12"
];
var DASHBOARD_TABLE_GROUP_MODES = ["columns", "nested"];
var COLUMN_RENDERER_TYPES = ["auto", "bold", "rate", "boolean", "badge"];
var COLUMN_THRESHOLD_COLORS = [
  "grey",
  "purple",
  "midblue",
  "lightblue",
  "blue",
  "green",
  "red",
  "orange",
  "yellow"
];
var COLUMN_THRESHOLD_MODES = ["number", "text"];
var normalizeTableColumns = (columns) => columns?.map((column) => typeof column === "string" ? { key: column } : column);
var WIDGET_DERIVED_COLUMN_FORMULAS = ["rate", "clampedDiff"];
var STAT_RENDERER_TYPES = ["auto", "rate"];
var STAT_LABEL_RENDERER_TYPES = ["auto", "badge", "symbolBadge"];
var STAT_LABEL_COLORS = [
  "lightgrey",
  "grey",
  "purple",
  "midblue",
  "lightblue",
  "blue",
  "green",
  "red",
  "orange",
  "yellow",
  "white"
];
var WIDGET_UNITS_STATISTICS_TABLE_STRUCTURE = ["flat", "recursive"];
var WIDGET_TABS_HEADER_ALIGNMENT = ["left", "center", "right"];
var DASHBOARD_SELECT_SOURCE_TYPES = ["static", "question"];

// src/models/DashboardSlot/DashboardSlot.ts
var DashboardSlot = class extends ParseClass {
  constructor(attributes) {
    super("DashboardSlot", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get slotKey() {
    return this.Get("slotKey");
  }
  set slotKey(val) {
    this.Set("slotKey", val);
  }
  get dashboard() {
    return this.Get("dashboard");
  }
  set dashboard(val) {
    this.Set("dashboard", val);
  }
  get cacheDurationMs() {
    return this.Get("cacheDurationMs");
  }
  set cacheDurationMs(val) {
    this.Set("cacheDurationMs", val);
  }
  get refreshIntervalMs() {
    return this.Get("refreshIntervalMs");
  }
  set refreshIntervalMs(val) {
    this.Set("refreshIntervalMs", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("DashboardSlot", DashboardSlot);

// src/models/DashboardSlot/IDashboardSlot.ts
var MAX_SLOT_CACHE_DURATION_MS = 24 * 60 * 60 * 1e3;
var MAX_SLOT_REFRESH_INTERVAL_MS = 24 * 60 * 60 * 1e3;

// src/models/DashboardSlot/slotKeys.ts
var SLOT_KEYS = ["hc-overview", "territory-overview", "unit-overview"];

// src/models/EmergencyOccupancy.ts
var emergencyOccupancyKey = ["VIVALTO_API", "9H", "14H", "17H"];
var emergencyOccupancyService = ["adults", "pediatric"];
var EmergencyOccupancy = class extends ParseClass {
  constructor(attributes) {
    super("EmergencyOccupancy", attributes);
  }
  get key() {
    return this.Get("key");
  }
  set key(value) {
    this.Set("key", value);
  }
  get date() {
    return this.Get("date");
  }
  set date(value) {
    this.Set("date", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(value) {
    this.Set("healthCenter", value);
  }
  get service() {
    return this.Get("service");
  }
  set service(value) {
    this.Set("service", value);
  }
  get averageWaitingTime() {
    return this.Get("averageWaitingTime");
  }
  set averageWaitingTime(value) {
    this.Set("averageWaitingTime", value);
  }
  get waitingPatients() {
    return this.Get("waitingPatients");
  }
  set waitingPatients(value) {
    this.Set("waitingPatients", value);
  }
  get currentPatients() {
    return this.Get("currentPatients");
  }
  set currentPatients(value) {
    this.Set("currentPatients", value);
  }
  get availableBeds() {
    return this.Get("availableBeds");
  }
  set availableBeds(value) {
    this.Set("availableBeds", value);
  }
  get waitingPatientsBySector() {
    return this.Get("waitingPatientsBySector");
  }
  set waitingPatientsBySector(value) {
    this.Set("waitingPatientsBySector", value);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(value) {
    this.Set("comment", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("EmergencyOccupancy", EmergencyOccupancy);

// src/models/ExternalAuthUnitRule.ts
var ExternalAuthUnitRule = class extends ParseClass {
  constructor(attributes) {
    super("ExternalAuthUnitRule", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get externalIdentifiers() {
    return this.Get("externalIdentifiers");
  }
  set externalIdentifiers(val) {
    this.Set("externalIdentifiers", val);
  }
  get internalIdentifiers() {
    return this.Get("internalIdentifiers");
  }
  set internalIdentifiers(val) {
    this.Set("internalIdentifiers", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ExternalAuthUnitRule", ExternalAuthUnitRule);

// src/models/ExternalPatientTransport/ExternalPatientTransport.ts
var externalPatientTransportPosition = ["LYING_DOWN", "SITTING_UP"];
var ExternalPatientTransport = class extends ParseClass {
  constructor(attributes) {
    super("ExternalPatientTransport", attributes);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get farePosition() {
    return this.Get("farePosition");
  }
  set farePosition(val) {
    this.Set("farePosition", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get startAtHistory() {
    return this.Get("startAtHistory");
  }
  set startAtHistory(val) {
    this.Set("startAtHistory", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ExternalPatientTransport", ExternalPatientTransport);

// src/models/Fare.ts
var farePositions = ["LYING_DOWN_BED", "LYING_DOWN", "SITTING_UP", "WALKING"];
var fareStatus = [
  "ASSIGNED",
  // Assignée
  "CANCELED",
  // Annulée
  "DONE",
  // Terminé
  "DRAFT",
  // Brouillon
  "FAILED",
  // Mission échouée
  "IN_PROGRESS",
  // En cours
  "PATIENT_CARE",
  // Patient pris en charge
  "PENDING",
  // En attente d'assignation
  "QUEUED",
  // À venir
  "STARTED",
  // Mission débutée
  "WAITING"
  // Appel requis
];
var cancellableConfirmedFareStatus = ["PENDING", "ASSIGNED", "STARTED", "PATIENT_CARE"];
var Fare = class extends ParseClass {
  constructor(attributes) {
    super("Fare", attributes);
  }
  get reference() {
    return this.Get("reference");
  }
  set reference(val) {
    this.Set("reference", val);
  }
  get wantedDate() {
    return this.Get("wantedDate");
  }
  set wantedDate(val) {
    this.Set("wantedDate", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get patient() {
    return this.Get("patient");
  }
  set patient(val) {
    this.Set("patient", val);
  }
  get position() {
    return this.Get("position");
  }
  set position(val) {
    this.Set("position", val);
  }
  get needUnitConfirmation() {
    return this.Get("needUnitConfirmation");
  }
  set needUnitConfirmation(val) {
    this.Set("needUnitConfirmation", val);
  }
  get fromArea() {
    return this.Get("fromArea");
  }
  set fromArea(val) {
    this.Set("fromArea", val);
  }
  get toArea() {
    return this.Get("toArea");
  }
  set toArea(val) {
    this.Set("toArea", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get assignations() {
    return this.Get("assignations");
  }
  set assignations(val) {
    this.Set("assignations", val);
  }
  get incidents() {
    return this.Get("incidents");
  }
  set incidents(val) {
    this.Set("incidents", val);
  }
  get specificities() {
    return this.Get("specificities");
  }
  set specificities(val) {
    this.Set("specificities", val);
  }
  get customSpecificities() {
    return this.Get("customSpecificities");
  }
  set customSpecificities(val) {
    this.Set("customSpecificities", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get roundTrip() {
    return this.Get("roundTrip");
  }
  set roundTrip(val) {
    this.Set("roundTrip", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get canceledAt() {
    return this.Get("canceledAt");
  }
  set canceledAt(val) {
    this.Set("canceledAt", val);
  }
  get canceledBy() {
    return this.Get("canceledBy");
  }
  set canceledBy(val) {
    this.Set("canceledBy", val);
  }
  get cancellationReason() {
    return this.Get("cancellationReason");
  }
  set cancellationReason(val) {
    this.Set("cancellationReason", val);
  }
  get lastUpdateBy() {
    return this.Get("lastUpdateBy");
  }
  set lastUpdateBy(val) {
    this.Set("lastUpdateBy", val);
  }
  get isReturnTripFromFare() {
    return this.Get("isReturnTripFromFare");
  }
  set isReturnTripFromFare(val) {
    this.Set("isReturnTripFromFare", val);
  }
  get isArchived() {
    return this.Get("isArchived");
  }
  set isArchived(val) {
    this.Set("isArchived", val);
  }
  get isEmergency() {
    return this.Get("isEmergency");
  }
  set isEmergency(val) {
    this.Set("isEmergency", val);
  }
  get scheduledAt() {
    return this.Get("scheduledAt");
  }
  set scheduledAt(val) {
    this.Set("scheduledAt", val);
  }
  get startedAt() {
    return this.Get("startedAt");
  }
  set startedAt(val) {
    this.Set("startedAt", val);
  }
  get patientCareAt() {
    return this.Get("patientCareAt");
  }
  set patientCareAt(val) {
    this.Set("patientCareAt", val);
  }
  get endedAt() {
    return this.Get("endedAt");
  }
  set endedAt(val) {
    this.Set("endedAt", val);
  }
  get duration() {
    return this.Get("duration");
  }
  set duration(val) {
    this.Set("duration", val);
  }
  get startDelay() {
    return this.Get("startDelay");
  }
  set startDelay(val) {
    this.Set("startDelay", val);
  }
  get porters() {
    return this.Get("porters");
  }
  set porters(val) {
    this.Set("porters", val);
  }
  get fromUnit() {
    return this.Get("fromUnit");
  }
  set fromUnit(val) {
    this.Set("fromUnit", val);
  }
  get toUnit() {
    return this.Get("toUnit");
  }
  set toUnit(val) {
    this.Set("toUnit", val);
  }
  get estimatedPathDurationInSeconds() {
    return this.Get("estimatedPathDurationInSeconds");
  }
  set estimatedPathDurationInSeconds(val) {
    this.Set("estimatedPathDurationInSeconds", val);
  }
  get estimatedPathDurationStrategy() {
    return this.Get("estimatedPathDurationStrategy");
  }
  set estimatedPathDurationStrategy(val) {
    this.Set("estimatedPathDurationStrategy", val);
  }
  get groupId() {
    return this.Get("groupId");
  }
  set groupId(val) {
    this.Set("groupId", val);
  }
  get procedureExternalId() {
    return this.Get("procedureExternalId");
  }
  set procedureExternalId(val) {
    this.Set("procedureExternalId", val);
  }
  get fromStep() {
    return this.Get("fromStep");
  }
  set fromStep(val) {
    this.Set("fromStep", val);
  }
  get toStep() {
    return this.Get("toStep");
  }
  set toStep(val) {
    this.Set("toStep", val);
  }
  get journey() {
    return this.Get("journey");
  }
  set journey(val) {
    this.Set("journey", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Fare", Fare);

// src/models/FareAssignation.ts
var FareAssignation = class extends ParseClass {
  constructor(attributes) {
    super("FareAssignation", attributes);
  }
  get fare() {
    return this.Get("fare");
  }
  set fare(val) {
    this.Set("fare", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get acknowledgedAt() {
    return this.Get("acknowledgedAt");
  }
  set acknowledgedAt(val) {
    this.Set("acknowledgedAt", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("FareAssignation", FareAssignation);

// src/models/FareHistory.ts
var FareHistory = class extends ParseClass {
  constructor(attributes) {
    super("FareHistory", attributes);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get fare() {
    return this.Get("fare");
  }
  set fare(val) {
    this.Set("fare", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("FareHistory", FareHistory);

// src/models/GamExport.ts
var GamExport = class extends ParseClass {
  constructor(attributes) {
    super("GamExport", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get exportPatients() {
    return this.Get("exportPatients");
  }
  set exportPatients(val) {
    this.Set("exportPatients", val);
  }
  get surnumeraryPatients() {
    return this.Get("surnumeraryPatients");
  }
  set surnumeraryPatients(val) {
    this.Set("surnumeraryPatients", val);
  }
  get fileDate() {
    return this.Get("fileDate");
  }
  set fileDate(val) {
    this.Set("fileDate", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("GamExport", GamExport);

// src/models/HealthCenter.ts
var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["fr_FR"] = "fr_FR";
  Locale2["fr_CH"] = "fr_CH";
  Locale2["en_GB"] = "en_GB";
  Locale2["fr_APHP"] = "fr_APHP";
  return Locale2;
})(Locale || {});
var rorTypes = ["PACA", "BRETAGNE", "IDF"];
var delayRuleTypes = ["TODAY_AT", "TOMORROW_AT", "HOURS"];
var HealthCenter = class extends ParseClass {
  constructor(attributes) {
    super("HealthCenter", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get qrCodeKey() {
    return this.Get("qrCodeKey");
  }
  set qrCodeKey(val) {
    this.Set("qrCodeKey", val);
  }
  get autodispatchActivated() {
    return this.Get("autodispatchActivated");
  }
  set autodispatchActivated(val) {
    this.Set("autodispatchActivated", val);
  }
  get autoComputeOccupanciesActivated() {
    return this.Get("autoComputeOccupanciesActivated");
  }
  set autoComputeOccupanciesActivated(val) {
    this.Set("autoComputeOccupanciesActivated", val);
  }
  get fareGroupActivated() {
    return this.Get("fareGroupActivated");
  }
  set fareGroupActivated(val) {
    this.Set("fareGroupActivated", val);
  }
  get fareGroupTimeInterval() {
    return this.Get("fareGroupTimeInterval");
  }
  set fareGroupTimeInterval(val) {
    this.Set("fareGroupTimeInterval", val);
  }
  get endOfShiftPorterActivated() {
    return this.Get("endOfShiftPorterActivated");
  }
  set endOfShiftPorterActivated(val) {
    this.Set("endOfShiftPorterActivated", val);
  }
  get portersLimitByFarePosition() {
    return this.Get("portersLimitByFarePosition");
  }
  set portersLimitByFarePosition(val) {
    this.Set("portersLimitByFarePosition", val);
  }
  get username() {
    return this.Get("username");
  }
  set username(val) {
    this.Set("username", val);
  }
  get externalCpageId() {
    return this.get("externalCpageId");
  }
  set externalCpageId(val) {
    this.set("externalCpageId", val);
  }
  getPortersLimitByFarePosition(val) {
    const portersLimitByFarePosition = this.portersLimitByFarePosition;
    if (portersLimitByFarePosition) {
      return portersLimitByFarePosition[val];
    }
  }
  get autodispatchTimeInMinutesAnticipation() {
    return this.Get("autodispatchTimeInMinutesAnticipation");
  }
  set autodispatchTimeInMinutesAnticipation(val) {
    this.Set("autodispatchTimeInMinutesAnticipation", val);
  }
  get location() {
    return this.Get("location");
  }
  set location(val) {
    this.Set("location", val);
  }
  get assigningAuthority() {
    return this.Get("assigningAuthority");
  }
  set assigningAuthority(val) {
    this.Set("assigningAuthority", val);
  }
  get isStructureDiscoveryActivated() {
    return this.Get("isStructureDiscoveryActivated");
  }
  set isStructureDiscoveryActivated(val) {
    this.Set("isStructureDiscoveryActivated", val);
  }
  get groups() {
    return this.Get("groups");
  }
  set groups(val) {
    this.Set("groups", val);
  }
  get finess() {
    return this.Get("finess");
  }
  set finess(val) {
    this.Set("finess", val);
  }
  get geoFiness() {
    return this.Get("geoFiness");
  }
  set geoFiness(val) {
    this.set("geoFiness", val);
  }
  get rorOptions() {
    return this.Get("rorOptions");
  }
  set rorOptions(val) {
    this.Set("rorOptions", val);
  }
  get computeAnomaliesActivated() {
    return this.Get("computeAnomaliesActivated");
  }
  set computeAnomaliesActivated(val) {
    this.Set("computeAnomaliesActivated", val);
  }
  get bookedBedDelayRule() {
    return this.Get("bookedBedDelayRule");
  }
  set bookedBedDelayRule(val) {
    this.Set("bookedBedDelayRule", val);
  }
  get hasPediatricService() {
    return this.Get("hasPediatricService");
  }
  set hasPediatricService(val) {
    this.Set("hasPediatricService", val);
  }
  get autoComputeDischarge() {
    return this.Get("autoComputeDischarge");
  }
  set autoComputeDischarge(val) {
    this.Set("autoComputeDischarge", val);
  }
  get chatSupportEnabled() {
    return this.Get("chatSupportEnabled");
  }
  set chatSupportEnabled(val) {
    this.Set("chatSupportEnabled", val);
  }
  get patientTransportEnabled() {
    return this.Get("patientTransportEnabled");
  }
  set patientTransportEnabled(val) {
    this.Set("patientTransportEnabled", val);
  }
  get samlConfig() {
    return this.Get("samlConfig");
  }
  set samlConfig(val) {
    this.Set("samlConfig", val);
  }
  get microsoftAuthConfig() {
    return this.Get("microsoftAuthConfig");
  }
  set microsoftAuthConfig(val) {
    this.Set("microsoftAuthConfig", val);
  }
  get config() {
    return this.Get("config");
  }
  set config(val) {
    this.Set("config", val);
  }
  get lastDatasetSyncedAt() {
    return this.Get("lastDatasetSyncedAt");
  }
  set lastDatasetSyncedAt(val) {
    this.Set("lastDatasetSyncedAt", val);
  }
  get locale() {
    return this.Get("locale");
  }
  set locale(val) {
    this.Set("locale", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("HealthCenter", HealthCenter);

// src/models/healthcenter-config/capacityConfig.ts
var capacityPeriodAdjustmentModes = ["override", "delta"];
var capacityModes = ["fixed", "scheduled"];
var DEFAULT_CAPACITY_CONFIG = {
  enabled: false,
  adjustmentMode: "override",
  mode: "fixed",
  allowHistoryActions: false
};

// src/models/healthcenter-config/environmentalCleaningOptions.ts
var environmentalCleaningOptions = ["disabled", "manual", "automatic"];
var ACTIVE_ENVIRONMENTAL_CLEANING_OPTIONS = ["manual", "automatic"];
var isEnvironmentalCleaningActive = (environmentalCleaning) => environmentalCleaning !== void 0 && ACTIVE_ENVIRONMENTAL_CLEANING_OPTIONS.includes(environmentalCleaning);

// src/models/healthcenter-config/computeEmergencyOccupanciesOptions.ts
var computeEmergencyOccupanciesOptions = ["DISABLED", "MANUAL", "AUTO"];

// src/models/healthcenter-config/HealthCenterConfig.ts
var HealthCenterConfig = class extends ParseClass {
  constructor(attributes) {
    super("HealthCenterConfig", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get environmentalCleaning() {
    return this.Get("environmentalCleaning");
  }
  set environmentalCleaning(val) {
    this.Set("environmentalCleaning", val);
  }
  get roomDetailsDisplayEnabled() {
    return this.Get("roomDetailsDisplayEnabled");
  }
  set roomDetailsDisplayEnabled(val) {
    this.Set("roomDetailsDisplayEnabled", val);
  }
  get hospitalizationReasonDisplayEnabled() {
    return this.Get("hospitalizationReasonDisplayEnabled");
  }
  set hospitalizationReasonDisplayEnabled(val) {
    this.Set("hospitalizationReasonDisplayEnabled", val);
  }
  get bufferZoneDisplayEnabled() {
    return this.Get("bufferZoneDisplayEnabled");
  }
  set bufferZoneDisplayEnabled(val) {
    this.Set("bufferZoneDisplayEnabled", val);
  }
  get crisisBannerEnabled() {
    return this.Get("crisisBannerEnabled");
  }
  set crisisBannerEnabled(val) {
    this.Set("crisisBannerEnabled", val);
  }
  get crisisBannerTitle() {
    return this.Get("crisisBannerTitle");
  }
  set crisisBannerTitle(val) {
    this.Set("crisisBannerTitle", val);
  }
  get crisisBannerContent() {
    return this.Get("crisisBannerContent");
  }
  set crisisBannerContent(val) {
    this.Set("crisisBannerContent", val);
  }
  get crisisBannerColor() {
    return this.Get("crisisBannerColor");
  }
  set crisisBannerColor(val) {
    this.Set("crisisBannerColor", val);
  }
  get customSpecificitiesEnabled() {
    return this.Get("customSpecificitiesEnabled");
  }
  set customSpecificitiesEnabled(val) {
    this.Set("customSpecificitiesEnabled", val);
  }
  get thesaurusEnabled() {
    return this.Get("thesaurusEnabled");
  }
  set thesaurusEnabled(val) {
    this.Set("thesaurusEnabled", val);
  }
  get thesaurusReasonEnabled() {
    return this.Get("thesaurusReasonEnabled");
  }
  set thesaurusReasonEnabled(val) {
    this.Set("thesaurusReasonEnabled", val);
  }
  get thesaurusUnitsSuggestionsEnabled() {
    return this.Get("thesaurusUnitsSuggestionsEnabled");
  }
  set thesaurusUnitsSuggestionsEnabled(val) {
    this.Set("thesaurusUnitsSuggestionsEnabled", val);
  }
  get thesaurusAutocomputeDischargeDateEnabled() {
    return this.Get("thesaurusAutocomputeDischargeDateEnabled");
  }
  set thesaurusAutocomputeDischargeDateEnabled(val) {
    this.Set("thesaurusAutocomputeDischargeDateEnabled", val);
  }
  get multiUnitOnKurtViews() {
    return this.Get("multiUnitOnKurtViews");
  }
  set multiUnitOnKurtViews(val) {
    this.Set("multiUnitOnKurtViews", val);
  }
  get interopStructureConnectorEnabled() {
    return this.Get("interopStructureConnectorEnabled");
  }
  set interopStructureConnectorEnabled(val) {
    this.Set("interopStructureConnectorEnabled", val);
  }
  get medicalSpecialtiesEnabled() {
    return this.Get("medicalSpecialtiesEnabled");
  }
  set medicalSpecialtiesEnabled(val) {
    this.Set("medicalSpecialtiesEnabled", val);
  }
  get computeEmergencyOccupancies() {
    return this.Get("computeEmergencyOccupancies");
  }
  set computeEmergencyOccupancies(val) {
    this.Set("computeEmergencyOccupancies", val);
  }
  get viaTrajectoireEnabled() {
    return this.Get("viaTrajectoireEnabled");
  }
  set viaTrajectoireEnabled(val) {
    this.Set("viaTrajectoireEnabled", val);
  }
  get viaTrajectoireCodeSih() {
    return this.Get("viaTrajectoireCodeSih");
  }
  set viaTrajectoireCodeSih(val) {
    this.Set("viaTrajectoireCodeSih", val);
  }
  get autoDispatchEnabled() {
    return this.Get("autoDispatchEnabled");
  }
  set autoDispatchEnabled(val) {
    this.Set("autoDispatchEnabled", val);
  }
  /** Time in minutes */
  get autoDispatchAnticipationTime() {
    return this.Get("autoDispatchAnticipationTime");
  }
  set autoDispatchAnticipationTime(val) {
    this.Set("autoDispatchAnticipationTime", val);
  }
  /** Delay in seconds */
  get autoDispatchDelayBetweenAssignations() {
    return this.Get("autoDispatchDelayBetweenAssignations");
  }
  set autoDispatchDelayBetweenAssignations(val) {
    this.Set("autoDispatchDelayBetweenAssignations", val);
  }
  get portersLimitByFarePosition() {
    return this.Get("portersLimitByFarePosition");
  }
  set portersLimitByFarePosition(val) {
    this.Set("portersLimitByFarePosition", val);
  }
  get fareGroupEnabled() {
    return this.Get("fareGroupEnabled");
  }
  set fareGroupEnabled(val) {
    this.Set("fareGroupEnabled", val);
  }
  get fareGroupTimeInterval() {
    return this.Get("fareGroupTimeInterval");
  }
  set fareGroupTimeInterval(val) {
    this.Set("fareGroupTimeInterval", val);
  }
  get nightAndWeekendEnabled() {
    return this.Get("nightAndWeekendEnabled");
  }
  set nightAndWeekendEnabled(val) {
    this.Set("nightAndWeekendEnabled", val);
  }
  get nightAndWeekendStartAt() {
    return this.Get("nightAndWeekendStartAt");
  }
  set nightAndWeekendStartAt(val) {
    this.Set("nightAndWeekendStartAt", val);
  }
  get updateOccupanciesDelay() {
    return this.Get("updateOccupanciesDelay");
  }
  set updateOccupanciesDelay(val) {
    this.Set("updateOccupanciesDelay", val);
  }
  get quotasReachedDisplayEnabled() {
    return this.Get("quotasReachedDisplayEnabled");
  }
  set quotasReachedDisplayEnabled(val) {
    this.Set("quotasReachedDisplayEnabled", val);
  }
  get bedClosingReasonEnabled() {
    return this.Get("bedClosingReasonEnabled");
  }
  set bedClosingReasonEnabled(val) {
    this.Set("bedClosingReasonEnabled", val);
  }
  get bedClosingReasonRequired() {
    return this.Get("bedClosingReasonRequired");
  }
  set bedClosingReasonRequired(val) {
    this.Set("bedClosingReasonRequired", val);
  }
  get bedBlockReasonRequired() {
    return this.Get("bedBlockReasonRequired");
  }
  set bedBlockReasonRequired(val) {
    this.Set("bedBlockReasonRequired", val);
  }
  get reservationReasonRequired() {
    return this.Get("reservationReasonRequired");
  }
  set reservationReasonRequired(val) {
    this.Set("reservationReasonRequired", val);
  }
  get capacityAdjustmentReasonRequired() {
    return this.Get("capacityAdjustmentReasonRequired");
  }
  set capacityAdjustmentReasonRequired(val) {
    this.Set("capacityAdjustmentReasonRequired", val);
  }
  get oidcConfig() {
    return this.Get("oidcConfig");
  }
  set oidcConfig(val) {
    this.Set("oidcConfig", val);
  }
  get appointmentsDisplayEnabled() {
    return this.Get("appointmentsDisplayEnabled");
  }
  set appointmentsDisplayEnabled(val) {
    this.Set("appointmentsDisplayEnabled", val);
  }
  get appointmentFaresEnabled() {
    return this.Get("appointmentFaresEnabled");
  }
  set appointmentFaresEnabled(val) {
    this.Set("appointmentFaresEnabled", val);
  }
  get interopRules() {
    return this.Get("interopRules");
  }
  set interopRules(val) {
    this.Set("interopRules", val);
  }
  get patientAddressDisplayEnabled() {
    return this.Get("patientAddressDisplayEnabled");
  }
  set patientAddressDisplayEnabled(val) {
    this.Set("patientAddressDisplayEnabled", val);
  }
  get occupancyLevels() {
    return this.Get("occupancyLevels");
  }
  set occupancyLevels(val) {
    this.Set("occupancyLevels", val);
  }
  get showFaresFromKurtDialogs() {
    return this.Get("showFaresFromKurtDialogs");
  }
  set showFaresFromKurtDialogs(val) {
    this.Set("showFaresFromKurtDialogs", val);
  }
  get medicallyOutgoingDisplayEnabled() {
    return this.Get("medicallyOutgoingDisplayEnabled");
  }
  set medicallyOutgoingDisplayEnabled(val) {
    this.Set("medicallyOutgoingDisplayEnabled", val);
  }
  get hidePatientSearchInDirectAdmissionForm() {
    return this.Get("hidePatientSearchInDirectAdmissionForm");
  }
  set hidePatientSearchInDirectAdmissionForm(val) {
    this.Set("hidePatientSearchInDirectAdmissionForm", val);
  }
  get directAdmissionOccurrenceDateEnabled() {
    return this.Get("directAdmissionOccurrenceDateEnabled");
  }
  set directAdmissionOccurrenceDateEnabled(val) {
    this.Set("directAdmissionOccurrenceDateEnabled", val);
  }
  get hospitalizationRequestOccurrenceDateEnabled() {
    return this.Get("hospitalizationRequestOccurrenceDateEnabled");
  }
  set hospitalizationRequestOccurrenceDateEnabled(val) {
    this.Set("hospitalizationRequestOccurrenceDateEnabled", val);
  }
  get internalMutationOccurrenceDateEnabled() {
    return this.Get("internalMutationOccurrenceDateEnabled");
  }
  set internalMutationOccurrenceDateEnabled(val) {
    this.Set("internalMutationOccurrenceDateEnabled", val);
  }
  get appBarSearchEnabled() {
    return this.Get("appBarSearchEnabled");
  }
  set appBarSearchEnabled(val) {
    this.Set("appBarSearchEnabled", val);
  }
  get patientPlacementWeekViewEnabled() {
    return this.Get("patientPlacementWeekViewEnabled");
  }
  set patientPlacementWeekViewEnabled(val) {
    this.Set("patientPlacementWeekViewEnabled", val);
  }
  get dataExportToOPBIEnabled() {
    return this.Get("dataExportToOPBIEnabled");
  }
  set dataExportToOPBIEnabled(val) {
    this.Set("dataExportToOPBIEnabled", val);
  }
  get dataExportToCustomerEnabled() {
    return this.Get("dataExportToCustomerEnabled");
  }
  set dataExportToCustomerEnabled(val) {
    this.Set("dataExportToCustomerEnabled", val);
  }
  get overrideExternalAuthProfile() {
    return this.Get("overrideExternalAuthProfile");
  }
  set overrideExternalAuthProfile(val) {
    this.Set("overrideExternalAuthProfile", val);
  }
  get overrideExternalAuthUnits() {
    return this.Get("overrideExternalAuthUnits");
  }
  set overrideExternalAuthUnits(val) {
    this.Set("overrideExternalAuthUnits", val);
  }
  get multifinessMutationEnabled() {
    return this.Get("multifinessMutationEnabled");
  }
  set multifinessMutationEnabled(val) {
    this.Set("multifinessMutationEnabled", val);
  }
  get metabaseConfig() {
    return this.Get("metabaseConfig");
  }
  set metabaseConfig(val) {
    this.Set("metabaseConfig", val);
  }
  get searchPatientWithSearchIndex() {
    return this.Get("searchPatientWithSearchIndex");
  }
  set searchPatientWithSearchIndex(val) {
    this.Set("searchPatientWithSearchIndex", val);
  }
  get displayPatientJourneyInDetailsDialog() {
    return this.Get("displayPatientJourneyInDetailsDialog");
  }
  set displayPatientJourneyInDetailsDialog(val) {
    this.Set("displayPatientJourneyInDetailsDialog", val);
  }
  get contextualLink() {
    return this.Get("contextualLink");
  }
  set contextualLink(val) {
    this.Set("contextualLink", val);
  }
  get contextualLinks() {
    return this.Get("contextualLinks");
  }
  set contextualLinks(val) {
    this.Set("contextualLinks", val);
  }
  get closedAndAdditionalBedsInManualOccupancyEnabled() {
    return this.Get("closedAndAdditionalBedsInManualOccupancyEnabled");
  }
  set closedAndAdditionalBedsInManualOccupancyEnabled(val) {
    this.Set("closedAndAdditionalBedsInManualOccupancyEnabled", val);
  }
  get patientSearchVersion() {
    return this.Get("patientSearchVersion");
  }
  get patientSearchAutocompleteVersion() {
    return this.Get("patientSearchAutocompleteVersion");
  }
  get movementRequestConfig() {
    return this.Get("movementRequestConfig");
  }
  set movementRequestConfig(val) {
    this.Set("movementRequestConfig", val);
  }
  get bedClosingFromStructureEnabled() {
    return this.Get("bedClosingFromStructureEnabled");
  }
  set bedClosingFromStructureEnabled(val) {
    this.Set("bedClosingFromStructureEnabled", val);
  }
  get transitUnitsEnabled() {
    return this.Get("transitUnitsEnabled");
  }
  set transitUnitsEnabled(val) {
    this.Set("transitUnitsEnabled", val);
  }
  get capacityConfig() {
    return this.Get("capacityConfig");
  }
  set capacityConfig(val) {
    this.Set("capacityConfig", val);
  }
  get financialAxisEnabled() {
    return this.Get("financialAxisEnabled");
  }
  set financialAxisEnabled(val) {
    this.Set("financialAxisEnabled", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("HealthCenterConfig", HealthCenterConfig);

// src/models/UserProfile.ts
var userProfileKurtActions = [
  "addAccommodation",
  "createDirectAdmission",
  "dischargePatient",
  "confirmAdmission",
  "updateUnit",
  "cancelAccommodationAutoPatient",
  "cancelAccommodationManualPatient",
  "cancelInternalAndEmergencyMutations",
  "createMovementRequest",
  "createHospitalizationRequest",
  "cancelMovementRequest",
  "manageSavedViews",
  "editDischargeDate",
  "searchPatientAcrossHealthCenterGroup",
  "editAdmitReason",
  "editSpecificities",
  "editRequestSpecificities",
  "appBarSearch",
  "rerouteDirectAdmission",
  "rerouteInternalMutation",
  "editOrientation",
  "manageBedClosure",
  "manageBedBlock",
  "manageReservation",
  "manageThesaurus",
  "manageStructure",
  "answerMovementRequest"
];
var userProfileSabriActions = [
  "orderJourney",
  "updateJourney",
  "cancelJourney",
  "assignFare",
  "tickFare",
  "reportFareIncident",
  "logoutPorter",
  "accessPendingFareTab",
  "accessInOutFareTabs",
  "confirmFare"
];
var userProfileEnvironmentalCleaningActions = ["cleanBeds", "manageEnvironmentalCleaning"];
var userProfileActions = [
  ...userProfileKurtActions,
  ...userProfileSabriActions,
  ...userProfileEnvironmentalCleaningActions
];
var DEFAULT_ACTION_PERMISSIONS = {
  addAccommodation: true,
  createDirectAdmission: true,
  dischargePatient: true,
  confirmAdmission: true,
  updateUnit: true,
  cancelAccommodationAutoPatient: true,
  cancelAccommodationManualPatient: true,
  cancelInternalAndEmergencyMutations: true,
  createMovementRequest: true,
  createHospitalizationRequest: true,
  cancelMovementRequest: true,
  manageSavedViews: true,
  editDischargeDate: true,
  searchPatientAcrossHealthCenterGroup: false,
  editAdmitReason: true,
  editSpecificities: true,
  editRequestSpecificities: false,
  appBarSearch: true,
  manageBedClosure: true,
  manageBedBlock: false,
  manageReservation: false,
  manageThesaurus: false,
  manageStructure: false,
  answerMovementRequest: true,
  orderJourney: true,
  updateJourney: true,
  cancelJourney: true,
  assignFare: true,
  tickFare: true,
  reportFareIncident: true,
  logoutPorter: true,
  accessPendingFareTab: true,
  accessInOutFareTabs: true,
  confirmFare: true,
  rerouteDirectAdmission: true,
  rerouteInternalMutation: true,
  editOrientation: true,
  // Le bionettoyage est opt-in : un profil créé avant le module n'y a pas droit.
  cleanBeds: false,
  manageEnvironmentalCleaning: false
};
var anonymousModes = ["full-total", "full-trigram", "partial-total", "partial-trigram"];
var UserProfile = class extends ParseClass {
  constructor(attributes) {
    super("UserProfile", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(val) {
    this.Set("identifiers", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get navigationACL() {
    return this.Get("navigationACL");
  }
  set navigationACL(val) {
    this.Set("navigationACL", val);
  }
  get isReadOnly() {
    return this.Get("isReadOnly");
  }
  set isReadOnly(val) {
    this.Set("isReadOnly", val);
  }
  get hasAccessToAllUnits() {
    return this.Get("hasAccessToAllUnits");
  }
  set hasAccessToAllUnits(val) {
    this.Set("hasAccessToAllUnits", val);
  }
  get actionPermissions() {
    return this.Get("actionPermissions");
  }
  set actionPermissions(val) {
    this.Set("actionPermissions", val);
  }
  get anonymousMode() {
    return this.Get("anonymousMode");
  }
  set anonymousMode(val) {
    this.Set("anonymousMode", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UserProfile", UserProfile);

// src/models/healthcenter-config/healthCenterModules.ts
var HEALTH_CENTER_MODULES = [
  {
    isActive: (settings) => isEnvironmentalCleaningActive(settings.environmentalCleaning),
    routes: ["kurt.environmentalCleaning", "mobile.environmentalCleaning"],
    actions: userProfileEnvironmentalCleaningActions
  }
];
var inactiveModulesOf = (settings) => HEALTH_CENTER_MODULES.filter((module) => !module.isActive(settings));
var isNavigationRouteOffered = (route, settings) => !inactiveModulesOf(settings).some((module) => module.routes.includes(route));
var isUserProfileActionOffered = (action, settings) => !inactiveModulesOf(settings).some((module) => module.actions.includes(action));

// src/models/healthcenter-config/IHealthCenterConfig.ts
var crisisBannerColors = ["error", "warning", "danger", "success", "info", "primary", "secondary"];

// src/models/healthcenter-config/movementRequestConfig.ts
var movementRequestRoutingModeOptions = ["REQUIRED", "DISABLED", "OPTIONAL"];
var DEFAULT_MOVEMENT_REQUEST_TYPE_CONFIG = {
  routingMode: "REQUIRED",
  orientationEnabled: false
};
var DEFAULT_MOVEMENT_REQUEST_CONFIG = {
  hospitalization: { routingMode: "OPTIONAL", orientationEnabled: false },
  mutation: { ...DEFAULT_MOVEMENT_REQUEST_TYPE_CONFIG },
  directAdmission: { ...DEFAULT_MOVEMENT_REQUEST_TYPE_CONFIG }
};

// src/models/healthcenter-config/occupancyLevel.ts
var OCCUPANCY_LEVEL_COLORS = ["green", "orange", "red", "grey"];
var DEFAULT_OCCUPANCY_LEVELS = [
  { maxOccupancyRate: 85, color: "green" },
  { maxOccupancyRate: 95, color: "orange" },
  { maxOccupancyRate: null, color: "red" }
];

// src/models/Incident.ts
var incidentReasons = [
  "PATIENT_UNFIT",
  "PATIENT_NOT_READY",
  "INADEQUATE_FARE_TRANSPORT",
  "NEED_HELP",
  "OTHER",
  "PATIENT_MISSING"
];
var Incident = class extends ParseClass {
  constructor(attributes) {
    super("Incident", attributes);
  }
  get fare() {
    return this.Get("fare");
  }
  set fare(val) {
    this.Set("fare", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get delayInMinutes() {
    return this.Get("delayInMinutes");
  }
  set delayInMinutes(val) {
    this.Set("delayInMinutes", val);
  }
  get createdByRole() {
    return this.Get("createdByRole");
  }
  set createdByRole(val) {
    this.Set("createdByRole", val);
  }
  get createdByName() {
    return this.Get("createdByName");
  }
  set createdByName(val) {
    this.Set("createdByName", val);
  }
  get adequateTransport() {
    return this.Get("adequateTransport");
  }
  set adequateTransport(val) {
    this.Set("adequateTransport", val);
  }
  get helpRequired() {
    return this.Get("helpRequired");
  }
  set helpRequired(val) {
    this.Set("helpRequired", val);
  }
  get unassignmentRequested() {
    return this.Get("unassignmentRequested");
  }
  set unassignmentRequested(val) {
    this.Set("unassignmentRequested", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Incident", Incident);

// src/models/interop-message/data-types/InteropMessageHprimData.ts
var isInteropMessageHprimData = (data) => {
  return !!data && typeof data === "object" && "type" in data && "appointment" in data && "source" in data && data.source === "HPRIMXML";
};

// src/models/interop-message/InteropMessage.ts
var InteropMessage = class extends ParseClass {
  constructor(params) {
    super("InteropMessage", params);
  }
  set hash(value) {
    this.Set("hash", value);
  }
  get hash() {
    return this.Get("hash");
  }
  set status(value) {
    this.Set("status", value);
  }
  get status() {
    return this.Get("status");
  }
  set statusReason(value) {
    this.Set("statusReason", value);
  }
  get statusReason() {
    return this.Get("statusReason");
  }
  set username(value) {
    this.Set("username", value);
  }
  get username() {
    return this.Get("username");
  }
  set healthCenter(value) {
    this.Set("healthCenter", value);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set source(value) {
    this.Set("source", value);
  }
  get source() {
    return this.Get("source");
  }
  set sourceFilePath(value) {
    this.Set("sourceFilePath", value);
  }
  get sourceFilePath() {
    return this.Get("sourceFilePath");
  }
  set messageId(value) {
    this.Set("messageId", value);
  }
  get messageId() {
    return this.Get("messageId");
  }
  set messageDate(value) {
    this.Set("messageDate", value);
  }
  get messageDate() {
    return this.Get("messageDate");
  }
  set movementIds(value) {
    this.Set("movementIds", value);
  }
  get movementIds() {
    return this.Get("movementIds");
  }
  set movementType(value) {
    this.Set("movementType", value);
  }
  get movementType() {
    return this.Get("movementType");
  }
  set movementDate(value) {
    this.Set("movementDate", value);
  }
  get movementDate() {
    return this.Get("movementDate");
  }
  set movementAction(value) {
    this.Set("movementAction", value);
  }
  get movementAction() {
    return this.Get("movementAction");
  }
  set pan(value) {
    this.Set("pan", value);
  }
  get pan() {
    return this.Get("pan");
  }
  set data(value) {
    this.Set("data", value);
  }
  get data() {
    return this.Get("data");
  }
  set rawMessage(value) {
    this.Set("rawMessage", value);
  }
  get rawMessage() {
    return this.Get("rawMessage");
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropMessage", InteropMessage);

// src/models/interop-message/InteropMessageRaw.ts
var InteropMessageRaw = class extends ParseClass {
  constructor(params) {
    super("InteropMessageRaw", params);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get messageId() {
    return this.Get("messageId");
  }
  set messageId(value) {
    this.Set("messageId", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get uploadDate() {
    return this.Get("uploadDate");
  }
  set uploadDate(value) {
    this.Set("uploadDate", value);
  }
  get sourceFilePath() {
    return this.Get("sourceFilePath");
  }
  set sourceFilePath(value) {
    this.Set("sourceFilePath", value);
  }
  get data() {
    return this.Get("data");
  }
  set data(value) {
    this.Set("data", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropMessageRaw", InteropMessageRaw);

// src/models/interop-message/InteropMessageSIU.ts
var InteropMessageSIU = class extends ParseClass {
  constructor(params) {
    super("InteropMessageSIU", params);
  }
  get messageId() {
    return this.Get("messageId");
  }
  set messageId(value) {
    this.Set("messageId", value);
  }
  get status() {
    return this.Get("status");
  }
  set status(value) {
    this.Set("status", value);
  }
  get statusReason() {
    return this.Get("statusReason");
  }
  set statusReason(value) {
    this.Set("statusReason", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get sourceFilePath() {
    return this.Get("sourceFilePath");
  }
  set sourceFilePath(value) {
    this.Set("sourceFilePath", value);
  }
  get data() {
    return this.Get("data");
  }
  set data(value) {
    this.Set("data", value);
  }
  get rawMessage() {
    return this.Get("rawMessage");
  }
  set rawMessage(value) {
    this.Set("rawMessage", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropMessageSIU", InteropMessageSIU);

// src/models/InteropAppointment.ts
var InteropAppointment = class extends ParseClass {
  constructor(attributes) {
    super("InteropAppointment", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get lastMessageId() {
    return this.Get("lastMessageId");
  }
  set lastMessageId(value) {
    this.Set("lastMessageId", value);
  }
  get lastMessageDate() {
    return this.Get("lastMessageDate");
  }
  set lastMessageDate(value) {
    this.Set("lastMessageDate", value);
  }
  get patientIdentity() {
    return this.Get("patientIdentity");
  }
  set patientIdentity(value) {
    this.Set("patientIdentity", value);
  }
  get startDate() {
    return this.Get("startDate");
  }
  set startDate(value) {
    this.Set("startDate", value);
  }
  get status() {
    return this.Get("status");
  }
  set status(value) {
    this.Set("status", value);
  }
  get universalServiceIdentifier() {
    return this.Get("universalServiceIdentifier");
  }
  set universalServiceIdentifier(value) {
    this.Set("universalServiceIdentifier", value);
  }
  get history() {
    return this.Get("history");
  }
  set history(value) {
    this.Set("history", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropAppointment", InteropAppointment);

// src/models/InteropLocation.ts
var InteropLocation = class extends ParseClass {
  constructor(attributes) {
    super("InteropLocation", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get label() {
    return this.Get("label");
  }
  set label(value) {
    this.Set("label", value);
  }
  get parent() {
    return this.Get("parent");
  }
  set parent(value) {
    this.Set("parent", value);
  }
  get managingOrganization() {
    return this.Get("managingOrganization");
  }
  set managingOrganization(value) {
    this.Set("managingOrganization", value);
  }
  get parents() {
    return this.Get("parents");
  }
  set parents(value) {
    this.Set("parents", value);
  }
  get managingOrganizations() {
    return this.Get("managingOrganizations");
  }
  set managingOrganizations(value) {
    this.Set("managingOrganizations", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropLocation", InteropLocation);

// src/models/InteropMovement.ts
var InteropMovementTypes = {
  AdmitInpatient: "admit_inpatient",
  // admission hospitalisé
  RegisterOutpatient: "register_outpatient",
  // patient externe
  DischargePatient: "discharge_patient",
  // sortie
  PreAdmitPatient: "pre_admit_patient",
  // pré-admission
  ChangePatientClassToInpatient: "change_patient_class_to_inpatient",
  // externe devient hospitalisé
  ChangePatientClassToOutpatient: "change_patient_class_to_outpatient",
  // hospitalisé devient externe
  TransferPatient: "transfer_patient",
  // mutation
  ChangeAttendingDoctor: "change_attending_doctor",
  // changement médecin responsable
  LeaveOfAbsence: "leave_of_absence",
  // absence provisoire (permission) et mouvement de transfert vers plateau technique pour acte (<48H)
  ReturnFromLeaveOfAbsence: "return_from_leave_of_absence",
  // retour d’absence provisoire (permission) et mouvement de retour suite à transfert vers plateau technique pour acte (<48H)
  MoveAccountInformation: "move_account_information",
  // réattribution de dossier administratif;
  ChangeResponsibleWard: "change_responsible_ward"
  // Changement d'UF médicale
};
var InteropMovement = class extends ParseClass {
  constructor(attributes) {
    super("InteropMovement", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get lastMessageId() {
    return this.Get("lastMessageId");
  }
  set lastMessageId(value) {
    this.Set("lastMessageId", value);
  }
  get lastMessageDate() {
    return this.Get("lastMessageDate");
  }
  set lastMessageDate(value) {
    this.Set("lastMessageDate", value);
  }
  get identifier() {
    return this.Get("identifier");
  }
  set identifier(value) {
    this.Set("identifier", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get status() {
    return this.Get("status");
  }
  set status(value) {
    this.Set("status", value);
  }
  get date() {
    return this.Get("date");
  }
  set date(value) {
    this.Set("date", value);
  }
  get patientVisit() {
    return this.Get("patientVisit");
  }
  set patientVisit(value) {
    this.Set("patientVisit", value);
  }
  get patientClass() {
    return this.Get("patientClass");
  }
  set patientClass(value) {
    this.Set("patientClass", value);
  }
  get location() {
    return this.Get("location");
  }
  set location(value) {
    this.Set("location", value);
  }
  get organization() {
    return this.Get("organization");
  }
  set organization(value) {
    this.Set("organization", value);
  }
  get responsibleOrganization() {
    return this.Get("responsibleOrganization");
  }
  set responsibleOrganization(value) {
    this.Set("responsibleOrganization", value);
  }
  get responsibleNursingOrganization() {
    return this.Get("responsibleNursingOrganization");
  }
  set responsibleNursingOrganization(value) {
    this.Set("responsibleNursingOrganization", value);
  }
  get history() {
    return this.Get("history");
  }
  set history(value) {
    this.Set("history", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropMovement", InteropMovement);

// src/models/InteropOrganization.ts
var InteropOrganization = class extends ParseClass {
  constructor(attributes) {
    super("InteropOrganization", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get label() {
    return this.Get("label");
  }
  set label(value) {
    this.Set("label", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get parent() {
    return this.Get("parent");
  }
  set parent(value) {
    this.Set("parent", value);
  }
  get parents() {
    return this.Get("parents");
  }
  set parents(value) {
    this.Set("parents", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropOrganization", InteropOrganization);

// src/models/InteropPatientAccount.ts
var InteropPatientAccount = class extends ParseClass {
  constructor(attributes) {
    super("InteropPatientAccount", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get patientAccountNumber() {
    return this.Get("patientAccountNumber");
  }
  set patientAccountNumber(value) {
    this.Set("patientAccountNumber", value);
  }
  get patientIdentity() {
    return this.Get("patientIdentity");
  }
  set patientIdentity(value) {
    this.Set("patientIdentity", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropPatientAccount", InteropPatientAccount);

// src/models/InteropPatientIdentity.ts
var InteropPatientIdentity = class extends ParseClass {
  constructor(attributes) {
    super("InteropPatientIdentity", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get internalIdentifier() {
    return this.Get("internalIdentifier");
  }
  set internalIdentifier(value) {
    this.Set("internalIdentifier", value);
  }
  get name() {
    return this.Get("name");
  }
  set name(value) {
    this.Set("name", value);
  }
  get birthDate() {
    return this.Get("birthDate");
  }
  set birthDate(value) {
    this.Set("birthDate", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropPatientIdentity", InteropPatientIdentity);

// src/models/InteropPatientVisit.ts
var InteropPatientVisit = class extends ParseClass {
  constructor(attributes) {
    super("InteropPatientVisit", attributes);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(value) {
    this.Set("identifiers", value);
  }
  get source() {
    return this.Get("source");
  }
  set source(value) {
    this.Set("source", value);
  }
  get lastMessageId() {
    return this.Get("lastMessageId");
  }
  set lastMessageId(value) {
    this.Set("lastMessageId", value);
  }
  get lastMessageDate() {
    return this.Get("lastMessageDate");
  }
  set lastMessageDate(value) {
    this.Set("lastMessageDate", value);
  }
  get visitNumber() {
    return this.Get("visitNumber");
  }
  set visitNumber(value) {
    this.Set("visitNumber", value);
  }
  get preadmitNumber() {
    return this.Get("preadmitNumber");
  }
  set preadmitNumber(value) {
    this.Set("preadmitNumber", value);
  }
  get patientAccount() {
    return this.Get("patientAccount");
  }
  set patientAccount(value) {
    this.Set("patientAccount", value);
  }
  get expectedAdmitDate() {
    return this.Get("expectedAdmitDate");
  }
  set expectedAdmitDate(value) {
    this.Set("expectedAdmitDate", value);
  }
  get admitDate() {
    return this.Get("admitDate");
  }
  set admitDate(value) {
    this.Set("admitDate", value);
  }
  get expectedDischargeDate() {
    return this.Get("expectedDischargeDate");
  }
  set expectedDischargeDate(value) {
    this.Set("expectedDischargeDate", value);
  }
  get dischargeDate() {
    return this.Get("dischargeDate");
  }
  set dischargeDate(value) {
    this.Set("dischargeDate", value);
  }
  get history() {
    return this.Get("history");
  }
  set history(value) {
    this.Set("history", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("InteropPatientVisit", InteropPatientVisit);

// src/models/Journey.ts
var Journey = class extends ParseClass {
  constructor(attributes) {
    super("Journey", attributes);
  }
  get fares() {
    return this.Get("fares");
  }
  set fares(val) {
    this.Set("fares", val);
  }
  get roundTrip() {
    return this.Get("roundTrip");
  }
  set roundTrip(val) {
    this.Set("roundTrip", val);
  }
  get startingUnit() {
    return this.Get("startingUnit");
  }
  set startingUnit(val) {
    this.Set("startingUnit", val);
  }
  get startingArea() {
    return this.Get("startingArea");
  }
  set startingArea(val) {
    this.Set("startingArea", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Journey", Journey);

// src/models/Migration.ts
var migrationStatuses = ["PROCESSING", "ERROR", "SUCCESS"];
var Migration = class extends ParseClass {
  constructor(attributes) {
    super("Migration", attributes);
  }
  get scriptName() {
    return this.Get("scriptName");
  }
  set scriptName(val) {
    this.Set("scriptName", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get lastRunAt() {
    return this.Get("lastRunAt");
  }
  set lastRunAt(val) {
    this.Set("lastRunAt", val);
  }
  get hash() {
    return this.Get("hash");
  }
  set hash(val) {
    this.Set("hash", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Migration", Migration);

// src/models/Movement.ts
var Movement = class extends ParseClass {
  constructor(attributes) {
    super("Movement", attributes);
  }
  get visit() {
    return this.Get("visit");
  }
  set visit(val) {
    this.Set("visit", val);
  }
  get date() {
    return this.Get("date");
  }
  set date(val) {
    this.Set("date", val);
  }
  set movementId(value) {
    this.Set("movementId", value);
  }
  get movementId() {
    return this.Get("movementId");
  }
  get status() {
    return this.Get("status");
  }
  set status(value) {
    this.Set("status", value);
  }
  get type() {
    return this.Get("type");
  }
  set type(value) {
    this.Set("type", value);
  }
  get lastMessageId() {
    return this.Get("lastMessageId");
  }
  set lastMessageId(value) {
    this.Set("lastMessageId", value);
  }
};
parse_instance_browser_default.Object.registerSubclass("Movement", Movement);

// src/models/CodeSystemConcept/CodeSystemConcept.ts
var CodeSystemConcept = class extends ParseClass {
  constructor(attributes) {
    super("CodeSystemConcept", attributes);
  }
  get system() {
    return this.Get("system");
  }
  set system(val) {
    this.Set("system", val);
  }
  get code() {
    return this.Get("code");
  }
  set code(val) {
    this.Set("code", val);
  }
  get display() {
    return this.Get("display");
  }
  set display(val) {
    this.Set("display", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("CodeSystemConcept", CodeSystemConcept);

// src/models/ConceptMap/ConceptMap.ts
var ConceptMap = class extends ParseClass {
  constructor(attributes) {
    super("ConceptMap", attributes);
  }
  get map() {
    return this.Get("map");
  }
  set map(val) {
    this.Set("map", val);
  }
  get sourceSystem() {
    return this.Get("sourceSystem");
  }
  set sourceSystem(val) {
    this.Set("sourceSystem", val);
  }
  get sourceCode() {
    return this.Get("sourceCode");
  }
  set sourceCode(val) {
    this.Set("sourceCode", val);
  }
  get targetSystem() {
    return this.Get("targetSystem");
  }
  set targetSystem(val) {
    this.Set("targetSystem", val);
  }
  get targetCode() {
    return this.Get("targetCode");
  }
  set targetCode(val) {
    this.Set("targetCode", val);
  }
  get relationship() {
    return this.Get("relationship");
  }
  set relationship(val) {
    this.Set("relationship", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ConceptMap", ConceptMap);

// src/models/ConceptMap/IConceptMap.ts
var conceptRelationships = ["equivalent", "source-is-narrower-than-target"];

// src/models/NavigationACL.ts
var KURT_ROUTES = [
  "kurt",
  "kurt.territory",
  "kurt.healthCenter",
  "kurt.recursiveHealthCenter",
  "kurt.unit",
  "kurt.movements",
  "kurt.requests",
  "kurt.emergency",
  "kurt.environmentalCleaning",
  "kurt.patientTransport",
  "kurt.service",
  "kurt.statistics"
];
var SABRI_ROUTES = [
  "sabri",
  "sabri.settings",
  "sabri.fares",
  "sabri.archives",
  "sabri.team",
  "sabri.statistics"
];
var ADMIN_ROUTES = [
  "admin",
  "admin.healthCenter",
  "admin.users",
  "admin.userProfiles",
  "admin.patients",
  "admin.appointments",
  "admin.bedSettings",
  "admin.serviceManagement",
  "admin.externalTransports",
  "admin.anomalies",
  "admin.emergencies",
  "admin.thesaurus",
  "admin.overview",
  "admin.manualOccupancy",
  "admin.practitioners",
  "admin.specificities",
  "admin.specialties",
  "admin.structure",
  "admin.nightAndWeekend",
  "admin.bedClosingReasons",
  "admin.dischargeDestinations",
  "admin.externalAuthUnitRules",
  "admin.dashboards",
  "admin.dashboardSlots"
];
var MOBILE_ROUTES = ["mobile", "mobile.environmentalCleaning"];
var NAVIGATION_ROUTES = [...KURT_ROUTES, ...SABRI_ROUTES, ...ADMIN_ROUTES, ...MOBILE_ROUTES];
var EXPLICIT_NAVIGATION_ROUTES = [
  "kurt.service",
  "kurt.statistics",
  "sabri.statistics"
];
var hasAccessToRoute = (navigationACL, route) => {
  if (navigationACL.length === 0) {
    return !EXPLICIT_NAVIGATION_ROUTES.includes(route);
  }
  for (const acl of navigationACL) {
    const test = acl.replace(".*", "").replace("*", "");
    if (test === route) {
      return true;
    }
    if (test.length > route.length && test.startsWith(route)) {
      return true;
    }
    if (route.length > test.length) {
      const parentRoute = route.split(".").slice(0, -1).join(".");
      if (parentRoute === test || parentRoute.startsWith(test)) {
        return true;
      }
    }
  }
  return false;
};

// src/models/notifications/fare/fareNotification.ts
var FARE_ASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_ASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var FARE_UNASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_UNASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};

// src/models/notifications/fare/fareUpdatedNotification.ts
var FARE_UPDATED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "FARE_UPDATED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var getFaresDifferences = (oldFare, newFare) => {
  const differences = [];
  if (oldFare.patient.id !== newFare.patient.id) {
    differences.push({
      type: "patient",
      newValue: {
        firstName: newFare.patient.firstName,
        age: newFare.patient.age,
        birthdate: newFare.patient.birthdate,
        gender: newFare.patient.gender,
        lastName: newFare.patient.lastName
      },
      oldValue: {
        firstName: oldFare.patient.firstName,
        age: oldFare.patient.age,
        birthdate: oldFare.patient.birthdate,
        gender: oldFare.patient.gender,
        lastName: oldFare.patient.lastName
      }
    });
  }
  if (oldFare.fromUnit.id !== newFare.fromUnit.id || oldFare.fromArea?.id !== newFare.fromArea?.id) {
    differences.push({
      type: "fromLocation",
      newValue: { unit: newFare.fromUnit.id, areasBreadcrumb: newFare.fromArea?.id },
      oldValue: { unit: oldFare.fromUnit.id, areasBreadcrumb: oldFare.fromArea?.id }
    });
  }
  if (oldFare.toUnit.id !== newFare.toUnit.id || oldFare.toArea?.id !== newFare.toArea?.id) {
    differences.push({
      type: "toLocation",
      newValue: { unit: newFare.toUnit.id, areasBreadcrumb: newFare.toArea?.id },
      oldValue: { unit: oldFare.toUnit.id, areasBreadcrumb: oldFare.toArea?.id }
    });
  }
  if (oldFare.position !== newFare.position) {
    differences.push({
      type: "position",
      newValue: newFare.position,
      oldValue: oldFare.position
    });
  }
  if (JSON.stringify(oldFare.specificities) !== JSON.stringify(newFare.specificities)) {
    differences.push({
      type: "specificities",
      newValue: newFare.specificities ? newFare.specificities : [],
      oldValue: oldFare.specificities ? oldFare.specificities : []
    });
  }
  if (oldFare.comment !== newFare.comment) {
    differences.push({
      type: "comment",
      newValue: newFare.comment,
      oldValue: oldFare.comment
    });
  }
  return differences;
};

// src/models/notifications/fare/newFareIncidentNotification.ts
var NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "NEW_FARE_INCIDENT"
};

// src/models/notifications/notification.ts
import * as Yup2 from "yup";
var notificationTriggerEvent = [
  "FARE_ASSIGNED",
  "FARE_UNASSIGNED",
  "FARE_UPDATED",
  "PORTER_SUPPORT_ASSIGNED",
  "PORTER_SUPPORT_UNASSIGNED",
  "NEW_FARE_INCIDENT",
  "PORTER_START_OF_SERVICE",
  "PORTER_END_OF_SERVICE",
  "NEW_PERFORMER_REQUEST",
  "PERFORMER_REQUEST_ACCEPTED",
  "PERFORMER_REQUEST_REJECTED"
];
var notificationProvider = ["WEB", "IN_APP", "PUSH_MOBILE"];
var retryPolicyValidation = Yup2.object({
  retryDelayInSeconds: Yup2.number().required(),
  maxRetryCount: Yup2.number().required()
});
var notificationConfigurationValidation = Yup2.object({
  triggerEvent: Yup2.string().oneOf(notificationTriggerEvent).required(),
  isAcknowledgeNeeded: Yup2.boolean(),
  retryPolicy: retryPolicyValidation.default(void 0),
  notificationsProviders: Yup2.array().of(Yup2.string().oneOf(notificationProvider).required()).required()
});
var Notification = class extends ParseClass {
  constructor(attributes) {
    super("Notification", attributes);
  }
  get acknowledgedAt() {
    return this.Get("acknowledgedAt");
  }
  set acknowledgedAt(val) {
    this.Set("acknowledgedAt", val);
  }
  get triggerEvent() {
    return this.Get("triggerEvent");
  }
  set triggerEvent(val) {
    this.Set("triggerEvent", val);
  }
  get sendTo() {
    return this.Get("sendTo");
  }
  set sendTo(val) {
    this.Set("sendTo", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get sentNotifications() {
    return this.Get("sentNotifications");
  }
  set sentNotifications(val) {
    this.Set("sentNotifications", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get data() {
    return this.Get("data");
  }
  set data(val) {
    this.Set("data", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Notification", Notification);

// src/models/notifications/porter/porterServiceNotification.ts
var PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PORTER_START_OF_SERVICE"
};
var PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PORTER_END_OF_SERVICE"
};

// src/models/notifications/porter/porterSupportNotification.ts
var PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "PORTER_SUPPORT_ASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};
var PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: true,
  notificationsProviders: ["IN_APP", "PUSH_MOBILE"],
  triggerEvent: "PORTER_SUPPORT_UNASSIGNED",
  retryPolicy: {
    retryDelayInSeconds: 10,
    maxRetryCount: 5
  }
};

// src/models/notifications/step/newPerformerRequestNotification.ts
var NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB", "PUSH_MOBILE"],
  triggerEvent: "NEW_PERFORMER_REQUEST"
};

// src/models/notifications/step/performerRequestAcceptedNotification.ts
var PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PERFORMER_REQUEST_ACCEPTED"
};

// src/models/notifications/step/performerRequestRejectedNotification.ts
var PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION = {
  isAcknowledgeNeeded: false,
  notificationsProviders: ["WEB"],
  triggerEvent: "PERFORMER_REQUEST_REJECTED"
};

// src/models/notifications/notificationConfigurations.ts
var DEFAULT_NOTIFICATION_CONFIGURATION = {
  FARE_ASSIGNED: FARE_ASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UPDATED: FARE_UPDATED_DEFAULT_CONFIGURATION,
  FARE_UNASSIGNED: FARE_UNASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_ASSIGNED: PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_UNASSIGNED: PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION,
  NEW_FARE_INCIDENT: NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION,
  PORTER_START_OF_SERVICE: PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_END_OF_SERVICE: PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION,
  NEW_PERFORMER_REQUEST: NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_ACCEPTED: PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_REJECTED: PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION
};

// src/models/OrganizationAffiliation/OrganizationAffiliation.ts
var OrganizationAffiliation = class extends ParseClass {
  constructor(attributes) {
    super("OrganizationAffiliation", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get participatingOrganization() {
    return this.Get("participatingOrganization");
  }
  set participatingOrganization(val) {
    this.Set("participatingOrganization", val);
  }
  get organization() {
    return this.Get("organization");
  }
  set organization(val) {
    this.Set("organization", val);
  }
  get organizationAncestors() {
    return this.Get("organizationAncestors");
  }
  set organizationAncestors(val) {
    this.Set("organizationAncestors", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("OrganizationAffiliation", OrganizationAffiliation);

// src/models/PathDefaultTime.ts
var PathDefaultTime = class extends ParseClass {
  constructor(attributes) {
    super("PathDefaultTime", attributes);
  }
  get fromArea() {
    return this.Get("fromArea");
  }
  set fromArea(val) {
    this.Set("fromArea", val);
  }
  get toArea() {
    return this.Get("toArea");
  }
  set toArea(val) {
    this.Set("toArea", val);
  }
  get weight() {
    return this.Get("weight");
  }
  set weight(val) {
    this.Set("weight", val);
  }
  get durationInSeconds() {
    return this.Get("durationInSeconds");
  }
  set durationInSeconds(val) {
    this.Set("durationInSeconds", val);
  }
  get position() {
    return this.Get("position");
  }
  set position(val) {
    this.Set("position", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("PathDefaultTime", PathDefaultTime);

// src/utils/string.utils.ts
var normalize = (field) => field.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w]/g, " ").replace(/\s+/g, " ").replace(/^0+/, "").trim();
var StringUtils = {
  normalize
};

// src/utils/formatName/buildPatientSearch.ts
var getAllCombinations = (patient) => {
  const combinations = [];
  const normalizedFirstName = patient.firstName ? StringUtils.normalize(patient.firstName) : null;
  const normalizedLastName = patient.lastName ? StringUtils.normalize(patient.lastName) : null;
  const normalizedLegalName = patient.legalName ? StringUtils.normalize(patient.legalName) : null;
  if (normalizedFirstName) {
    combinations.push(`${normalizedFirstName} ${normalizedLastName || ""}`.trim());
  }
  if (normalizedLastName) {
    combinations.push(`${normalizedLastName} ${normalizedFirstName || ""}`.trim());
  }
  if (normalizedLegalName) {
    combinations.push(`${normalizedLegalName} ${normalizedFirstName || ""}`.trim());
  }
  return Array.from(new Set(combinations));
};
var buildPatientSearch = (patient) => {
  const patientSearch = {
    ...patient.firstName && { firstName: StringUtils.normalize(patient.firstName) },
    ...patient.lastName && { lastName: StringUtils.normalize(patient.lastName) },
    ...patient.legalName && { legalName: StringUtils.normalize(patient.legalName) },
    ...patient.ipp && { ipp: StringUtils.normalize(patient.ipp) },
    ...patient.pan && { pan: StringUtils.normalize(patient.pan) }
  };
  patientSearch.terms = getAllCombinations(patient);
  return patientSearch;
};

// src/utils/formatName/formatFirstname.ts
var formatFirstname = (value) => {
  if (!value) {
    return "";
  }
  return value.trim().toLowerCase().replace(/(^\p{L}{1})|((\s+|-)\p{L}{1})/gu, (letter) => letter.toUpperCase());
};

// src/utils/formatName/formatName.ts
var formatName = (firstName = "", lastName = "", legalName, legalFirstName) => {
  const name = `${lastName.toUpperCase()} ${formatFirstname(firstName)}`;
  const shouldDisplayLegalName = legalName?.toLocaleLowerCase() !== lastName?.toLocaleLowerCase();
  const displayLegalFirstName = legalFirstName && legalFirstName?.toLocaleLowerCase() !== firstName?.toLocaleLowerCase() ? ` (${formatFirstname(legalFirstName)})` : void 0;
  const fullName = legalName && shouldDisplayLegalName ? `${lastName.toUpperCase()} (${legalName.toUpperCase()}) ${formatFirstname(firstName)}` : name;
  return displayLegalFirstName ? fullName + displayLegalFirstName : fullName;
};

// src/utils/formatName/formatNameShort.ts
var formatNameShort = (firstName = "", lastName = "") => {
  return `${lastName.toUpperCase()} ${firstName.charAt(0).toUpperCase()}.`;
};

// src/models/patient/Patient.ts
var patientGender = ["FEMALE", "MALE", "UNKNOWN"];
var patientCreationSources = ["HL7", "HPRIMXML", "MANUAL", "UNKNOWN"];
var patientOutcomeTypes = ["Domicile", "SAD", "EHPAD", "SMR", "Autre", "to-define"];
var PENDING_PAN = "PENDING_PAN";
var Patient = class extends ParseClass {
  constructor(attributes) {
    super("Patient", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get birthdate() {
    return this.Get("birthdate");
  }
  set birthdate(val) {
    this.Set("birthdate", val);
  }
  get birthplace() {
    return this.Get("birthplace");
  }
  set birthplace(val) {
    this.Set("birthplace", val);
  }
  get birthdateAsString() {
    return this.Get("birthdateAsString");
  }
  set birthdateAsString(val) {
    this.Set("birthdateAsString", val);
  }
  get ipp() {
    return this.Get("ipp");
  }
  set ipp(val) {
    this.Set("ipp", val);
  }
  get pan() {
    return this.Get("pan");
  }
  set pan(val) {
    this.Set("pan", val);
  }
  get visitNumber() {
    return this.Get("visitNumber");
  }
  set visitNumber(val) {
    this.Set("visitNumber", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get legalName() {
    return this.Get("legalName");
  }
  set legalName(val) {
    this.Set("legalName", val);
  }
  get legalFirstNames() {
    return this.Get("legalFirstNames");
  }
  set legalFirstNames(val) {
    this.Set("legalFirstNames", val);
  }
  get gender() {
    return this.Get("gender");
  }
  set gender(val) {
    this.Set("gender", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get fullTextSearch() {
    return this.Get("fullTextSearch");
  }
  set fullTextSearch(val) {
    this.Set("fullTextSearch", val);
  }
  get isDischarged() {
    return this.Get("isDischarged");
  }
  set isDischarged(val) {
    this.Set("isDischarged", val);
  }
  get age() {
    return getPatientAge(this.birthdate);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get area() {
    return this.Get("area");
  }
  set area(val) {
    this.Set("area", val);
  }
  get dischargedAt() {
    return this.Get("dischargedAt");
  }
  set dischargedAt(val) {
    this.Set("dischargedAt", val);
  }
  get isDischargeConfirmed() {
    return this.Get("isDischargeConfirmed") ?? false;
  }
  set isDischargeConfirmed(val) {
    this.Set("isDischargeConfirmed", val);
  }
  get admittedAt() {
    return this.Get("admittedAt");
  }
  set admittedAt(val) {
    this.Set("admittedAt", val);
  }
  get ins() {
    return this.Get("ins");
  }
  set ins(val) {
    this.Set("ins", val);
  }
  get insc() {
    return this.Get("insc");
  }
  set insc(val) {
    this.Set("insc", val);
  }
  get socialSecurityNumber() {
    return this.Get("socialSecurityNumber");
  }
  set socialSecurityNumber(val) {
    this.Set("socialSecurityNumber", val);
  }
  get createdFrom() {
    return this.Get("createdFrom");
  }
  set createdFrom(val) {
    this.Set("createdFrom", val);
  }
  get patientOutcome() {
    return this.Get("patientOutcome");
  }
  set patientOutcome(val) {
    this.Set("patientOutcome", val);
  }
  get dischargeDestination() {
    return this.Get("dischargeDestination");
  }
  set dischargeDestination(val) {
    this.Set("dischargeDestination", val);
  }
  get legalFirstName() {
    return this.Get("legalFirstName");
  }
  set legalFirstName(val) {
    this.Set("legalFirstName", val);
  }
  get fullName() {
    return formatName(this.firstName, this.lastName, this.legalName, this.legalFirstName);
  }
  get identityReliabilityCode() {
    return this.Get("identityReliabilityCode");
  }
  set identityReliabilityCode(val) {
    this.Set("identityReliabilityCode", val);
  }
  get admitReason() {
    return this.Get("admitReason");
  }
  set admitReason(val) {
    const trimmed = val?.trim();
    if (trimmed?.length) {
      this.Set("admitReason", trimmed);
    } else {
      this.Unset("admitReason");
    }
  }
  get thesaurusItem() {
    return this.Get("thesaurusItem");
  }
  set thesaurusItem(val) {
    this.Set("thesaurusItem", val);
  }
  get dischargeDateSource() {
    return this.Get("dischargeDateSource");
  }
  set dischargeDateSource(val) {
    this.Set("dischargeDateSource", val);
  }
  get thesaurusComputedDischargeDate() {
    return this.Get("thesaurusComputedDischargeDate");
  }
  set thesaurusComputedDischargeDate(val) {
    this.Set("thesaurusComputedDischargeDate", val);
  }
  get medicallyOutgoing() {
    return this.Get("medicallyOutgoing");
  }
  set medicallyOutgoing(val) {
    this.Set("medicallyOutgoing", val);
  }
  get isNewborn() {
    return this.Get("isNewborn");
  }
  set isNewborn(val) {
    this.Set("isNewborn", val);
  }
  get interop() {
    return this.Get("interop");
  }
  set interop(val) {
    this.Set("interop", val);
  }
  get lastRawAdmitMessage() {
    return this.Get("lastRawAdmitMessage");
  }
  set lastRawAdmitMessage(val) {
    this.Set("lastRawAdmitMessage", val);
  }
  get city() {
    return this.Get("city");
  }
  set city(val) {
    this.Set("city", val);
  }
  get postalCode() {
    return this.Get("postalCode");
  }
  set postalCode(val) {
    this.Set("postalCode", val);
  }
  get customSpecificities() {
    return this.Get("customSpecificities");
  }
  set customSpecificities(val) {
    this.Set("customSpecificities", val);
  }
  get search() {
    return this.Get("search");
  }
  set search(val) {
    this.Set("search", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Patient", Patient);

// src/models/patient/PatientIdentity.ts
var PatientIdentity = class extends ParseClass {
  constructor(attributes) {
    super("PatientIdentity", attributes);
  }
  get ins() {
    return this.Get("ins");
  }
  set ins(val) {
    this.Set("ins", val);
  }
  get insc() {
    return this.Get("insc");
  }
  set insc(val) {
    this.Set("insc", val);
  }
  get socialSecurityNumber() {
    return this.Get("socialSecurityNumber");
  }
  set socialSecurityNumber(val) {
    this.Set("socialSecurityNumber", val);
  }
  get gender() {
    return this.Get("gender");
  }
  set gender(val) {
    this.Set("gender", val);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get legalName() {
    return this.Get("legalName");
  }
  set legalName(val) {
    this.Set("legalName", val);
  }
  get birthdate() {
    return this.Get("birthdate");
  }
  set birthdate(val) {
    this.Set("birthdate", val);
  }
  get birthplace() {
    return this.Get("birthplace");
  }
  set birthplace(val) {
    this.Set("birthplace", val);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(val) {
    this.Set("identifiers", val);
  }
  get legalFirstName() {
    return this.Get("legalFirstName");
  }
  set legalFirstName(val) {
    this.Set("legalFirstName", val);
  }
  get fullName() {
    return formatName(this.firstName, this.lastName, this.legalName, this.legalFirstName);
  }
};
parse_instance_browser_default.Object.registerSubclass("PatientIdentity", PatientIdentity);

// src/models/DischargeDestination/DischargeDestination.ts
var DischargeDestination = class extends ParseClass {
  constructor(attributes) {
    super("DischargeDestination", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get hl7Identifier() {
    return this.Get("hl7Identifier");
  }
  set hl7Identifier(val) {
    this.Set("hl7Identifier", val);
  }
  get isActive() {
    return this.Get("isActive");
  }
  set isActive(val) {
    this.Set("isActive", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("DischargeDestination", DischargeDestination);

// src/models/PerformerRequest/PerformerRequest.ts
var TERMINAL_PERFORMER_REQUEST_STATUSES = ["REJECTED", "REROUTED"];
var PerformerRequest = class extends ParseClass {
  constructor(attributes) {
    super("PerformerRequest", attributes);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get performer() {
    return this.Get("performer");
  }
  set performer(val) {
    this.Set("performer", val);
  }
  get rejectionReason() {
    return this.Get("rejectionReason");
  }
  set rejectionReason(val) {
    this.Set("rejectionReason", val);
  }
  get request() {
    return this.Get("request");
  }
  set request(val) {
    this.Set("request", val);
  }
  get fulfilledBy() {
    return this.Get("fulfilledBy");
  }
  set fulfilledBy(val) {
    this.Set("fulfilledBy", val);
  }
  get fulfilledAt() {
    return this.Get("fulfilledAt");
  }
  set fulfilledAt(val) {
    this.Set("fulfilledAt", val);
  }
  get createdBy() {
    return this.Get("createdBy");
  }
  set createdBy(val) {
    this.Set("createdBy", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("PerformerRequest", PerformerRequest);

// src/models/Porter.ts
var porterBreak = ["COFFEE_BREAK", "LUNCH_BREAK"];
var Porter = class extends ParseClass {
  constructor(attributes) {
    super("Porter", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get units() {
    return this.Get("units");
  }
  set units(val) {
    this.Set("units", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
  get lastActivityAt() {
    return this.Get("lastActivityAt");
  }
  set lastActivityAt(val) {
    this.Set("lastActivityAt", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get breakType() {
    return this.Get("breakType");
  }
  set breakType(val) {
    this.Set("breakType", val);
  }
  get breakStartedAt() {
    return this.Get("breakStartedAt");
  }
  set breakStartedAt(val) {
    this.Set("breakStartedAt", val);
  }
  get lastArea() {
    return this.Get("lastArea");
  }
  set lastArea(val) {
    this.Set("lastArea", val);
  }
  get lastUnit() {
    return this.Get("lastUnit");
  }
  set lastUnit(val) {
    this.Set("lastUnit", val);
  }
  get lastAreaAt() {
    return this.Get("lastAreaAt");
  }
  set lastAreaAt(val) {
    this.Set("lastAreaAt", val);
  }
  get nextArea() {
    return this.Get("nextArea");
  }
  set nextArea(val) {
    this.Set("nextArea", val);
  }
  get nextUnit() {
    return this.Get("nextUnit");
  }
  set nextUnit(val) {
    this.Set("nextUnit", val);
  }
  get fareAssignedCount() {
    return this.Get("fareAssignedCount");
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  resetFareAssignedCount() {
    this.Set("fareAssignedCount", 0);
  }
  incrementFareAssignedCount() {
    this.Set("fareAssignedCount", Number(this.Get("fareAssignedCount")) + 1);
  }
  decrementFareAssignedCount() {
    if (Number(this.Get("fareAssignedCount")) > 0) {
      this.Set("fareAssignedCount", Math.max(0, Number(this.Get("fareAssignedCount")) - 1));
    }
  }
  get fareDoneCount() {
    return this.Get("fareDoneCount");
  }
  resetFareDoneCount() {
    this.Set("fareDoneCount", 0);
  }
  incrementFareDoneCount() {
    this.Set("fareDoneCount", Number(this.Get("fareDoneCount")) + 1);
  }
  decrementFareDoneCount() {
    if (Number(this.Get("fareDoneCount")) > 0) {
      this.Set("fareDoneCount", Math.max(0, Number(this.Get("fareDoneCount")) - 1));
    }
  }
  get hasInternet() {
    return this.Get("hasInternet");
  }
  set hasInternet(val) {
    this.Set("hasInternet", val);
  }
  get lastFareDoneAt() {
    return this.Get("lastFareDoneAt");
  }
  set lastFareDoneAt(val) {
    this.Set("lastFareDoneAt", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Porter", Porter);

// src/models/Practitioner.ts
var Practitioner = class extends ParseClass {
  constructor(attributes) {
    super("Practitioner", attributes);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get units() {
    return this.Get("units");
  }
  set units(val) {
    this.Set("units", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get color() {
    return this.Get("color");
  }
  set color(val) {
    this.Set("color", val);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(val) {
    this.Set("identifiers", val);
  }
  get isArchived() {
    return this.Get("isArchived");
  }
  set isArchived(val) {
    this.Set("isArchived", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Practitioner", Practitioner);

// src/models/shared/contact.ts
var contactPointSystems = ["phone", "fax", "email", "url", "pager", "sms", "other"];
var contactPointUses = ["home", "work", "mobile", "temp", "old"];

// src/models/shared/exclusionReason.ts
var exclusionReasons = [
  // N'a jamais été une vraie structure : un emplacement « par défaut » créé par
  // le système source (codes sentinelles).
  "placeholder",
  // A été une vraie structure, puis vidée ou retirée (libellé mis à blanc côté
  // source, ou rattachée à un emplacement « par défaut »).
  "decommissioned",
  // Vraie structure active, mais hors du périmètre suivi.
  "out-of-scope",
  // Unité d'hébergement sans chambre en propre : elle ne peut pas restituer de lits.
  "no-room",
  // Nœud d'organisation dont aucune descendance n'est restituée : il n'encadre
  // rien dans le périmètre suivi.
  "no-descendant",
  // Exclue depuis l'espace d'administration, par décision d'un administrateur.
  "manual"
];

// src/models/Specialty.ts
var Specialty = class extends ParseClass {
  constructor(attributes) {
    super("Specialty", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get shortName() {
    return this.Get("shortName");
  }
  set shortName(val) {
    this.Set("shortName", val);
  }
  get quota() {
    return this.Get("quota");
  }
  set quota(val) {
    this.Set("quota", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Specialty", Specialty);

// src/models/Unit/ServiceConfig.ts
var serviceOrientations = ["vertical", "horizontal"];
var careSectorOverflowModes = ["scroll", "expand-columns"];
var roomAlignments = ["left", "center", "right"];
var encodeServiceConfigRoomKey = (roomName) => roomName.split(".").join("\uFF0E").split("$").join("\uFF04");
var decodeServiceConfigRoomKey = (roomKey) => roomKey.split("\uFF0E").join(".").split("\uFF04").join("$");
var mapKeys = (record, mapKey) => record && Object.fromEntries(Object.entries(record).map(([key, value]) => [mapKey(key), value]));
var mapCareSectorRoomKeys = (careSectorConfig, mapKey) => ({
  ...careSectorConfig,
  bedsByRoom: mapKeys(careSectorConfig.bedsByRoom, mapKey) ?? {},
  roomPositions: mapKeys(careSectorConfig.roomPositions, mapKey),
  bedPositionsInRooms: mapKeys(careSectorConfig.bedPositionsInRooms, mapKey),
  numberOfBedsPerRoom: mapKeys(careSectorConfig.numberOfBedsPerRoom, mapKey),
  roomAlignment: mapKeys(careSectorConfig.roomAlignment, mapKey)
});
var mapServiceConfigRoomKeys = (config, mapKey) => config && {
  ...config,
  careSectorsConfig: (config.careSectorsConfig || []).map(
    (careSectorConfig) => mapCareSectorRoomKeys(careSectorConfig, mapKey)
  )
};
var encodeServiceConfig = (config) => mapServiceConfigRoomKeys(config, encodeServiceConfigRoomKey);
var decodeServiceConfig = (config) => mapServiceConfigRoomKeys(config, decodeServiceConfigRoomKey);

// src/models/Unit/Unit.ts
var Unit = class extends ParseClass {
  constructor(attributes) {
    super("Unit", attributes);
  }
  get name() {
    return this.Get("name");
  }
  set name(val) {
    this.Set("name", val);
  }
  get identifiers() {
    return this.Get("identifiers");
  }
  set identifiers(val) {
    this.Set("identifiers", val);
  }
  get areas() {
    return this.Get("areas");
  }
  set areas(val) {
    this.Set("areas", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get requestFareConfirmation() {
    return this.Get("requestFareConfirmation");
  }
  set requestFareConfirmation(val) {
    this.Set("requestFareConfirmation", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get department() {
    return this.Get("department");
  }
  set department(val) {
    this.Set("department", val);
  }
  get externalTypeCode() {
    return this.Get("externalTypeCode");
  }
  set externalTypeCode(val) {
    this.Set("externalTypeCode", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get defaultFarePositionFromThis() {
    return this.Get("defaultFarePositionFromThis");
  }
  set defaultFarePositionFromThis(val) {
    this.Set("defaultFarePositionFromThis", val);
  }
  get occupancy() {
    return this.Get("occupancy");
  }
  set occupancy(val) {
    this.Set("occupancy", val);
  }
  get contacts() {
    return this.Get("contacts");
  }
  set contacts(val) {
    this.Set("contacts", val);
  }
  get specialties() {
    return this.Get("specialties");
  }
  set specialties(value) {
    this.Set("specialties", value);
  }
  get autoComputeOccupanciesActivated() {
    return this.Get("autoComputeOccupanciesActivated");
  }
  set autoComputeOccupanciesActivated(val) {
    this.Set("autoComputeOccupanciesActivated", val);
  }
  get responsibleUnits() {
    return this.Get("responsibleUnits");
  }
  set responsibleUnits(val) {
    this.Set("responsibleUnits", val);
  }
  get autoComputeDischarge() {
    return this.Get("autoComputeDischarge");
  }
  set autoComputeDischarge(val) {
    this.Set("autoComputeDischarge", val);
  }
  get isEmergency() {
    return this.Get("isEmergency");
  }
  set isEmergency(val) {
    this.Set("isEmergency", val);
  }
  get isMaternityUnit() {
    return this.Get("isMaternityUnit");
  }
  set isMaternityUnit(val) {
    this.Set("isMaternityUnit", val);
  }
  get isResponsibleUnit() {
    return this.Get("isResponsibleUnit");
  }
  set isResponsibleUnit(val) {
    this.Set("isResponsibleUnit", val);
  }
  get isTransitUnit() {
    return this.Get("isTransitUnit");
  }
  set isTransitUnit(val) {
    this.Set("isTransitUnit", val);
  }
  get manualOccupancyActivated() {
    return this.Get("manualOccupancyActivated");
  }
  set manualOccupancyActivated(val) {
    this.Set("manualOccupancyActivated", val);
  }
  get manualOccupancy() {
    return this.Get("manualOccupancy");
  }
  set manualOccupancy(val) {
    this.Set("manualOccupancy", val);
  }
  get defaultManualOccupancy() {
    return this.Get("defaultManualOccupancy");
  }
  set defaultManualOccupancy(val) {
    this.Set("defaultManualOccupancy", val);
  }
  get appliedManualOccupancyId() {
    return this.Get("appliedManualOccupancyId");
  }
  set appliedManualOccupancyId(val) {
    this.Set("appliedManualOccupancyId", val);
  }
  get careSectors() {
    return this.Get("careSectors");
  }
  set careSectors(val) {
    this.Set("careSectors", val);
  }
  get visibilityConfig() {
    return this.Get("visibilityConfig");
  }
  set visibilityConfig(val) {
    this.Set("visibilityConfig", val);
  }
  get medicalSpecialties() {
    return this.Get("medicalSpecialties");
  }
  set medicalSpecialties(val) {
    this.Set("medicalSpecialties", val);
  }
  get partOf() {
    return this.Get("partOf");
  }
  set partOf(val) {
    this.Set("partOf", val);
  }
  get partOfAncestors() {
    return this.Get("partOfAncestors");
  }
  set partOfAncestors(val) {
    this.Set("partOfAncestors", val);
  }
  get financialPartOf() {
    return this.Get("financialPartOf");
  }
  set financialPartOf(val) {
    this.Set("financialPartOf", val);
  }
  get financialPartOfAncestors() {
    return this.Get("financialPartOfAncestors");
  }
  set financialPartOfAncestors(val) {
    this.Set("financialPartOfAncestors", val);
  }
  get parents() {
    return this.Get("parents");
  }
  set parents(val) {
    this.Set("parents", val);
  }
  get parentsAncestors() {
    return this.Get("parentsAncestors");
  }
  set parentsAncestors(val) {
    this.Set("parentsAncestors", val);
  }
  get serviceConfig() {
    return decodeServiceConfig(this.Get("serviceConfig"));
  }
  set serviceConfig(val) {
    this.Set("serviceConfig", encodeServiceConfig(val));
  }
  get usePeriodStart() {
    return this.Get("usePeriodStart");
  }
  set usePeriodStart(val) {
    this.Set("usePeriodStart", val);
  }
  get usePeriodEnd() {
    return this.Get("usePeriodEnd");
  }
  set usePeriodEnd(val) {
    this.Set("usePeriodEnd", val);
  }
  get activityProfile() {
    return this.Get("activityProfile");
  }
  set activityProfile(val) {
    this.Set("activityProfile", val);
  }
  get ignoredAt() {
    return this.Get("ignoredAt");
  }
  set ignoredAt(val) {
    this.Set("ignoredAt", val);
  }
  get ignoredReasons() {
    return this.Get("ignoredReasons");
  }
  set ignoredReasons(val) {
    this.Set("ignoredReasons", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("Unit", Unit);

// src/models/Unit/UnitActivityProfile.ts
var hospitalizationModes = ["HC", "HDS"];
var compactActivityProfile = (profile) => Object.fromEntries(Object.entries(profile).filter(([, value]) => value != null));

// src/models/Unit/unit.helpers.ts
var isUnitActiveAt = (unit, date46) => {
  if (unit.ignoredAt) {
    return false;
  }
  const time = date46.getTime();
  return (!unit.usePeriodStart || unit.usePeriodStart.getTime() <= time) && (!unit.usePeriodEnd || time < unit.usePeriodEnd.getTime());
};
var isEmergencyUnit = (unit) => {
  return !!unit && (unit.type === "EMERGENCY" || !!unit.isEmergency);
};
var hasMedicalResponsibility = (unit) => unit.type === "MEDICAL_RESPONSIBILITY" || !!unit.isResponsibleUnit;

// src/models/Unit/UnitType.ts
var unitTypes = [
  /*
   * Types Silbo
   */
  "MEDICAL",
  // Unité médicale (legacy Silbo, garder pour rétrocompat)
  "ACCOMMODATION",
  // Hébergement
  "OTHER",
  // Autres
  "EMERGENCY",
  // Unité d'urgence
  "MEDICAL_RESPONSIBILITY",
  // Unité de responsabilité médicale
  "INTERNAL_STRUCTURE",
  // Structure interne générique
  /*
   * FHIR FR core (jeu de valeurs v2-3307).
   * https://hl7.fr/ig/fhir/core/CodeSystem-fr-core-cs-v2-3307.html
   */
  "GHT",
  // Groupement hospitalier de territoire
  "LEGAL_ENTITY",
  // Entité juridique
  "GEOGRAPHICAL_ENTITY",
  // Établissement géographique
  "SOIN",
  // Soin
  "ADMINISTRATIF",
  // Administratif
  "SERVICE",
  // Service
  "UM",
  // Unité médicale (FHIR v2-3307)
  "UAC",
  // Unité d'activité (FHIR v2-3307)
  "UF",
  // Unité fonctionnelle
  "POLE",
  // Pôle
  "CENTRE_RESP",
  // Centre de responsabilité (FHIR v2-3307)
  /*
   * Spécifique établissement
   */
  "UH"
  // Unité hospitalière
];

// src/models/Unit/UnitVisibility.ts
var unitVisibilityConfigOptions = ["healthCenter", "bedManagement", "patientTransport", "emergency"];

// src/models/UnitHistory.ts
var UnitHistory = class extends ParseClass {
  constructor(attributes) {
    super("UnitHistory", attributes);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get data() {
    return this.Get("data");
  }
  set data(val) {
    this.Set("data", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UnitHistory", UnitHistory);

// src/models/UnitManualOccupancy.ts
var UnitManualOccupancy = class extends ParseClass {
  constructor(attributes) {
    super("UnitManualOccupancy", attributes);
  }
  get open() {
    return this.Get("open");
  }
  set open(val) {
    this.Set("open", val);
  }
  get default() {
    return this.Get("default");
  }
  set default(val) {
    this.Set("default", val);
  }
  get closed() {
    return this.Get("closed");
  }
  set closed(val) {
    this.Set("closed", val);
  }
  get additional() {
    return this.Get("additional");
  }
  set additional(val) {
    this.Set("additional", val);
  }
  get installed() {
    return this.Get("installed");
  }
  set installed(val) {
    this.Set("installed", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get startDate() {
    return this.Get("startDate");
  }
  set startDate(val) {
    this.Set("startDate", val);
  }
  get endDate() {
    return this.Get("endDate");
  }
  set endDate(val) {
    this.Set("endDate", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get bedClosingReason() {
    return this.Get("bedClosingReason");
  }
  set bedClosingReason(val) {
    this.Set("bedClosingReason", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UnitManualOccupancy", UnitManualOccupancy);

// src/models/UnitOccupancy/UnitOccupancy.ts
var UnitOccupancy = class extends ParseClass {
  constructor(attributes) {
    super("UnitOccupancy", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get comment() {
    return this.Get("comment");
  }
  set comment(val) {
    this.Set("comment", val);
  }
  get covid() {
    return this.Get("covid");
  }
  set covid(val) {
    this.Set("covid", val);
  }
  get isolated() {
    return this.Get("isolated");
  }
  set isolated(val) {
    this.Set("isolated", val);
  }
  get isolatedAir() {
    return this.Get("isolatedAir");
  }
  set isolatedAir(val) {
    this.Set("isolatedAir", val);
  }
  get isolatedDroplet() {
    return this.Get("isolatedDroplet");
  }
  set isolatedDroplet(val) {
    this.Set("isolatedDroplet", val);
  }
  get isolatedContact() {
    return this.Get("isolatedContact");
  }
  set isolatedContact(val) {
    this.Set("isolatedContact", val);
  }
  get isolatedProtector() {
    return this.Get("isolatedProtector");
  }
  set isolatedProtector(val) {
    this.Set("isolatedProtector", val);
  }
  get accomodated() {
    return this.Get("accomodated");
  }
  set accomodated(val) {
    this.Set("accomodated", val);
  }
  get waitingForDownstreamBed() {
    return this.Get("waitingForDownstreamBed");
  }
  set waitingForDownstreamBed(val) {
    this.Set("waitingForDownstreamBed", val);
  }
  get open() {
    return this.Get("open");
  }
  set open(val) {
    this.Set("open", val);
  }
  get h24Open() {
    return this.Get("h24Open");
  }
  set h24Open(val) {
    this.Set("h24Open", val);
  }
  get h48Open() {
    return this.Get("h48Open");
  }
  set h48Open(val) {
    this.Set("h48Open", val);
  }
  get close() {
    return this.Get("close");
  }
  set close(val) {
    this.Set("close", val);
  }
  get h24Close() {
    return this.Get("h24Close");
  }
  set h24Close(val) {
    this.Set("h24Close", val);
  }
  get h48Close() {
    return this.Get("h48Close");
  }
  set h48Close(val) {
    this.Set("h48Close", val);
  }
  get booked() {
    return this.Get("booked");
  }
  set booked(val) {
    this.Set("booked", val);
  }
  get h24Booked() {
    return this.Get("h24Booked");
  }
  set h24Booked(val) {
    this.Set("h24Booked", val);
  }
  get h48Booked() {
    return this.Get("h48Booked");
  }
  set h48Booked(val) {
    this.Set("h48Booked", val);
  }
  get admission() {
    return this.Get("admission");
  }
  set admission(val) {
    this.Set("admission", val);
  }
  get discharge() {
    return this.Get("discharge");
  }
  set discharge(val) {
    this.Set("discharge", val);
  }
  get dDaySupernumerary() {
    return this.Get("dDaySupernumerary");
  }
  set dDaySupernumerary(val) {
    this.Set("dDaySupernumerary", val);
  }
  get h24Supernumerary() {
    return this.Get("h24Supernumerary");
  }
  set h24Supernumerary(val) {
    this.Set("h24Supernumerary", val);
  }
  get h48Supernumerary() {
    return this.Get("h48Supernumerary");
  }
  set h48Supernumerary(val) {
    this.Set("h48Supernumerary", val);
  }
  get dDayAvailabilities() {
    return this.Get("dDayAvailabilities");
  }
  set dDayAvailabilities(val) {
    this.Set("dDayAvailabilities", val);
  }
  get h24Availabilities() {
    return this.Get("h24Availabilities");
  }
  set h24Availabilities(val) {
    this.Set("h24Availabilities", val);
  }
  get h48Availabilities() {
    return this.Get("h48Availabilities");
  }
  set h48Availabilities(val) {
    this.Set("h48Availabilities", val);
  }
  get dDayRoomAvailabilities() {
    return this.Get("dDayRoomAvailabilities");
  }
  set dDayRoomAvailabilities(val) {
    this.Set("dDayRoomAvailabilities", val);
  }
  get h24RoomAvailabilities() {
    return this.Get("h24RoomAvailabilities");
  }
  set h24RoomAvailabilities(val) {
    this.Set("h24RoomAvailabilities", val);
  }
  get h48RoomAvailabilities() {
    return this.Get("h48RoomAvailabilities");
  }
  set h48RoomAvailabilities(val) {
    this.Set("h48RoomAvailabilities", val);
  }
  get currentOccupancy() {
    return this.Get("currentOccupancy");
  }
  set currentOccupancy(val) {
    this.Set("currentOccupancy", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UnitOccupancy", UnitOccupancy);

// src/models/UnitSpecialty.ts
var unitSectors = [
  "Chirurgie",
  "M\xE9decine",
  "Obst\xE9trique",
  "R\xE9animation",
  "Urgences",
  "SMR",
  "PSY",
  "P\xE9diatrie",
  "HAD"
];
var unitSpecialties = [
  "Chirurgie cardiaque",
  "Chirurgie cervico-faciale",
  "Chirurgie g\xE9n\xE9rale",
  "Chirurgie infantile",
  "Chirurgie maxillo-faciale et stomatologie",
  "Chirurgie orthop\xE9dique et traumatologie",
  "Chirurgie plastique",
  "Chirurgie thoracique et cardio-vasculaire",
  "Chirurgie urologique",
  "Chirurgie vasculaire",
  "Chirurgie visc\xE9rale et digestive",
  "Neurochirurgie",
  "Addictologie",
  "Allergologie et immunologie",
  "Anatomie et Cytologie pathologiques",
  "Anesth\xE9sie",
  "Biologie m\xE9dicale",
  "Br\xFBlologie",
  "Cardiologie",
  "Dermatologie",
  "Endocrinologie et m\xE9tabolisme",
  "H\xE9pato-Gastro-Ent\xE9rologie",
  "G\xE9n\xE9tique",
  "G\xE9riatrie",
  "HAD",
  "H\xE9matologie",
  "Imagerie m\xE9dicale",
  "Maladies infectieuses",
  "Maladies tropicales",
  "M\xE9decine a\xE9rospatiale-a\xE9ronautique",
  "M\xE9decine du sport",
  "M\xE9decine du travail",
  "M\xE9decine g\xE9n\xE9rale",
  "M\xE9decine hyperbare",
  "M\xE9decine interne",
  "M\xE9decine l\xE9gale",
  "M\xE9decine nucl\xE9aire",
  "M\xE9decine p\xE9nitentiaire",
  "M\xE9decine polyvalente",
  "M\xE9decine post urgence",
  "M\xE9decine sp\xE9cialis\xE9e",
  "M\xE9decine vasculaire, angiologie, phl\xE9bologie",
  "N\xE9phrologie",
  "Neurologie",
  "Neuropediatrie",
  "Oncologie",
  "Ophtalmologie",
  "ORL",
  "P\xE9diatrie",
  "Pneumologie",
  "Rhumatologie",
  "Sant\xE9 publique et M\xE9decine sociale",
  "Soins palliatifs",
  "Transfusion",
  "Gyn\xE9cologie-obst\xE9trique",
  "N\xE9onatologie",
  "Maternit\xE9",
  "UHCD",
  "Urgences",
  "M\xE9decine physique et de r\xE9adaptation adulte",
  "M\xE9decine physique et de r\xE9adaptation enfant",
  "Soins de suite sp\xE9cialis\xE9s et polyvalents",
  "R\xE9animation polyvalente",
  "USC - Unit\xE9 de Surveillance Continue",
  "USI - Unit\xE9 de Soins Intensifs",
  "P\xE9dopsychiatrie",
  "Neuropsychiatrie",
  "Psychiatrie",
  "Court s\xE9jour g\xE9riatrique"
];
var specialtiesBySector = {
  Chirurgie: [
    "Chirurgie cardiaque",
    "Chirurgie cervico-faciale",
    "Chirurgie g\xE9n\xE9rale",
    "Chirurgie infantile",
    "Chirurgie maxillo-faciale et stomatologie",
    "Chirurgie orthop\xE9dique et traumatologie",
    "Chirurgie plastique",
    "Chirurgie thoracique et cardio-vasculaire",
    "Chirurgie urologique",
    "Chirurgie vasculaire",
    "Chirurgie visc\xE9rale et digestive",
    "Neurochirurgie"
  ],
  M\u00E9decine: [
    "Addictologie",
    "Allergologie et immunologie",
    "Anatomie et Cytologie pathologiques",
    "Anesth\xE9sie",
    "Biologie m\xE9dicale",
    "Br\xFBlologie",
    "Cardiologie",
    "Dermatologie",
    "Endocrinologie et m\xE9tabolisme",
    "H\xE9pato-Gastro-Ent\xE9rologie",
    "G\xE9n\xE9tique",
    "G\xE9riatrie",
    "H\xE9matologie",
    "Imagerie m\xE9dicale",
    "Maladies infectieuses",
    "Maladies tropicales",
    "M\xE9decine a\xE9rospatiale-a\xE9ronautique",
    "M\xE9decine du sport",
    "M\xE9decine du travail",
    "M\xE9decine g\xE9n\xE9rale",
    "M\xE9decine hyperbare",
    "M\xE9decine interne",
    "M\xE9decine l\xE9gale",
    "M\xE9decine nucl\xE9aire",
    "M\xE9decine p\xE9nitentiaire",
    "M\xE9decine polyvalente",
    "M\xE9decine post urgence",
    "M\xE9decine sp\xE9cialis\xE9e",
    "M\xE9decine vasculaire, angiologie, phl\xE9bologie",
    "N\xE9phrologie",
    "Neurologie",
    "Neuropediatrie",
    "Oncologie",
    "Ophtalmologie",
    "ORL",
    "P\xE9diatrie",
    "Pneumologie",
    "Rhumatologie",
    "Sant\xE9 publique et M\xE9decine sociale",
    "Soins palliatifs",
    "Transfusion",
    "Court s\xE9jour g\xE9riatrique"
  ],
  Obst\u00E9trique: ["Gyn\xE9cologie-obst\xE9trique", "N\xE9onatologie", "Maternit\xE9"],
  Urgences: ["UHCD", "Urgences"],
  SMR: [
    "M\xE9decine physique et de r\xE9adaptation adulte",
    "M\xE9decine physique et de r\xE9adaptation enfant",
    "Soins de suite sp\xE9cialis\xE9s et polyvalents"
  ],
  R\u00E9animation: ["R\xE9animation polyvalente", "USC - Unit\xE9 de Surveillance Continue", "USI - Unit\xE9 de Soins Intensifs"],
  PSY: ["P\xE9dopsychiatrie", "Neuropsychiatrie", "Psychiatrie"],
  P\u00E9diatrie: [],
  HAD: ["HAD"]
};
var getSpecialtiesBySectors = (sectors) => {
  const specialties = /* @__PURE__ */ new Set();
  sectors.forEach((sector) => {
    const sectorSpecialties = getSpecialtiesBySector(sector);
    sectorSpecialties.forEach((sectorSpecialty) => specialties.add(sectorSpecialty));
  });
  return Array.from(specialties);
};
var getSpecialtiesBySector = (sector) => {
  return specialtiesBySector[sector];
};
var getSectorBySpecialty = (specialty) => {
  for (const key in specialtiesBySector) {
    const sector = key;
    const sectorSpecialities = specialtiesBySector[sector];
    if (sectorSpecialities.includes(specialty)) {
      return sector;
    }
  }
  throw new Error(`No sector found for speciality ${specialty}`);
};
var getSectorsBySpecialties = (specialties = []) => {
  return Array.from(new Set(specialties.map(getSectorBySpecialty).filter((specialty) => specialty !== void 0)));
};

// src/models/User.ts
var webUserRoles = [...["REGULATOR", "MANAGER", "ADMIN_REGULATOR", "ADMIN", "BED_MANAGER"]];
var userRoles = [...[...webUserRoles, "PORTER"]];
var User = class extends ParseUser {
  constructor(attributes) {
    super(attributes);
  }
  get username() {
    return this.Get("username");
  }
  set username(val) {
    this.Set("username", val);
  }
  get password() {
    return this.Get("password");
  }
  set password(val) {
    this.Set("password", val);
  }
  get email() {
    return this.Get("email");
  }
  set email(val) {
    this.Set("email", val);
  }
  get firstName() {
    return this.Get("firstName");
  }
  set firstName(val) {
    this.Set("firstName", val);
  }
  get lastName() {
    return this.Get("lastName");
  }
  set lastName(val) {
    this.Set("lastName", val);
  }
  get role() {
    return this.Get("role");
  }
  set role(val) {
    this.Set("role", val);
  }
  get porter() {
    return this.Get("porter");
  }
  set porter(val) {
    this.Set("porter", val);
  }
  get healthCenters() {
    return this.Get("healthCenters");
  }
  set healthCenters(val) {
    this.Set("healthCenters", val);
  }
  get unit() {
    return this.Get("unit");
  }
  set unit(val) {
    this.Set("unit", val);
  }
  get units() {
    return this.Get("units");
  }
  set units(val) {
    this.Set("units", val);
  }
  get notificationConfigurations() {
    return this.Get("notificationConfigurations");
  }
  set notificationConfigurations(val) {
    this.Set("notificationConfigurations", val);
  }
  get profile() {
    return this.Get("profile");
  }
  set profile(val) {
    this.Set("profile", val);
  }
  get navigationACL() {
    return this.Get("navigationACL");
  }
  set navigationACL(val) {
    this.Set("navigationACL", val);
  }
  get isReadOnly() {
    return this.Get("isReadOnly");
  }
  set isReadOnly(val) {
    this.Set("isReadOnly", val);
  }
  get whitelistedIPs() {
    return this.Get("whitelistedIPs");
  }
  set whitelistedIPs(val) {
    this.Set("whitelistedIPs", val);
  }
  get disabled() {
    return this.Get("disabled");
  }
  set disabled(val) {
    this.Set("disabled", val);
  }
  get disabledAt() {
    return this.Get("disabledAt");
  }
  set disabledAt(val) {
    this.Set("disabledAt", val);
  }
  get disabledReason() {
    return this.Get("disabledReason");
  }
  set disabledReason(val) {
    this.Set("disabledReason", val);
  }
  get lastConnectionAt() {
    return this.Get("lastConnectionAt");
  }
  set lastConnectionAt(val) {
    this.Set("lastConnectionAt", val);
  }
  get externalAuthConfig() {
    return this.Get("externalAuthConfig");
  }
  set externalAuthConfig(val) {
    this.Set("externalAuthConfig", val);
  }
  get config() {
    return this.Get("config");
  }
  set config(val) {
    this.Set("config", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("_User", User);

// src/models/UserConfig.ts
var patientPlacementViews = ["day", "week"];
var UserConfig = class extends ParseClass {
  constructor(attributes) {
    super("UserConfig", attributes);
  }
  get healthCenters() {
    return this.Get("healthCenters");
  }
  set healthCenters(val) {
    this.Set("healthCenters", val);
  }
  get lastSelectedUnits() {
    return this.Get("lastSelectedUnits");
  }
  set lastSelectedUnits(val) {
    this.Set("lastSelectedUnits", val);
  }
  get lastSelectedEmergencyUnits() {
    return this.Get("lastSelectedEmergencyUnits");
  }
  set lastSelectedEmergencyUnits(val) {
    this.Set("lastSelectedEmergencyUnits", val);
  }
  get patientPlacementView() {
    return this.Get("patientPlacementView");
  }
  set patientPlacementView(val) {
    this.Set("patientPlacementView", val);
  }
  get serviceViewZoomLevel() {
    return this.Get("serviceViewZoomLevel");
  }
  set serviceViewZoomLevel(val) {
    this.Set("serviceViewZoomLevel", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UserConfig", UserConfig);

// src/models/UserHealthCenterConfig.ts
var UserHealthCenterConfig = class extends ParseClass {
  constructor(attributes) {
    super("UserHealthCenterConfig", attributes);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get profile() {
    return this.Get("profile");
  }
  set profile(val) {
    this.Set("profile", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("UserHealthCenterConfig", UserHealthCenterConfig);

// src/models/View/types.ts
var unitViewsTypes = ["list", "grid", "timeline"];
var periods = ["day", "week"];
var movementTypesFilters = [
  "SCHEDULED_ADMISSION",
  "SCHEDULED_DISCHARGE",
  "INTERNAL_MUTATION",
  "DIRECT_ADMISSION"
];
var movementStatusesFilters = [
  "accommodation_to_assign",
  "accommodation_assigned",
  "accommodation_admitted",
  "accommodation_planned_discharge",
  "accommodation_confirmed_discharge",
  "accommodation_discharged",
  "incoming_mutation_requested",
  "outgoing_mutation_requested",
  "outgoing_mutation_blocked"
];
var movementsViewTypes = ["kanban", "list", "sheets"];
var movementsFlowTypes = ["admission", "discharge"];
var patientCreationOrigins = ["MANUAL", "AUTO"];
var healthCenterFlowTypes = ["departments", "emergency", "specialties"];
var occupancyFiltersType = ["LOWER_THAN_RATE", "BETWEEN_RATES", "GREATER_THAN_RATE"];
var emergencyPages = ["present-patients", "night-and-weekend", "hospitalizations"];
var territoryFlowTypes = ["departments", "emergency"];
var territoryViewTypes = ["map", "list"];
var requestsDisplayedTypes = ["DIRECT_ADMISSION", "INTERNAL_MUTATION"];
var requestStatuses = [
  "TO_ROUTE",
  "REQUESTED",
  "REJECTED",
  "ACCEPTED",
  "VALIDATED",
  "COMPLETED",
  "CANCELLED"
];
var defaultRequestStatuses = requestStatuses.filter(
  (status) => status !== "COMPLETED" && status !== "CANCELLED"
);
var requestsCreatedSinceOptions = ["1_HOUR", "6_HOURS", "12_HOURS", "24_HOURS", "48_HOURS"];
var requestsCreatedSinceDirections = ["LESS_THAN", "MORE_THAN"];
var defaultFilterByType = {
  unit: {
    units: [],
    statuses: [],
    genders: [],
    specificities: [],
    locationSpecificities: [],
    medicalSpecialties: [],
    practitioners: [],
    patientOutcomes: [],
    medicallyOutgoing: [],
    accommodated: [],
    view: "grid",
    period: "week",
    date: null,
    search: ""
  },
  service: {
    units: [],
    statuses: [],
    genders: [],
    specificities: [],
    locationSpecificities: [],
    medicalSpecialties: [],
    careSectors: [],
    practitioners: [],
    patientOutcomes: [],
    medicallyOutgoing: [],
    accommodated: [],
    view: "grid",
    period: "week",
    date: null,
    search: ""
  },
  movements: {
    units: [],
    genders: [],
    specificities: [],
    date: null,
    flow: "admission",
    view: "kanban",
    search: "",
    movementTypes: [],
    movementStatuses: [],
    practitioners: [],
    creationOrigin: [],
    medicallyOutgoing: [],
    accommodated: []
  },
  healthCenter: {
    units: [],
    occupancies: [],
    specialties: [],
    medicalSpecialties: [],
    flow: "departments"
  },
  territory: {
    healthCenters: [],
    sectors: [],
    tensions: [],
    flow: "departments",
    view: "list"
  },
  emergency: {
    units: [],
    page: "present-patients",
    search: "",
    statuses: [],
    genders: [],
    specificities: [],
    practitioners: [],
    accommodated: []
  },
  requests: {
    types: [],
    requestStatuses: defaultRequestStatuses,
    orientationUnitIds: [],
    originUnitIds: [],
    destinationUnitIds: [],
    createdSince: null,
    createdSinceDirection: null,
    specificities: [],
    accommodated: [],
    search: ""
  }
};

// src/models/View/View.ts
var configurableViewTypes = [
  "unit",
  "service",
  "movements",
  "emergency",
  "healthCenter",
  "territory",
  "requests"
];
var View = class extends ParseClass {
  constructor(attributes) {
    super("View", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get type() {
    return this.Get("type");
  }
  set type(val) {
    this.Set("type", val);
  }
  get metadata() {
    return this.Get("metadata");
  }
  set metadata(val) {
    this.Set("metadata", val);
  }
  get filter() {
    return this.Get("filter");
  }
  set filter(val) {
    this.Set("filter", val);
  }
  get user() {
    return this.Get("user");
  }
  set user(val) {
    this.Set("user", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("View", View);

// src/cloud/assign-dashboard-to-slot/assign-dashboard-to-slot.ts
import * as Yup3 from "yup";

// src/cloud/utils/build-cloud-function-runner.ts
var buildCloudFunctionRunner = (functionName) => (params, options) => parse_instance_browser_default.Cloud.run(functionName, params, options);

// src/cloud/assign-dashboard-to-slot/assign-dashboard-to-slot.ts
var AssignDashboardToSlotValidation = Yup3.object({
  healthCenterId: Yup3.string().required(),
  slotKey: Yup3.string().oneOf(SLOT_KEYS).required(),
  dashboardId: Yup3.string().required(),
  cacheDurationMs: Yup3.number().integer().min(0).max(MAX_SLOT_CACHE_DURATION_MS),
  refreshIntervalMs: Yup3.number().integer().min(0).max(MAX_SLOT_REFRESH_INTERVAL_MS)
});
var assignDashboardToSlotRoute = "assign-dashboard-to-slot";
var assignDashboardToSlot = buildCloudFunctionRunner(assignDashboardToSlotRoute);

// src/cloud/bedClosingReason/createBedClosingReason.ts
import * as Yup4 from "yup";
var CreateBedClosingReasonValidation = Yup4.object({
  healthCenterId: Yup4.string().required(),
  name: Yup4.string().required(),
  description: Yup4.string(),
  externalId: Yup4.string(),
  type: Yup4.mixed().oneOf([...BED_REASON_TYPES])
});
var createBedClosingReason = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-bed-closing-reason",
    params,
    options
  );
};

// src/cloud/bedClosingReason/deleteBedClosingReason.ts
import * as Yup5 from "yup";
var DeleteBedClosingReasonValidation = Yup5.object({
  id: Yup5.string().required()
});
var deleteBedClosingReason = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "delete-bed-closing-reason",
    params,
    options
  );
};

// src/cloud/bedClosingReason/updateBedClosingReason.ts
import * as Yup6 from "yup";
var UpdateBedClosingReasonValidation = Yup6.object({
  id: Yup6.string().required(),
  name: Yup6.string(),
  description: Yup6.string().notRequired(),
  externalId: Yup6.string().nullable()
});
var updateBedClosingReason = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-bed-closing-reason",
    params,
    options
  );
};

// src/cloud/cancel-bed-block/cancel-bed-block.ts
import * as Yup7 from "yup";
var CancelBedBlockValidation = Yup7.object({
  bedBlockId: Yup7.string().required()
});
var cancelBedBlockRoute = "cancel-bed-block";
var cancelBedBlock = buildCloudFunctionRunner(
  cancelBedBlockRoute
);

// src/cloud/cancel-reservation/cancel-reservation.ts
import * as Yup8 from "yup";
var CancelReservationValidation = Yup8.object({
  reservationId: Yup8.string().required()
});
var cancelReservationRoute = "cancel-reservation";
var cancelReservation = buildCloudFunctionRunner(
  cancelReservationRoute
);

// src/cloud/cancelPerformerRequestAcceptation.ts
import * as Yup9 from "yup";
var CancelPerformerRequestAcceptationValidation = Yup9.object({
  performerRequestId: Yup9.string().required()
});
var cancelPerformerRequestAcceptation = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "cancel-performer-request-acceptation",
    params,
    options
  );
};

// src/cloud/careSector/updateCareSector.ts
import * as Yup10 from "yup";
var UpdateCareSectorValidation = Yup10.object({
  id: Yup10.string().required(),
  name: Yup10.string().required()
});
var updateCareSector = (params, options) => parse_instance_browser_default.Cloud.run("update-care-sector", params, options);

// src/cloud/careSector/createCareSector.ts
import * as Yup11 from "yup";
var createCareSectorValidation = Yup11.object({
  unitId: Yup11.string().required(),
  name: Yup11.string().required()
});
var createCareSector = (params, options) => parse_instance_browser_default.Cloud.run("create-care-sector", params, options);

// src/cloud/careSector/deleteCareSector.ts
import * as Yup12 from "yup";
var DeleteCareSectorValidation = Yup12.object({
  id: Yup12.string().required()
});
var deleteCareSector = (params, options) => parse_instance_browser_default.Cloud.run("delete-care-sector", params, options);

// src/cloud/create-bed-block/create-bed-block.ts
import * as Yup13 from "yup";

// src/locales/fr.ts
var errorTranslations = {
  CONNECTION_FAILED: "Erreur de connexion"
};
var translations = {
  patientRequired: "Veuillez s\xE9lectionner un patient",
  unitRequired: "Veuillez s\xE9lectionner une unit\xE9",
  dateRequired: 'Veuillez s\xE9lectionner une date et une heure ou d\xE9finir la mission comme "Urgente"',
  positionRequired: "Veuillez s\xE9lectionner une position pour le transport",
  atLeastOneProperty: "Au moins une propri\xE9t\xE9 doit \xEAtre pr\xE9ciser",
  fareIdRequired: "Veuillez s\xE9lectionner un identifiant de mission",
  porterIdRequired: "Veuillez s\xE9lectionner un identifiant du brancardier",
  unitIdRequired: "Veuillez s\xE9lectionner l'identifiants de l'unit\xE9e",
  breakTypeRequired: "Veuillez s\xE9lectionner le type de pause",
  endAtMustBeAfterStartAt: "La date de fin doit \xEAtre apr\xE8s la date de d\xE9but",
  manualOccupancyCanNotBeNegative: "Le capacitaire ne peut pas \xEAtre n\xE9gatif",
  searchPatientAtLeastOneFieldRequired: "Au moins un des champs suivants est requis: IPP, PAN, pr\xE9nom, nom ou date de naissance",
  ...errorTranslations,
  bedClosingReasonOnlyOnClosedBed: "Le motif de fermeture de lit ne peut \xEAtre renseign\xE9 que sur une fermeture de lit",
  crisisBannerTitleRequired: "Le titre de la banni\xE8re de crise est requis lorsque la banni\xE8re de crise est activ\xE9e",
  crisisBannerColorRequired: "La couleur de la banni\xE8re de crise est requise lorsque la banni\xE8re de crise est activ\xE9e",
  atLeastOneField: "Au moins un champ doit \xEAtre renseign\xE9",
  invalidViewFilter: "Le type de filtre de la vue est invalide",
  nameFieldRequired: "Le champ nom est requis",
  unitManualOccupancyFieldRequired: "Au moins un identifiant doit \xEAtre renseign\xE9",
  healthCenterIdRequiredForExternalId: "L'identifiant de l'\xE9tablissement est requis lors de l'utilisation d'un identifiant externe",
  missingIdentifier: "Un identifiant (Silbo ou externe) est requis"
};

// src/locales/index.ts
var languageMap = {
  fr_FR: translations
};
var i18n = languageMap["fr_FR"];

// src/cloud/create-bed-block/create-bed-block.ts
var CreateBedBlockValidation = Yup13.object({
  bedId: Yup13.string().required(),
  startAt: Yup13.date().required(),
  endAt: Yup13.date().min(Yup13.ref("startAt"), i18n.endAtMustBeAfterStartAt),
  comment: Yup13.string(),
  customSpecificityIds: Yup13.array(Yup13.string().required()),
  reasonId: Yup13.string()
});
var createBedBlockRoute = "create-bed-block";
var createBedBlock = buildCloudFunctionRunner(
  createBedBlockRoute
);

// src/cloud/create-capacity-period/create-capacity-period.ts
import * as Yup14 from "yup";
var WeeklySlotValidation = Yup14.object({
  startMinuteOfWeek: Yup14.number().integer().min(0).max(MINUTES_PER_WEEK).required(),
  endMinuteOfWeek: Yup14.number().integer().min(0).max(MINUTES_PER_WEEK).required(),
  value: Yup14.number().required()
});
var CreateCapacityPeriodValidation = Yup14.object({
  organizationId: Yup14.string().required(),
  type: Yup14.mixed().oneOf([...capacityPeriodTypes]).required(),
  value: Yup14.number().required(),
  startDate: Yup14.date().required(),
  endDate: Yup14.date(),
  slots: Yup14.array().of(WeeklySlotValidation.required()),
  reasonId: Yup14.string(),
  reasonText: Yup14.string(),
  externalId: Yup14.string()
});
var createCapacityPeriodRoute = "create-capacity-period";
var createCapacityPeriod = buildCloudFunctionRunner(
  createCapacityPeriodRoute
);

// src/cloud/create-dashboard/create-dashboard.ts
import * as Yup17 from "yup";

// src/cloud/update-dashboard/dashboard-widget-validation.ts
import * as Yup16 from "yup";

// src/utils/dashboard/column-thresholds.utils.ts
var overlaps = (left, right) => {
  const leftMin = left.min ?? Number.NEGATIVE_INFINITY;
  const leftMax = left.max ?? Number.POSITIVE_INFINITY;
  const rightMin = right.min ?? Number.NEGATIVE_INFINITY;
  const rightMax = right.max ?? Number.POSITIVE_INFINITY;
  return leftMin < rightMax && rightMin < leftMax;
};
var isEmptyRange = (threshold) => threshold.min !== void 0 && threshold.max !== void 0 && threshold.min >= threshold.max;
var invalidThresholdIndexes = (thresholds) => {
  if (!thresholds?.length) {
    return [];
  }
  const invalid = /* @__PURE__ */ new Set();
  thresholds.forEach((threshold, index) => {
    if (isEmptyRange(threshold)) {
      invalid.add(index);
      return;
    }
    thresholds.forEach((other, otherIndex) => {
      if (otherIndex !== index && !isEmptyRange(other) && overlaps(threshold, other)) {
        invalid.add(index);
      }
    });
  });
  return [...invalid].sort((left, right) => left - right);
};
var resolveThresholdMode = (settings) => settings?.thresholdMode ?? "number";
var invalidTextThresholdIndexes = (textThresholds) => {
  if (!textThresholds?.length) {
    return [];
  }
  const occurrences = /* @__PURE__ */ new Map();
  textThresholds.forEach(({ value }) => occurrences.set(value, (occurrences.get(value) ?? 0) + 1));
  return textThresholds.flatMap((threshold, index) => (occurrences.get(threshold.value) ?? 0) > 1 ? [index] : []);
};
var invalidColumnThresholdIndexes = (settings) => resolveThresholdMode(settings) === "text" ? invalidTextThresholdIndexes(settings?.textThresholds) : invalidThresholdIndexes(settings?.thresholds);
var areColumnThresholdsValid = (settings) => invalidThresholdIndexes(settings?.thresholds).length === 0 && invalidTextThresholdIndexes(settings?.textThresholds).length === 0;

// src/cloud/validations/widgetDerivedColumn.ts
import * as Yup15 from "yup";
var RateColumnValidation = Yup15.object({
  column: Yup15.string().required(),
  formula: Yup15.mixed().oneOf(["rate"]).required(),
  numerator: Yup15.string().required(),
  denominator: Yup15.string().required()
});
var ClampedDiffColumnValidation = Yup15.object({
  column: Yup15.string().required(),
  formula: Yup15.mixed().oneOf(["clampedDiff"]).required(),
  minuend: Yup15.string().required(),
  subtrahend: Yup15.string().required()
});
var WidgetDerivedColumnValidation = Yup15.lazy(
  (value) => value?.formula === "clampedDiff" ? ClampedDiffColumnValidation : RateColumnValidation
);

// src/cloud/update-dashboard/dashboard-widget-validation.ts
var commonOptionFields = {
  // Coerce any unrecognized value to undefined instead of rejecting
  // it, so editing an old dashboard's widgets doesn't fail validation
  colSpan: Yup16.mixed().transform((value) => WIDGET_COL_SPAN.includes(value) ? value : void 0).oneOf([...WIDGET_COL_SPAN]),
  hideTitle: Yup16.boolean(),
  hideBorder: Yup16.boolean()
};
var isString = (value) => typeof value === "string";
var isRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
var isFiniteNumber = (value) => typeof value === "number" && Number.isFinite(value);
var isValidColumnRenderer = (renderer) => {
  if (!isRecord(renderer) || !isString(renderer.type)) {
    return false;
  }
  if (!COLUMN_RENDERER_TYPES.some((rendererType) => rendererType === renderer.type)) {
    return false;
  }
  if (renderer.type === "boolean") {
    return (renderer.trueLabel === void 0 || isString(renderer.trueLabel)) && (renderer.falseLabel === void 0 || isString(renderer.falseLabel));
  }
  if (renderer.type === "badge") {
    const { colorByValue } = renderer;
    return colorByValue === void 0 || isRecord(colorByValue) && Object.values(colorByValue).every(isString);
  }
  return true;
};
var isValidColumnThresholds = (thresholds) => Array.isArray(thresholds) && thresholds.every((threshold) => {
  if (!isRecord(threshold)) {
    return false;
  }
  const { min, max } = threshold;
  return COLUMN_THRESHOLD_COLORS.some((candidate) => candidate === threshold.color) && (min === void 0 || isFiniteNumber(min)) && (max === void 0 || isFiniteNumber(max));
});
var isValidTextThresholds = (textThresholds) => Array.isArray(textThresholds) && textThresholds.every(
  (threshold) => isRecord(threshold) && isString(threshold.value) && COLUMN_THRESHOLD_COLORS.some((candidate) => candidate === threshold.color)
);
var isValidColumnThresholdSettings = (column) => {
  const { thresholdMode, thresholds, textThresholds } = column;
  if (thresholdMode !== void 0 && !COLUMN_THRESHOLD_MODES.some((mode) => mode === thresholdMode)) {
    return false;
  }
  if (thresholds !== void 0 && !isValidColumnThresholds(thresholds)) {
    return false;
  }
  if (textThresholds !== void 0 && !isValidTextThresholds(textThresholds)) {
    return false;
  }
  return areColumnThresholdsValid({ thresholds, textThresholds });
};
var isValidTableColumn = (column) => {
  if (!isRecord(column) || !isString(column.key) || !column.key) {
    return false;
  }
  if (column.label !== void 0 && !isString(column.label)) {
    return false;
  }
  if (column.hidden !== void 0 && typeof column.hidden !== "boolean") {
    return false;
  }
  if (!isValidColumnThresholdSettings(column)) {
    return false;
  }
  return column.renderer === void 0 || isValidColumnRenderer(column.renderer);
};
var isValidStatRenderer = (renderer) => isRecord(renderer) && isString(renderer.type) && STAT_RENDERER_TYPES.some((rendererType) => rendererType === renderer.type);
var isValidStatLabelRenderer = (renderer) => isRecord(renderer) && isString(renderer.type) && STAT_LABEL_RENDERER_TYPES.some((rendererType) => rendererType === renderer.type);
var isValidStatColumn = (column) => {
  if (!isRecord(column) || !isString(column.key) || !column.key) {
    return false;
  }
  if (column.label !== void 0 && !isString(column.label)) {
    return false;
  }
  if (column.suffix !== void 0 && !isString(column.suffix)) {
    return false;
  }
  if (column.hidden !== void 0 && typeof column.hidden !== "boolean") {
    return false;
  }
  if (!isValidColumnThresholdSettings(column)) {
    return false;
  }
  if (column.labelRenderer !== void 0 && !isValidStatLabelRenderer(column.labelRenderer)) {
    return false;
  }
  if (column.labelColor !== void 0 && !STAT_LABEL_COLORS.some((color) => color === column.labelColor)) {
    return false;
  }
  if (column.labelSymbolColor !== void 0 && !COLUMN_THRESHOLD_COLORS.some((color) => color === column.labelSymbolColor)) {
    return false;
  }
  if (column.labelSymbol !== void 0 && !isString(column.labelSymbol)) {
    return false;
  }
  return column.renderer === void 0 || isValidStatRenderer(column.renderer);
};
var areValidStatColumns = (columns) => columns.every((column) => isString(column) && !!column) || columns.every(isValidStatColumn);
var WidgetSourceValidation = Yup16.object({
  type: Yup16.mixed().oneOf(["metabase"]).required(),
  questionId: Yup16.number().integer().positive().required()
});
var WidgetFilterValidation = Yup16.object({
  parameterKey: Yup16.string().required(),
  column: Yup16.string().required()
});
var TableWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  source: WidgetSourceValidation.required(),
  columns: Yup16.array().of(Yup16.mixed().required()).test(
    "valid-table-columns",
    "Each column needs a key, a known renderer type and a consistent list of thresholds",
    (columns) => columns ? columns.every(isValidTableColumn) : true
  ),
  filters: Yup16.array().of(WidgetFilterValidation.required()),
  pinFirstColumn: Yup16.boolean(),
  groupMode: Yup16.mixed().oneOf([...DASHBOARD_TABLE_GROUP_MODES]),
  groupColumns: Yup16.array().of(Yup16.string().required()),
  groupChildrenKey: Yup16.string(),
  derived: Yup16.array().of(WidgetDerivedColumnValidation)
}).test(
  "group-columns-required",
  "groupColumns must list at least one column when groupMode is 'columns'",
  (value) => value.groupMode !== "columns" || !!value.groupColumns?.length
).test(
  "group-children-key-required",
  "groupChildrenKey is required when groupMode is 'nested'",
  (value) => value.groupMode !== "nested" || !!value.groupChildrenKey
);
var StatWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  source: WidgetSourceValidation.required(),
  columns: Yup16.array().of(Yup16.mixed().required()).test(
    "valid-stat-columns",
    "Columns must be all names or all objects with a key, a known renderer and a consistent list of thresholds",
    (columns) => columns ? areValidStatColumns(columns) : true
  ),
  // `Yup.mixed` (not `Yup.object`) so the per-column suffix map keeps its dynamic keys instead of being stripped.
  suffix: Yup16.mixed(),
  filters: Yup16.array().of(WidgetFilterValidation.required()),
  derived: Yup16.array().of(WidgetDerivedColumnValidation),
  linkSpecificities: Yup16.boolean().strict(),
  linkedColumnsBefore: Yup16.string().strict()
});
var UnitsStatisticsTableWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  structure: Yup16.mixed().oneOf([...WIDGET_UNITS_STATISTICS_TABLE_STRUCTURE]),
  questionId: Yup16.number().integer().positive(),
  specialtiesQuestionId: Yup16.number().integer().positive()
});
var TabValidation = Yup16.object({
  id: Yup16.string().required(),
  label: Yup16.string().required(),
  // Recursive reference. `Yup.lazy` defers resolving the schema until validation runs.
  widgets: Yup16.array().of(Yup16.lazy(() => DashboardWidgetValidation)).required()
});
var TabsWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  alignment: Yup16.mixed().oneOf([...WIDGET_TABS_HEADER_ALIGNMENT]),
  tabBarMarginX: Yup16.number().min(0),
  tabs: Yup16.array().of(TabValidation.required()).required()
});
var UnitsStatisticsIndicatorsWidgetOptionsValidation = Yup16.object({ ...commonOptionFields });
var SelectOptionValidation = Yup16.object({
  value: Yup16.string().required(),
  label: Yup16.string().required()
});
var SelectStaticSourceValidation = Yup16.object({
  type: Yup16.mixed().oneOf(["static"]).required(),
  options: Yup16.array().of(SelectOptionValidation.required()).required()
});
var selectLevelsValidation = Yup16.array().of(Yup16.number().integer().positive().required()).min(1);
var SelectQuestionSourceValidation = Yup16.object({
  type: Yup16.mixed().oneOf(["question"]).required(),
  questionId: Yup16.number().integer().positive().required(),
  valueColumn: Yup16.string().required(),
  labelColumn: Yup16.string(),
  levels: selectLevelsValidation
});
var SelectSourceValidation = Yup16.lazy((value) => {
  if (value?.type === "question") {
    return SelectQuestionSourceValidation;
  }
  return SelectStaticSourceValidation;
});
var SelectWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  source: SelectSourceValidation,
  parameterKey: Yup16.string().required(),
  multiple: Yup16.boolean(),
  searchable: Yup16.boolean(),
  placeholder: Yup16.string()
});
var GroupWidgetOptionsValidation = Yup16.object({
  ...commonOptionFields,
  // Référence récursive, comme les onglets : `Yup.lazy` diffère la résolution du schéma.
  widgets: Yup16.array().of(Yup16.lazy(() => DashboardWidgetValidation)).required()
});
var optionsValidationByDisplayType = {
  table: TableWidgetOptionsValidation,
  stat: StatWidgetOptionsValidation,
  unitsStatisticsTable: UnitsStatisticsTableWidgetOptionsValidation,
  unitsStatisticsIndicators: UnitsStatisticsIndicatorsWidgetOptionsValidation,
  tabs: TabsWidgetOptionsValidation,
  select: SelectWidgetOptionsValidation,
  group: GroupWidgetOptionsValidation
};
var DashboardWidgetValidation = Yup16.object({
  id: Yup16.string().required(),
  title: Yup16.string(),
  displayType: Yup16.mixed().oneOf([...WIDGET_DISPLAY_TYPES]).required(),
  // `Yup.mixed()` rather than `Yup.object()` to prevent stripping unknown keys (the shape of `options` depends on `displayType`)
  options: Yup16.mixed().required()
}).test("widget-options-per-type", "Invalid widget options for the given displayType", function(value) {
  const displayType = value?.displayType;
  if (!displayType) {
    return true;
  }
  const schema = optionsValidationByDisplayType[displayType];
  if (!schema) {
    return this.createError({
      path: `${this.path}.displayType`,
      message: `Unknown widget displayType: ${displayType}`
    });
  }
  try {
    schema.validateSync(value.options);
    return true;
  } catch (err) {
    return this.createError({
      path: `${this.path}.options`,
      message: err.message
    });
  }
});

// src/cloud/create-dashboard/create-dashboard.ts
var CreateDashboardValidation = Yup17.object({
  healthCenterId: Yup17.string().required(),
  title: Yup17.string().required(),
  widgets: Yup17.array().of(DashboardWidgetValidation.required())
});
var createDashboardRoute = "create-dashboard";
var createDashboard = buildCloudFunctionRunner(
  createDashboardRoute
);

// src/cloud/create-direct-admission/create-direct-admission.ts
import * as Yup18 from "yup";
var CreateDirectAdmissionValidation = Yup18.object({
  unitId: Yup18.string(),
  visitId: Yup18.string().required(),
  occurrenceDate: Yup18.date(),
  origin: Yup18.string().required(),
  thesaurusItemId: Yup18.string(),
  reason: Yup18.string(),
  specificities: Yup18.array(Yup18.string().oneOf(accommodationSpecificities).required()),
  customSpecificityIds: Yup18.array(Yup18.string().required()),
  comment: Yup18.string(),
  orientationUnitId: Yup18.string()
});
var createDirectAdmissionRoute = "create-direct-admission";
var CreateDirectAdmission = buildCloudFunctionRunner(createDirectAdmissionRoute);

// src/cloud/create-discharge-destination/create-discharge-destination.ts
import * as Yup19 from "yup";
var CreateDischargeDestinationValidation = Yup19.object({
  healthCenterId: Yup19.string().required(),
  name: Yup19.string().required(),
  hl7Identifier: Yup19.string()
});
var createDischargeDestinationRoute = "create-discharge-destination";
var createDischargeDestination = buildCloudFunctionRunner(createDischargeDestinationRoute);

// src/cloud/create-interop-message.ts
import * as Yup20 from "yup";
var CreateInteropMessageValidation = Yup20.object({
  source: Yup20.string().required(),
  data: Yup20.object().required()
});
var createInteropMessage = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-interop-message",
    params,
    options
  );
};

// src/cloud/create-reservation/create-reservation.ts
import * as Yup21 from "yup";
var CreateReservationValidation = Yup21.object({
  startAt: Yup21.date().required(),
  endAt: Yup21.date(),
  bedId: Yup21.string(),
  visitId: Yup21.string(),
  targetAccommodationId: Yup21.string(),
  comment: Yup21.string(),
  reasonId: Yup21.string()
});
var createReservationRoute = "create-reservation";
var createReservation = buildCloudFunctionRunner(
  createReservationRoute
);

// src/cloud/create-service-config/create-service-config.ts
import * as Yup23 from "yup";

// src/cloud/validations/careSectorConfig.ts
import * as Yup22 from "yup";
var CoordinatesValidation = Yup22.object({
  x: Yup22.number().required(),
  y: Yup22.number().required()
});
var BedValidation = Yup22.object({
  id: Yup22.string().required(),
  name: Yup22.string().required()
});
var CareSectorConfigValidation = Yup22.object({
  id: Yup22.string().required(),
  name: Yup22.string().required(),
  numberOfRooms: Yup22.number().required(),
  numberOfColumns: Yup22.number().required(),
  numberOfRows: Yup22.number().required(),
  bedsByRoom: Yup22.lazy(
    (obj) => Yup22.object(
      Object.keys(obj || {}).reduce(
        (acc, key) => {
          acc[key] = Yup22.array().of(BedValidation).required();
          return acc;
        },
        {}
      )
    )
  ),
  roomPositions: Yup22.lazy(
    (obj) => Yup22.object(
      Object.keys(obj || {}).reduce(
        (acc, key) => {
          acc[key] = CoordinatesValidation;
          return acc;
        },
        {}
      )
    )
  ),
  overflowMode: Yup22.string().oneOf(careSectorOverflowModes),
  bedPositionsInRooms: Yup22.lazy(
    (obj) => Yup22.object(
      Object.keys(obj || {}).reduce(
        (acc, roomKey) => {
          acc[roomKey] = Yup22.lazy(
            (innerObj) => Yup22.object(
              Object.keys(innerObj || {}).reduce(
                (innerAcc, bedKey) => {
                  innerAcc[bedKey] = CoordinatesValidation;
                  return innerAcc;
                },
                {}
              )
            )
          );
          return acc;
        },
        {}
      )
    )
  ),
  numberOfBedsPerRoom: Yup22.lazy(
    (obj) => Yup22.object(
      Object.keys(obj || {}).reduce(
        (acc, key) => {
          acc[key] = Yup22.number().required();
          return acc;
        },
        {}
      )
    )
  ),
  roomAlignment: Yup22.lazy(
    (obj) => Yup22.object(
      Object.keys(obj || {}).reduce(
        (acc, key) => {
          acc[key] = Yup22.string().oneOf(roomAlignments).required();
          return acc;
        },
        {}
      )
    )
  )
});

// src/cloud/create-service-config/create-service-config.ts
var createServiceConfigRoute = "create-service-config";
var CreateServiceConfigValidation = Yup23.object({
  unitId: Yup23.string().required(),
  orientation: Yup23.string().oneOf(serviceOrientations).required(),
  isSidebarMultiColumn: Yup23.boolean().required(),
  careSectorsConfig: Yup23.array().of(CareSectorConfigValidation).required()
});
var createServiceConfig = buildCloudFunctionRunner(createServiceConfigRoute);

// src/cloud/create-unit/create-unit.ts
import * as Yup26 from "yup";

// src/cloud/shared/contact.ts
import * as Yup24 from "yup";
var ContactPointValidation = Yup24.object({
  system: Yup24.string().required().oneOf(contactPointSystems),
  value: Yup24.string().required(),
  use: Yup24.string().oneOf(contactPointUses).optional()
});
var ContactValidation = Yup24.object({
  name: Yup24.string().required(),
  telecoms: Yup24.array().required().of(ContactPointValidation.required())
});

// src/cloud/validations/visibilityConfig.ts
import * as Yup25 from "yup";
var VisibilityConfigValidation = Yup25.object({
  healthCenter: Yup25.boolean(),
  bedManagement: Yup25.boolean(),
  patientTransport: Yup25.boolean(),
  emergency: Yup25.boolean()
});

// src/cloud/create-unit/create-unit.ts
var CreateUnitValidation = Yup26.object({
  name: Yup26.string().required(),
  identifiers: Yup26.array(Yup26.string().required()),
  parentIds: Yup26.array(Yup26.string().required()),
  areaIds: Yup26.array(Yup26.string().required()),
  healthCenterId: Yup26.string().required(),
  requestFareConfirmation: Yup26.boolean(),
  type: Yup26.string().oneOf(unitTypes),
  externalId: Yup26.string(),
  department: Yup26.string(),
  specialties: Yup26.array(Yup26.string().oneOf(unitSpecialties).required()),
  medicalSpecialtyIds: Yup26.array(Yup26.string().required()),
  defaultFarePositionFromThis: Yup26.string().oneOf(farePositions),
  contacts: Yup26.array().of(ContactValidation.required()),
  autoComputeOccupanciesActivated: Yup26.boolean(),
  responsibleUnits: Yup26.array(Yup26.string().required()),
  autoComputeDischarge: Yup26.boolean(),
  isEmergency: Yup26.boolean(),
  isMaternityUnit: Yup26.boolean(),
  isResponsibleUnit: Yup26.boolean(),
  isTransitUnit: Yup26.boolean(),
  manualOccupancyActivated: Yup26.boolean(),
  visibilityConfig: VisibilityConfigValidation.default(void 0),
  partOfId: Yup26.string()
});
var createUnit = buildCloudFunctionRunner("create-unit");

// src/cloud/createSpecialty.ts
import * as Yup27 from "yup";
var CreateSpecialtyValidation = Yup27.object({
  healthCenterId: Yup27.string().required(),
  name: Yup27.string().required(),
  shortName: Yup27.string().required(),
  quota: Yup27.number().required()
});
var createSpecialty = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-specialty", params, options);
};

// src/cloud/createUserProfile.ts
import * as Yup30 from "yup";

// src/cloud/validations/bedClosingReason.ts
import * as Yup28 from "yup";
var BedClosingReasonValidationSchema = Yup28.object({
  id: Yup28.string().required(),
  name: Yup28.string().required(),
  description: Yup28.string(),
  externalId: Yup28.string(),
  type: Yup28.mixed().oneOf([...BED_REASON_TYPES]),
  deletedAt: Yup28.date()
});

// src/cloud/validations/userProfile.ts
import * as Yup29 from "yup";
var profileActionsValidation = Yup29.object({
  // Kurt actions
  addAccommodation: Yup29.boolean(),
  createDirectAdmission: Yup29.boolean(),
  dischargePatient: Yup29.boolean(),
  confirmAdmission: Yup29.boolean(),
  updateUnit: Yup29.boolean(),
  cancelAccommodationAutoPatient: Yup29.boolean(),
  cancelAccommodationManualPatient: Yup29.boolean(),
  cancelInternalAndEmergencyMutations: Yup29.boolean(),
  createMovementRequest: Yup29.boolean(),
  createHospitalizationRequest: Yup29.boolean(),
  cancelMovementRequest: Yup29.boolean(),
  manageSavedViews: Yup29.boolean(),
  editDischargeDate: Yup29.boolean(),
  searchPatientAcrossHealthCenterGroup: Yup29.boolean(),
  editAdmitReason: Yup29.boolean(),
  editSpecificities: Yup29.boolean(),
  editRequestSpecificities: Yup29.boolean(),
  appBarSearch: Yup29.boolean(),
  rerouteDirectAdmission: Yup29.boolean(),
  rerouteInternalMutation: Yup29.boolean(),
  editOrientation: Yup29.boolean(),
  manageBedClosure: Yup29.boolean(),
  manageBedBlock: Yup29.boolean(),
  manageReservation: Yup29.boolean(),
  manageThesaurus: Yup29.boolean(),
  manageStructure: Yup29.boolean(),
  answerMovementRequest: Yup29.boolean(),
  // Sabri actions
  orderJourney: Yup29.boolean(),
  updateJourney: Yup29.boolean(),
  cancelJourney: Yup29.boolean(),
  assignFare: Yup29.boolean(),
  tickFare: Yup29.boolean(),
  reportFareIncident: Yup29.boolean(),
  logoutPorter: Yup29.boolean(),
  accessPendingFareTab: Yup29.boolean(),
  accessInOutFareTabs: Yup29.boolean(),
  confirmFare: Yup29.boolean(),
  cleanBeds: Yup29.boolean(),
  manageEnvironmentalCleaning: Yup29.boolean()
});

// src/cloud/createUserProfile.ts
var CreateUserProfileValidation = Yup30.object({
  identifiers: Yup30.array().of(Yup30.string().required()).required(),
  navigationACL: Yup30.array().of(Yup30.string().oneOf(NAVIGATION_ROUTES).required()).required(),
  isReadOnly: Yup30.boolean().required(),
  healthCenterId: Yup30.string().required(),
  hasAccessToAllUnits: Yup30.boolean(),
  actionPermissions: profileActionsValidation.default(void 0),
  anonymousMode: Yup30.string().oneOf(anonymousModes)
});
var createUserProfile = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-user-profile",
    params,
    options
  );
};

// src/cloud/deactivate-organization/deactivate-organization.ts
import * as Yup31 from "yup";
var DeactivateOrganizationValidation = Yup31.object({
  organizationId: Yup31.string().required(),
  date: Yup31.date().required(),
  includeAttachedElements: Yup31.boolean().optional()
});
var deactivateOrganizationRoute = "deactivate-organization";
var deactivateOrganization = buildCloudFunctionRunner(deactivateOrganizationRoute);

// src/cloud/delete-bed-closures/delete-bed-closures.ts
import * as Yup32 from "yup";
var DeleteBedClosuresValidation = Yup32.object({
  bedClosureIds: Yup32.array(Yup32.string().required()).required()
});
var deleteBedClosuresRoute = "delete-bed-closures";
var deleteBedClosures = buildCloudFunctionRunner(
  deleteBedClosuresRoute
);

// src/cloud/delete-dashboard/delete-dashboard.ts
import * as Yup33 from "yup";
var DeleteDashboardValidation = Yup33.object({
  id: Yup33.string().required()
});
var deleteDashboardRoute = "delete-dashboard";
var deleteDashboard = buildCloudFunctionRunner(
  deleteDashboardRoute
);

// src/cloud/delete-dashboard-slot/delete-dashboard-slot.ts
import * as Yup34 from "yup";
var DeleteDashboardSlotValidation = Yup34.object({
  healthCenterId: Yup34.string().required(),
  slotKey: Yup34.string().oneOf(SLOT_KEYS).required()
});
var deleteDashboardSlotRoute = "delete-dashboard-slot";
var deleteDashboardSlot = buildCloudFunctionRunner(
  deleteDashboardSlotRoute
);

// src/cloud/delete-discharge-destination/delete-discharge-destination.ts
import * as Yup35 from "yup";
var DeleteDischargeDestinationValidation = Yup35.object({
  id: Yup35.string().required()
});
var deleteDischargeDestinationRoute = "delete-discharge-destination";
var deleteDischargeDestination = buildCloudFunctionRunner(deleteDischargeDestinationRoute);

// src/cloud/deleteSpecialty.ts
import * as Yup36 from "yup";
var DeleteSpecialtyValidation = Yup36.object({
  id: Yup36.string().required()
});
var deleteSpecialty = (params, options) => {
  return parse_instance_browser_default.Cloud.run("delete-specialty", params, options);
};

// src/cloud/deleteSpecificity.ts
import * as Yup37 from "yup";
var DeleteSpecificityValidation = Yup37.object({
  ids: Yup37.array(Yup37.string().required()).required()
});
var deleteSpecificity = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "delete-specificity",
    params,
    options
  );
};

// src/cloud/deleteUserProfile.ts
import * as Yup38 from "yup";
var DeleteUserProfileValidation = Yup38.object({
  id: Yup38.string().required()
});
var deleteUserProfile = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "delete-user-profile",
    params,
    options
  );
};

// src/cloud/export-aphp-f00024-capacity-history/export-aphp-f00024-capacity-history.ts
import * as Yup39 from "yup";
var ExportAphpF00024CapacityHistoryValidation = Yup39.object({
  source: Yup39.string().required()
});
var exportAphpF00024CapacityHistoryRoute = "export-aphp-f00024-capacity-history";
var exportAphpF00024CapacityHistory = buildCloudFunctionRunner(exportAphpF00024CapacityHistoryRoute);

// src/cloud/export-aphp-np10000-bed-situation/export-aphp-np10000-bed-situation.ts
import * as Yup40 from "yup";
var ExportAphpNp10000BedSituationValidation = Yup40.object({
  source: Yup40.string().required()
});
var exportAphpNp10000BedSituationRoute = "export-aphp-np10000-bed-situation";
var exportAphpNp10000BedSituation = buildCloudFunctionRunner(exportAphpNp10000BedSituationRoute);

// src/cloud/export-dashboards/export-dashboards.ts
import * as Yup41 from "yup";
var ExportDashboardsValidation = Yup41.object({
  healthCenterId: Yup41.string().required(),
  dashboardIds: Yup41.array().of(Yup41.string().required()).min(1).required()
});
var exportDashboardsRoute = "export-dashboards";
var exportDashboards = buildCloudFunctionRunner(
  exportDashboardsRoute
);

// src/cloud/export-user-profiles/export-user-profiles.ts
import * as Yup42 from "yup";
var ExportUserProfilesValidation = Yup42.object({
  healthCenterId: Yup42.string().required()
});
var exportUserProfilesRoute = "export-user-profiles";
var exportUserProfiles = buildCloudFunctionRunner(
  exportUserProfilesRoute
);

// src/cloud/external/ans/getAnsOrganizations.ts
import * as Yup43 from "yup";
var GetAnsOrganizationValidation = Yup43.object({
  finessList: Yup43.array().of(Yup43.string().required()).required()
});
var getAnsOrganizations = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-ans-organizations",
  params,
  options
);

// src/cloud/external/ans/getAnsPractitioners.ts
import * as Yup44 from "yup";
var optionsValidation = Yup44.object({
  count: Yup44.number(),
  bindOrganizations: Yup44.boolean(),
  bindRpps: Yup44.boolean()
});
var GetAnsPractitionersValidation = Yup44.object({
  search: Yup44.string().required(),
  options: optionsValidation.default(void 0)
});
var getAnsPractitioners = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-ans-practitioners",
  params,
  options
);

// src/cloud/external/viaTrajectoire/getPatientContextualLink.ts
import * as Yup45 from "yup";
var reportTypes = { SANITARY: "sanitaire", GREAT_AGE: "grand-age" };
var GetPatientContextualLinkValidation = Yup45.object({
  id: Yup45.string().required(),
  type: Yup45.string().required().oneOf(Object.values(reportTypes))
});
var getPatientContextualLink = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-patient-contextual-link",
  params,
  options
);

// src/cloud/fareTick.ts
import * as Yup46 from "yup";
var FareTickValidation = Yup46.object({
  fareId: Yup46.string().required(),
  date: Yup46.date(),
  status: Yup46.string().oneOf(Object.values(fareStatus))
});
var fareTick = (params, options) => {
  return parse_instance_browser_default.Cloud.run("fare-tick", params, options);
};

// src/cloud/find-active-area-availability-periods/find-active-area-availability-periods.ts
import * as Yup47 from "yup";
var FindActiveAreaAvailabilityPeriodsValidation = Yup47.object({
  areaIds: Yup47.array().of(Yup47.string().required()).required(),
  date: Yup47.date()
});
var findActiveAreaAvailabilityPeriodsRoute = "find-active-area-availability-periods";
var findActiveAreaAvailabilityPeriods = buildCloudFunctionRunner(findActiveAreaAvailabilityPeriodsRoute);

// src/cloud/find-active-areas/find-active-areas.ts
import * as Yup48 from "yup";
var FindActiveAreasValidation = Yup48.object({
  unitIds: Yup48.array(Yup48.string().required()).required(),
  startAt: Yup48.date().required(),
  endAt: Yup48.date().required(),
  areaIncludes: Yup48.array(Yup48.string().required())
});
var findActiveAreasRoute = "find-active-areas";
var findActiveAreas = buildCloudFunctionRunner(
  findActiveAreasRoute
);

// src/cloud/find-structure-nodes/find-structure-nodes.ts
import * as Yup49 from "yup";

// src/domain/structure/structure-axis.ts
var structureAxes = [
  "operational",
  "physical",
  "financial",
  "medicalResponsibility",
  "medical",
  "other"
];
var organizationParentFields = {
  operational: { parent: "partOf", ancestors: "partOfAncestors" },
  financial: { parent: "financialPartOf", ancestors: "financialPartOfAncestors" }
};
var writableStructureAxes = Object.keys(organizationParentFields);

// src/cloud/find-structure-nodes/find-structure-nodes.ts
var FindStructureNodesValidation = Yup49.object({
  healthCenterId: Yup49.string().required(),
  axis: Yup49.string().oneOf([...structureAxes]).required(),
  date: Yup49.date().optional(),
  includeInactive: Yup49.boolean().optional(),
  includeExcluded: Yup49.boolean().optional()
});
var findStructureNodesRoute = "find-structure-nodes";
var findStructureNodes = buildCloudFunctionRunner(
  findStructureNodesRoute
);

// src/cloud/get-bed-resources/get-bed-resources.ts
import * as Yup50 from "yup";

// src/const/bedStatus.ts
var BED_STATUSES = [
  "AVAILABLE",
  "AVAILABLE_DOUBLE",
  "AVAILABLE_SINGLE",
  "BUSY",
  "CLOSED",
  "BLOCKED",
  "BOOKED"
];

// src/const/errors.ts
var errorTypes = ["CONNECTION_FAILED"];

// src/const/unitVisibilityConfig.ts
var EMPTY_VISIBILITY_CONFIG = {
  healthCenter: false,
  bedManagement: false,
  patientTransport: false,
  emergency: false
};
var DEFAULT_VISIBILITY_CONFIG_BY_TYPE = {
  GHT: EMPTY_VISIBILITY_CONFIG,
  LEGAL_ENTITY: EMPTY_VISIBILITY_CONFIG,
  GEOGRAPHICAL_ENTITY: EMPTY_VISIBILITY_CONFIG,
  POLE: EMPTY_VISIBILITY_CONFIG,
  SERVICE: EMPTY_VISIBILITY_CONFIG,
  MEDICAL_RESPONSIBILITY: EMPTY_VISIBILITY_CONFIG,
  MEDICAL: {
    ...EMPTY_VISIBILITY_CONFIG,
    patientTransport: true
  },
  ACCOMMODATION: { ...EMPTY_VISIBILITY_CONFIG, bedManagement: true, patientTransport: true, healthCenter: true },
  EMERGENCY: {
    ...EMPTY_VISIBILITY_CONFIG,
    emergency: true,
    patientTransport: true
  },
  OTHER: EMPTY_VISIBILITY_CONFIG,
  INTERNAL_STRUCTURE: EMPTY_VISIBILITY_CONFIG,
  UF: EMPTY_VISIBILITY_CONFIG,
  UH: { ...EMPTY_VISIBILITY_CONFIG, healthCenter: true },
  UM: EMPTY_VISIBILITY_CONFIG,
  UAC: EMPTY_VISIBILITY_CONFIG,
  CENTRE_RESP: EMPTY_VISIBILITY_CONFIG,
  SOIN: EMPTY_VISIBILITY_CONFIG,
  ADMINISTRATIF: EMPTY_VISIBILITY_CONFIG
};

// src/cloud/get-bed-resources/get-bed-resources.ts
var GetBedResourcesValidation = Yup50.object({
  units: Yup50.array(Yup50.string().required()).required().min(1, "At least one unit id is required"),
  statuses: Yup50.array(Yup50.string().required().oneOf(BED_STATUSES)).required()
});
var getBedResourcesRoute = "get-bed-resources";
var getBedResources = buildCloudFunctionRunner(
  getBedResourcesRoute
);

// src/cloud/get-capacity/get-capacity.ts
import * as Yup51 from "yup";
var capacityAxes = ["operational", "financial"];
var GetCapacityValidation = Yup51.object({
  healthCenterId: Yup51.string(),
  organizationId: Yup51.string(),
  organizationIds: Yup51.array().of(Yup51.string().required()),
  date: Yup51.date(),
  axis: Yup51.mixed().oneOf([...capacityAxes])
}).test("at-least-one-id", "healthCenterId, organizationId or organizationIds is required", (value) => {
  return !!(value?.healthCenterId || value?.organizationId || value?.organizationIds && value.organizationIds.length > 0);
});
var getCapacityRoute = "get-capacity";
var getCapacity = buildCloudFunctionRunner(getCapacityRoute);

// src/cloud/get-encounter-isolation-specificities/get-encounter-isolation-specificities.ts
import * as Yup52 from "yup";
var GetEncounterIsolationSpecificitiesValidation = Yup52.object({
  visitId: Yup52.string().required(),
  from: Yup52.date().required()
});
var getEncounterIsolationSpecificitiesRoute = "get-encounter-isolation-specificities";
var getEncounterIsolationSpecificities = buildCloudFunctionRunner(getEncounterIsolationSpecificitiesRoute);

// src/cloud/getConfig/getConfig.ts
import * as Yup53 from "yup";
var GetConfigValidation = Yup53.object({
  healthCenterId: Yup53.string().required()
});
var getConfig = (params, options) => parse_instance_browser_default.Cloud.run("get-config", params, options);

// src/cloud/getOidcLogoutRequest.ts
import * as Yup54 from "yup";
var GetOidcLogoutRequestValidation = Yup54.object({});
var getOidcLogoutRequest = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-oidc-logout-request",
    params,
    options
  );
};

// src/cloud/getPorterDailyFares/getPorterDailyFares.ts
var getPorterDailyFares = (options) => {
  return parse_instance_browser_default.Cloud.run("get-porter-daily-fares", {}, options);
};

// src/cloud/getRegionStatistics.ts
import * as Yup55 from "yup";
var GetRegionStatisticsValidation = Yup55.object({
  sectors: Yup55.array().of(Yup55.string().oneOf(Object.values(unitSectors)).required()),
  currentHealthCenterId: Yup55.string().optional()
});
var getRegionStatistics = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-region-statistics",
    params,
    options
  );
};

// src/cloud/getSpecialtyOccupancies.ts
import * as Yup56 from "yup";
var GetSpecialtyOccupanciesValidation = Yup56.object({
  healthCenterId: Yup56.string().required()
});
var getSpecialtyOccupancies = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-specialty-occupancies",
    params,
    options
  );
};

// src/cloud/handleHl7Message.ts
import * as Yup57 from "yup";
var HandleHl7MessageValidation = Yup57.object({
  source: Yup57.string().required(),
  message: Yup57.string().required()
});
var handleHl7Message = (params, options) => parse_instance_browser_default.Cloud.run("handle-hl7-message", params, options);

// src/cloud/handleOidcCallback.ts
import * as Yup58 from "yup";
var HandleOidcCallbackValidation = Yup58.object({
  code: Yup58.string().required(),
  state: Yup58.string().required(),
  sessionData: Yup58.string().required()
});
var handleOidcCallback = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "handle-oidc-callback",
    params,
    options
  );
};

// src/cloud/exclude-organization/exclude-organization.ts
import * as Yup59 from "yup";
var ExcludeOrganizationValidation = Yup59.object({
  organizationId: Yup59.string().required(),
  date: Yup59.date().required(),
  includeAttachedElements: Yup59.boolean().optional()
});
var excludeOrganizationRoute = "exclude-organization";
var excludeOrganization = buildCloudFunctionRunner(
  excludeOrganizationRoute
);

// src/cloud/import-aphp-structure/import-aphp-structure.ts
import * as Yup60 from "yup";
var aphpStructureKinds = [
  "hospital",
  "gh",
  "site",
  "building",
  "building-sector",
  "level",
  "room",
  "bed",
  "pdt",
  "pole",
  "service",
  "uf",
  "uh",
  "uma",
  "ua",
  "ug",
  "uds",
  "urm-clinique",
  "nomenclature"
];
var ImportAphpStructureValidation = Yup60.object({
  csvContent: Yup60.string().required(),
  kind: Yup60.string().oneOf([...aphpStructureKinds]),
  healthCenterId: Yup60.string()
});
var importAphpStructureRoute = "import-aphp-structure";
var importAphpStructure = buildCloudFunctionRunner(
  importAphpStructureRoute
);

// src/cloud/import-dashboards/import-dashboards.ts
import * as Yup61 from "yup";
var ImportedDashboardValidation = Yup61.object({
  title: Yup61.string().trim().required(),
  widgets: Yup61.array().of(Yup61.mixed().required()).required()
});
var ImportDashboardsValidation = Yup61.object({
  healthCenterId: Yup61.string().required(),
  dashboards: Yup61.array().of(ImportedDashboardValidation.required()).min(1).required()
});
var importDashboardsRoute = "import-dashboards";
var importDashboards = buildCloudFunctionRunner(
  importDashboardsRoute
);

// src/cloud/import-user-profiles/import-user-profiles.ts
import * as Yup62 from "yup";
var ImportedUserProfileValidation = Yup62.object({
  identifiers: Yup62.array().of(Yup62.string().required()).min(1).required(),
  navigationACL: Yup62.array().of(Yup62.string().oneOf(NAVIGATION_ROUTES).required()),
  isReadOnly: Yup62.boolean(),
  hasAccessToAllUnits: Yup62.boolean(),
  actionPermissions: profileActionsValidation.default(void 0),
  anonymousMode: Yup62.string().oneOf(anonymousModes).nullable()
});
var ImportUserProfilesValidation = Yup62.object({
  healthCenterId: Yup62.string().required(),
  userProfiles: Yup62.array().of(ImportedUserProfileValidation.required()).min(1).required()
});
var importUserProfilesRoute = "import-user-profiles";
var importUserProfiles = buildCloudFunctionRunner(
  importUserProfilesRoute
);

// src/cloud/initiateOidcLogin.ts
import * as Yup63 from "yup";
var InitiateOidcLoginValidation = Yup63.object({
  healthCenter: Yup63.string().required()
});
var initiateOidcLogin = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "initiate-oidc-login",
    params,
    options
  );
};

// src/cloud/nightAndWeekend/addBedsToNightAndWeekendBedList.ts
import * as Yup64 from "yup";
var AddBedsToNightAndWeekendBedListValidation = Yup64.object({
  bedIds: Yup64.array(Yup64.string().required()).required(),
  healthCenterId: Yup64.string().required()
});
var addBedsToNightAndWeekendBedList = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "add-beds-to-night-and-weekend-bed-list",
    params,
    options
  );
};

// src/cloud/nightAndWeekend/getNightAndWeekendBedList.ts
import * as Yup65 from "yup";
var GetNightAndWeekendBedListValidation = Yup65.object({
  healthCenterId: Yup65.string().required()
});
var getNightAndWeekendBedList = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-night-and-weekend-bed-list",
    params,
    options
  );
};

// src/cloud/nightAndWeekend/removeBedFromNightAndWeekendBedList.ts
import * as Yup66 from "yup";
var RemoveBedFromNightAndWeekendBedListValidation = Yup66.object({
  bedIds: Yup66.array().of(Yup66.string().required()).required().min(1),
  healthCenterId: Yup66.string().required()
});
var removeBedFromNightAndWeekendBedList = (params, options) => {
  return parse_instance_browser_default.Cloud.run("remove-bed-from-night-and-weekend-bed-list", params, options);
};

// src/cloud/nightAndWeekend/updateNightAndWeekendBedComment.ts
import * as Yup67 from "yup";
var UpdateNightAndWeekendBedCommentValidation = Yup67.object({
  bedId: Yup67.string().required(),
  comment: Yup67.string().required().nullable(),
  healthCenterId: Yup67.string().required()
});
var updateNightAndWeekendBedComment = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-night-and-weekend-bed-comment",
    params,
    options
  );
};

// src/cloud/query-dashboard-question/query-dashboard-question.ts
import * as Yup68 from "yup";
var QueryDashboardQuestionValidation = Yup68.object({
  questionId: Yup68.number().integer().positive().required(),
  dashboardId: Yup68.string(),
  slotKey: Yup68.string().oneOf(SLOT_KEYS),
  unitIds: Yup68.array().of(Yup68.string().required()),
  date: Yup68.date(),
  refreshCache: Yup68.boolean()
});
var queryDashboardQuestionRoute = "query-dashboard-question";
var queryDashboardQuestion = buildCloudFunctionRunner(queryDashboardQuestionRoute);

// src/cloud/reactivate-organization/reactivate-organization.ts
import * as Yup69 from "yup";
var ReactivateOrganizationValidation = Yup69.object({
  organizationId: Yup69.string().required(),
  includeAttachedElements: Yup69.boolean().optional()
});
var reactivateOrganizationRoute = "reactivate-organization";
var reactivateOrganization = buildCloudFunctionRunner(reactivateOrganizationRoute);

// src/cloud/remove-capacity-period/remove-capacity-period.ts
import * as Yup70 from "yup";
var RemoveCapacityPeriodValidation = Yup70.object({
  id: Yup70.string().required()
});
var removeCapacityPeriodRoute = "remove-capacity-period";
var removeCapacityPeriod = buildCloudFunctionRunner(
  removeCapacityPeriodRoute
);

// src/cloud/searchPatient/searchPatient.ts
import * as Yup71 from "yup";
var SearchPatientValidation = Yup71.object({
  healthCenterId: Yup71.string().required(),
  ipp: Yup71.string(),
  pan: Yup71.string(),
  firstName: Yup71.string(),
  lastName: Yup71.string(),
  birthdate: Yup71.date(),
  isGroupSearchEnabled: Yup71.boolean(),
  page: Yup71.number().required(),
  version: Yup71.string()
}).test("at-least-one-field", i18n.searchPatientAtLeastOneFieldRequired, (value) => {
  const { healthCenterId, page, ...searchParams } = value || {};
  return Object.values(searchParams || {}).some((val) => val !== void 0 && val !== "");
});
var searchPatient = (params, options) => {
  return parse_instance_browser_default.Cloud.run("search-patient", params, options);
};

// src/cloud/steps/acceptPerformerRequest.ts
import * as Yup72 from "yup";
var AcceptPerformerRequestValidation = Yup72.object({
  id: Yup72.string().required(),
  startAt: Yup72.date().required(),
  bedId: Yup72.string()
});
var acceptPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "accept-performer-request",
  params,
  options
);

// src/cloud/steps/cancelAccommodation.ts
import * as Yup73 from "yup";
var CancelAccommodationValidation = Yup73.object({
  accommodationId: Yup73.string(),
  bedClosingExternalId: Yup73.string()
}).test("at-least-one-identifier", i18n.missingIdentifier, function(value) {
  return !!value.accommodationId || !!value.bedClosingExternalId;
});
var cancelAccommodation = (params, options) => parse_instance_browser_default.Cloud.run(
  "cancel-accommodation",
  params,
  options
);

// src/cloud/steps/cancelAccommodationRequest.ts
import * as Yup74 from "yup";
var CancelAccommodationRequestValidation = Yup74.object({
  requestId: Yup74.string().required()
});
var cancelAccommodationRequestRoute = "cancel-accommodation-request";
var cancelAccommodationRequest = buildCloudFunctionRunner(cancelAccommodationRequestRoute);

// src/cloud/steps/createAccommodationRequest.ts
import * as Yup75 from "yup";
var CreateAccommodationRequestValidation = Yup75.object({
  occurrenceDate: Yup75.date().when("requestType", {
    is: "BED_MUTATION",
    then: (schema) => schema.required()
  }),
  locationId: Yup75.string().when("requestType", {
    is: "BED_MUTATION",
    then: (schema) => schema.required()
  }),
  visitId: Yup75.string().required(),
  performerUnitIds: Yup75.array(Yup75.string().required()),
  specificities: Yup75.array(Yup75.string().oneOf(accommodationSpecificities).required()),
  customSpecificityIds: Yup75.array(Yup75.string().required()),
  requestType: Yup75.string().oneOf(ACCOMMODATION_REQUEST_TYPES).required(),
  reason: Yup75.string(),
  thesaurusItemId: Yup75.string(),
  directAdmissionOrigin: Yup75.string().when("requestType", {
    is: "DIRECT_ADMISSION",
    then: () => Yup75.string().required()
  }),
  comment: Yup75.string(),
  originAccommodationId: Yup75.string(),
  orientationUnitId: Yup75.string()
});
var createAccommodationRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-accommodation-request",
  params,
  options
);

// src/cloud/steps/createExternalTransport.ts
import * as Yup76 from "yup";
var externalTransportStatus = [
  "PLANNED",
  "VALIDATED",
  "IN_PROGRESS",
  "DONE",
  "CANCELED"
];
var identifierSchema = Yup76.object({
  type: Yup76.string().required(),
  value: Yup76.string().required()
});
var externalTransportPatientValidation = Yup76.object({
  birthDate: Yup76.string().required(),
  firstName: Yup76.string().required(),
  lastName: Yup76.string().required(),
  pan: Yup76.string(),
  gender: Yup76.string().oneOf(patientGender).required(),
  identifiers: Yup76.array(identifierSchema.required()).required()
});
var CreateExternalTransportValidation = Yup76.object({
  endAt: Yup76.date().required(),
  externalId: Yup76.string().required(),
  startAt: Yup76.date().required(),
  status: Yup76.string().oneOf(externalTransportStatus).required(),
  finess: Yup76.string().required(),
  farePosition: Yup76.string().oneOf(externalPatientTransportPosition).required(),
  comment: Yup76.string(),
  patient: externalTransportPatientValidation.required(),
  reason: Yup76.string()
});
var createExternalTransport = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-external-transport",
  params,
  options
);

// src/cloud/steps/createPerformerRequest.ts
import * as Yup77 from "yup";
var CreatePerformerRequestValidation = Yup77.object({
  requestId: Yup77.string().required(),
  performerId: Yup77.string().required()
});
var createPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "create-performer-request",
  params,
  options
);

// src/cloud/steps/rejectPerformerRequest.ts
import * as Yup78 from "yup";
var RejectPerformerRequestValidation = Yup78.object({
  id: Yup78.string().required(),
  reason: Yup78.string()
});
var rejectPerformerRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "reject-performer-request",
  params,
  options
);

// src/cloud/steps/stepScheduling.ts
import * as Yup79 from "yup";
var StepSchedulingValidation = Yup79.object({
  unitId: Yup79.string().required(),
  startAt: Yup79.date().required(),
  endAt: Yup79.date(),
  gender: Yup79.string().oneOf(patientGender),
  age: Yup79.number(),
  specificities: Yup79.array().of(Yup79.string().oneOf(accommodationSpecificities).required()),
  customSpecificitiesIds: Yup79.array().of(Yup79.string().required())
});
var stepScheduling = (params, options) => parse_instance_browser_default.Cloud.run("step-scheduling", params, options);

// src/cloud/steps/updateAccommodationRequest.ts
import * as Yup81 from "yup";

// src/cloud/updateVisit.ts
import * as Yup80 from "yup";
var patientOutcomeValidation = Yup80.object({
  comment: Yup80.string().notRequired(),
  viaTrajectoireReportNumber: Yup80.number()
});
var updateVisitValidation = Yup80.object({
  visitId: Yup80.string().required(),
  patientOutcome: patientOutcomeValidation.default(void 0),
  dischargeDestinationId: Yup80.string().nullable().notRequired(),
  admitReason: Yup80.string().notRequired(),
  thesaurusItemId: Yup80.string().notRequired(),
  medicallyOutgoing: Yup80.boolean()
});
var updateVisit = (params, options) => parse_instance_browser_default.Cloud.run("update-visit", params, options);
var updateVisit_default = updateVisit;

// src/cloud/steps/updateAccommodationRequest.ts
var UpdateAccommodationRequestValidation = Yup81.object({
  id: Yup81.string().required(),
  reason: Yup81.string().notRequired(),
  thesaurusItemId: Yup81.string().notRequired(),
  comment: Yup81.string().notRequired(),
  specificities: Yup81.array().of(Yup81.string().oneOf(accommodationSpecificities).required()),
  customSpecificityIds: Yup81.array().of(Yup81.string().required()),
  directAdmissionOrigin: Yup81.string().notRequired(),
  orientationUnitId: Yup81.string().notRequired(),
  patientOutcome: patientOutcomeValidation.default(void 0),
  dischargeDestinationId: Yup81.string().nullable().notRequired()
});
var updateAccommodationRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "update-accommodation-request",
  params,
  options
);

// src/cloud/steps/updateExternalTransport.ts
import * as Yup82 from "yup";
var UpdateExternalTransportValidation = Yup82.object({
  endAt: Yup82.date().required(),
  externalId: Yup82.string().required(),
  startAt: Yup82.date().required(),
  status: Yup82.string().oneOf(externalTransportStatus).required(),
  farePosition: Yup82.string().oneOf(externalPatientTransportPosition),
  comment: Yup82.string(),
  reason: Yup82.string()
});
var updateExternalTransport = (params, options) => parse_instance_browser_default.Cloud.run(
  "update-external-transport",
  params,
  options
);

// src/cloud/steps/upsertAccommodation.ts
import * as Yup83 from "yup";
var UpsertAccommodationValidation = Yup83.object({
  startAt: Yup83.date().required(),
  endAt: Yup83.date(),
  isEndEstimated: Yup83.boolean().required(),
  specificities: Yup83.array(Yup83.string().oneOf(accommodationSpecificities).required()),
  customSpecificityIds: Yup83.array(Yup83.string().required()),
  practitionerIds: Yup83.array().of(Yup83.string().required()),
  bedId: Yup83.string().notRequired(),
  visitId: Yup83.string(),
  unitId: Yup83.string(),
  accommodationId: Yup83.string(),
  bedClosingExternalId: Yup83.string(),
  status: Yup83.string().oneOf(accommodationStatus),
  comment: Yup83.string().notRequired(),
  reason: Yup83.string().notRequired(),
  thesaurusItemId: Yup83.string().notRequired(),
  patientOutcome: patientOutcomeValidation.default(void 0),
  dischargeDestinationId: Yup83.string().nullable().notRequired(),
  bedClosingReasonId: Yup83.string().test("bedClosingReasonId-visitId-exclusivity", i18n.bedClosingReasonOnlyOnClosedBed, function(value) {
    return !value || !this.parent.visitId;
  }).notRequired()
});
var upsertAccommodation = (params, options) => parse_instance_browser_default.Cloud.run(
  "upsert-accommodation",
  params,
  options
);

// src/cloud/include-organization/include-organization.ts
import * as Yup84 from "yup";
var IncludeOrganizationValidation = Yup84.object({
  organizationId: Yup84.string().required(),
  includeAttachedElements: Yup84.boolean().optional()
});
var includeOrganizationRoute = "include-organization";
var includeOrganization = buildCloudFunctionRunner(
  includeOrganizationRoute
);

// src/cloud/update-bed-block/update-bed-block.ts
import * as Yup85 from "yup";
var UpdateBedBlockValidation = Yup85.object({
  bedBlockId: Yup85.string().required(),
  startAt: Yup85.date(),
  endAt: Yup85.date().nullable(),
  comment: Yup85.string().nullable(),
  customSpecificityIds: Yup85.array(Yup85.string().required()),
  reasonId: Yup85.string().nullable()
});
var updateBedBlockRoute = "update-bed-block";
var updateBedBlock = buildCloudFunctionRunner(
  updateBedBlockRoute
);

// src/cloud/update-capacity-period/update-capacity-period.ts
import * as Yup86 from "yup";
var WeeklySlotValidation2 = Yup86.object({
  startMinuteOfWeek: Yup86.number().integer().min(0).max(MINUTES_PER_WEEK).required(),
  endMinuteOfWeek: Yup86.number().integer().min(0).max(MINUTES_PER_WEEK).required(),
  value: Yup86.number().required()
});
var UpdateCapacityPeriodValidation = Yup86.object({
  id: Yup86.string().required(),
  value: Yup86.number(),
  startDate: Yup86.date(),
  endDate: Yup86.date().nullable(),
  slots: Yup86.array().of(WeeklySlotValidation2.required()),
  reasonId: Yup86.string().nullable(),
  reasonText: Yup86.string().nullable()
});
var updateCapacityPeriodRoute = "update-capacity-period";
var updateCapacityPeriod = buildCloudFunctionRunner(
  updateCapacityPeriodRoute
);

// src/cloud/update-dashboard/update-dashboard.ts
import * as Yup87 from "yup";
var UpdateDashboardValidation = Yup87.object({
  id: Yup87.string().required(),
  title: Yup87.string(),
  widgets: Yup87.array().of(DashboardWidgetValidation.required())
});
var updateDashboardRoute = "update-dashboard";
var updateDashboard = buildCloudFunctionRunner(
  updateDashboardRoute
);

// src/cloud/update-discharge-destination/update-discharge-destination.ts
import * as Yup88 from "yup";
var UpdateDischargeDestinationValidation = Yup88.object({
  id: Yup88.string().required(),
  name: Yup88.string(),
  hl7Identifier: Yup88.string().nullable(),
  isActive: Yup88.boolean()
});
var updateDischargeDestinationRoute = "update-discharge-destination";
var updateDischargeDestination = buildCloudFunctionRunner(updateDischargeDestinationRoute);

// src/cloud/update-reservation/update-reservation.ts
import * as Yup89 from "yup";
var UpdateReservationValidation = Yup89.object({
  reservationId: Yup89.string().required(),
  startAt: Yup89.date(),
  endAt: Yup89.date(),
  comment: Yup89.string(),
  reasonId: Yup89.string().nullable()
});
var updateReservationRoute = "update-reservation";
var updateReservation = buildCloudFunctionRunner(
  updateReservationRoute
);

// src/cloud/update-service-config/update-service-config.ts
import * as Yup90 from "yup";
var updateServiceConfigRoute = "update-service-config";
var UpdateServiceConfigValidation = Yup90.object({
  unitId: Yup90.string().required(),
  orientation: Yup90.string().oneOf(serviceOrientations).required(),
  isSidebarMultiColumn: Yup90.boolean().required(),
  careSectorsConfig: Yup90.array().of(CareSectorConfigValidation).required()
});
var updateServiceConfig = buildCloudFunctionRunner(updateServiceConfigRoute);

// src/cloud/update-unit/update-unit.ts
import * as Yup91 from "yup";
var ManualOccupancyValidation = Yup91.object({
  open: Yup91.number().min(0, i18n.manualOccupancyCanNotBeNegative).required(),
  installed: Yup91.number().min(0, i18n.manualOccupancyCanNotBeNegative),
  reason: Yup91.string(),
  startDate: Yup91.date(),
  endDate: Yup91.date(),
  bedClosingReason: BedClosingReasonValidationSchema.notRequired().default(void 0)
});
var UpdateUnitValidation = Yup91.object({
  id: Yup91.string().required(),
  name: Yup91.string(),
  identifiers: Yup91.array(Yup91.string().required()),
  parentIds: Yup91.array(Yup91.string().required()),
  areaIds: Yup91.array(Yup91.string().required()),
  requestFareConfirmation: Yup91.boolean(),
  externalId: Yup91.string(),
  type: Yup91.string().oneOf(unitTypes),
  department: Yup91.string(),
  defaultFarePositionFromThis: Yup91.string().oneOf(farePositions),
  specialties: Yup91.array(Yup91.string().oneOf(unitSpecialties).required()),
  medicalSpecialtyIds: Yup91.array(Yup91.string().required()),
  contacts: Yup91.array().of(ContactValidation.required()),
  autoComputeOccupanciesActivated: Yup91.boolean(),
  responsibleUnits: Yup91.array(Yup91.string().required()),
  autoComputeDischarge: Yup91.boolean(),
  isEmergency: Yup91.boolean(),
  isMaternityUnit: Yup91.boolean(),
  isResponsibleUnit: Yup91.boolean(),
  isTransitUnit: Yup91.boolean(),
  manualOccupancyActivated: Yup91.boolean(),
  manualOccupancy: ManualOccupancyValidation.default(void 0),
  defaultManualOccupancy: ManualOccupancyValidation.default(void 0),
  visibilityConfig: VisibilityConfigValidation.default(void 0),
  partOfId: Yup91.string()
});
var updateUnit = buildCloudFunctionRunner("update-unit");

// src/cloud/update-organizations-parent/update-organizations-parent.ts
import * as Yup92 from "yup";
var UpdateOrganizationsParentValidation = Yup92.object({
  organizationIds: Yup92.array().of(Yup92.string().required()).required().min(1),
  axis: Yup92.string().oneOf(writableStructureAxes).required(),
  parentId: Yup92.string().required().nullable()
});
var updateOrganizationsParentRoute = "update-organizations-parent";
var updateOrganizationsParent = buildCloudFunctionRunner(updateOrganizationsParentRoute);

// src/cloud/update-organizations-visibility/update-organizations-visibility.ts
import * as Yup93 from "yup";
var UpdateOrganizationsVisibilityValidation = Yup93.object({
  organizationIds: Yup93.array().of(Yup93.string().required()).required().min(1),
  visibilityConfig: VisibilityConfigValidation.required()
});
var updateOrganizationsVisibilityRoute = "update-organizations-visibility";
var updateOrganizationsVisibility = buildCloudFunctionRunner(updateOrganizationsVisibilityRoute);

// src/cloud/updateSpecialty.ts
import * as Yup94 from "yup";
var UpdateSpecialtyValidation = Yup94.object({
  id: Yup94.string().required(),
  name: Yup94.string(),
  shortName: Yup94.string(),
  quota: Yup94.number()
});
var updateSpecialty = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-specialty", params, options);
};

// src/cloud/updateUserConfig.ts
import * as Yup95 from "yup";
var UpdateUserConfigValidation = Yup95.object({
  lastSelectedUnits: Yup95.array(Yup95.string().required()),
  lastSelectedEmergencyUnits: Yup95.array(Yup95.string().required()).nullable(),
  patientPlacementView: Yup95.string().oneOf(patientPlacementViews),
  serviceViewZoomLevel: Yup95.number().min(0.5).max(1.5)
});
var updateUserConfig = buildCloudFunctionRunner(
  "update-user-config"
);

// src/cloud/updateUserProfile.ts
import * as Yup96 from "yup";
var UpdateUserProfileValidation = Yup96.object({
  id: Yup96.string().required(),
  identifiers: Yup96.array().of(Yup96.string().required()),
  navigationACL: Yup96.array().of(Yup96.string().oneOf(NAVIGATION_ROUTES).required()),
  isReadOnly: Yup96.boolean(),
  hasAccessToAllUnits: Yup96.boolean(),
  actionPermissions: profileActionsValidation.default(void 0),
  anonymousMode: Yup96.string().oneOf(anonymousModes).notRequired()
});
var updateUserProfile = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-user-profile",
    params,
    options
  );
};

// src/cloud/view/createView.ts
import * as Yup98 from "yup";

// src/cloud/validations/viewFilters.ts
import * as Yup97 from "yup";
var UnitViewFilterValidation = Yup97.object({
  statuses: Yup97.array().of(Yup97.string().oneOf(BED_STATUSES).required()).default([]),
  genders: Yup97.array().of(Yup97.string().oneOf(patientGender).required()).default([]),
  specificities: Yup97.array().of(Yup97.string().required()).default([]),
  locationSpecificities: Yup97.array().of(Yup97.string().required()).default([]),
  medicalSpecialties: Yup97.array().of(Yup97.string().required()).default([]),
  practitioners: Yup97.array().of(Yup97.string().required()).default([]),
  patientOutcomes: Yup97.array().of(Yup97.string().required()).default([]),
  medicallyOutgoing: Yup97.array().of(Yup97.boolean().required()).default([]),
  accommodated: Yup97.array().of(Yup97.boolean().required()).default([]),
  view: Yup97.string().oneOf(unitViewsTypes).default("grid"),
  period: Yup97.string().oneOf(periods).default("week"),
  date: Yup97.date().nullable().default(null),
  search: Yup97.string().default(""),
  units: Yup97.array().of(Yup97.string().required()).default([]),
  tableColumns: Yup97.mixed(),
  activeTabs: Yup97.mixed(),
  dashboardParams: Yup97.mixed()
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const {
    units,
    statuses,
    genders,
    specificities,
    medicalSpecialties,
    practitioners,
    patientOutcomes,
    medicallyOutgoing,
    accommodated,
    view,
    period,
    date: date46,
    search,
    tableColumns,
    activeTabs,
    dashboardParams
  } = value || {};
  const hasWidgetState = !!tableColumns && Object.keys(tableColumns).length > 0 || !!activeTabs && Object.keys(activeTabs).length > 0 || !!dashboardParams && Object.keys(dashboardParams).length > 0;
  return hasWidgetState || [
    units,
    statuses,
    genders,
    specificities,
    medicalSpecialties,
    practitioners,
    patientOutcomes,
    medicallyOutgoing,
    accommodated,
    view,
    period,
    date46,
    search
  ].some((field) => Array.isArray(field) ? field.length > 0 : field !== void 0);
});
var ServiceViewFilterValidation = Yup97.object({
  statuses: Yup97.array().of(Yup97.string().oneOf(BED_STATUSES).required()).default([]),
  genders: Yup97.array().of(Yup97.string().oneOf(patientGender).required()).default([]),
  specificities: Yup97.array().of(Yup97.string().required()).default([]),
  locationSpecificities: Yup97.array().of(Yup97.string().required()).default([]),
  medicalSpecialties: Yup97.array().of(Yup97.string().required()).default([]),
  careSectors: Yup97.array().of(Yup97.string().required()).default([]),
  practitioners: Yup97.array().of(Yup97.string().required()).default([]),
  patientOutcomes: Yup97.array().of(Yup97.string().required()).default([]),
  medicallyOutgoing: Yup97.array().of(Yup97.boolean().required()).default([]),
  accommodated: Yup97.array().of(Yup97.boolean().required()).default([]),
  view: Yup97.string().oneOf(unitViewsTypes).default("grid"),
  period: Yup97.string().oneOf(periods).default("week"),
  date: Yup97.date().nullable().default(null),
  search: Yup97.string().default(""),
  units: Yup97.array().of(Yup97.string().required()).default([]),
  tableColumns: Yup97.mixed(),
  activeTabs: Yup97.mixed(),
  dashboardParams: Yup97.mixed()
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const {
    units,
    statuses,
    genders,
    specificities,
    medicalSpecialties,
    careSectors,
    practitioners,
    patientOutcomes,
    medicallyOutgoing,
    accommodated,
    view,
    period,
    date: date46,
    search,
    tableColumns,
    activeTabs,
    dashboardParams
  } = value || {};
  const hasWidgetState = !!tableColumns && Object.keys(tableColumns).length > 0 || !!activeTabs && Object.keys(activeTabs).length > 0 || !!dashboardParams && Object.keys(dashboardParams).length > 0;
  return hasWidgetState || [
    units,
    statuses,
    genders,
    specificities,
    medicalSpecialties,
    careSectors,
    practitioners,
    patientOutcomes,
    medicallyOutgoing,
    accommodated,
    view,
    period,
    date46,
    search
  ].some((field) => Array.isArray(field) ? field.length > 0 : field !== void 0);
});
var MovementsViewFilterValidation = Yup97.object({
  units: Yup97.array().of(Yup97.string().required()).default([]),
  genders: Yup97.array().of(Yup97.string().oneOf(patientGender).required()).default([]),
  specificities: Yup97.array().of(Yup97.string().required()).default([]),
  date: Yup97.date().nullable().default(null),
  flow: Yup97.string().oneOf(movementsFlowTypes).default("admission"),
  view: Yup97.string().oneOf(movementsViewTypes).default("kanban"),
  search: Yup97.string().default(""),
  movementTypes: Yup97.array().of(Yup97.string().oneOf(movementTypesFilters).required()).default([]),
  movementStatuses: Yup97.array().of(Yup97.string().oneOf(movementStatusesFilters).required()).default([]),
  practitioners: Yup97.array().of(Yup97.string().required()).default([]),
  creationOrigin: Yup97.array().of(Yup97.string().oneOf(patientCreationOrigins).required()).default([]),
  medicallyOutgoing: Yup97.array().of(Yup97.boolean().required()).default([]),
  accommodated: Yup97.array().of(Yup97.boolean().required()).default([])
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const {
    units,
    genders,
    specificities,
    date: date46,
    flow,
    view,
    search,
    movementTypes,
    movementStatuses,
    practitioners,
    creationOrigin,
    medicallyOutgoing,
    accommodated
  } = value || {};
  return [
    units,
    genders,
    specificities,
    date46,
    flow,
    view,
    search,
    movementTypes,
    movementStatuses,
    practitioners,
    creationOrigin,
    medicallyOutgoing,
    accommodated
  ].some((field) => Array.isArray(field) ? field.length > 0 : field !== void 0);
});
var HealthCenterViewFilterValidation = Yup97.object({
  units: Yup97.array().of(Yup97.string().required()).default([]),
  occupancies: Yup97.array().of(Yup97.string().oneOf(occupancyFiltersType).required()).default([]),
  specialties: Yup97.array().of(Yup97.string().oneOf(unitSpecialties).required()).default([]),
  medicalSpecialties: Yup97.array().of(Yup97.string().required()).default([]),
  flow: Yup97.string().oneOf(healthCenterFlowTypes).default("departments"),
  tableColumns: Yup97.mixed(),
  activeTabs: Yup97.mixed(),
  dashboardParams: Yup97.mixed()
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const { units, occupancies, specialties, medicalSpecialties, flow, tableColumns, activeTabs, dashboardParams } = value || {};
  const hasWidgetState = !!tableColumns && Object.keys(tableColumns).length > 0 || !!activeTabs && Object.keys(activeTabs).length > 0 || !!dashboardParams && Object.keys(dashboardParams).length > 0;
  return hasWidgetState || [units, occupancies, specialties, medicalSpecialties, flow].some(
    (field) => Array.isArray(field) ? field.length > 0 : field !== void 0
  );
});
var TerritoryViewFilterValidation = Yup97.object({
  healthCenters: Yup97.array().of(Yup97.string().required()).default([]),
  sectors: Yup97.array().of(Yup97.string().oneOf(unitSectors).required()).default([]),
  tensions: Yup97.array().of(Yup97.string().oneOf(occupancyFiltersType).required()).default([]),
  flow: Yup97.string().oneOf(territoryFlowTypes).default("departments"),
  view: Yup97.string().oneOf(territoryViewTypes).default("list"),
  tableColumns: Yup97.mixed(),
  activeTabs: Yup97.mixed(),
  dashboardParams: Yup97.mixed()
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const { healthCenters, sectors, tensions, flow, view, tableColumns, activeTabs, dashboardParams } = value || {};
  const hasWidgetState = !!tableColumns && Object.keys(tableColumns).length > 0 || !!activeTabs && Object.keys(activeTabs).length > 0 || !!dashboardParams && Object.keys(dashboardParams).length > 0;
  return hasWidgetState || [healthCenters, sectors, tensions, flow, view].some(
    (field) => Array.isArray(field) ? field.length > 0 : field !== void 0
  );
});
var EmergencyViewFilterValidation = Yup97.object({
  units: Yup97.array().of(Yup97.string().required()).default([]),
  page: Yup97.string().oneOf(emergencyPages).default("present-patients"),
  search: Yup97.string().default(""),
  statuses: Yup97.array().of(Yup97.string().oneOf(BED_STATUSES).required()).default([]),
  genders: Yup97.array().of(Yup97.string().oneOf(patientGender).required()).default([]),
  specificities: Yup97.array().of(Yup97.string().required()).default([]),
  practitioners: Yup97.array().of(Yup97.string().required()).default([]),
  accommodated: Yup97.array().of(Yup97.boolean().required()).default([])
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const { units, page, search, statuses, genders, specificities, practitioners, accommodated } = value || {};
  return [units, page, search, statuses, genders, specificities, practitioners, accommodated].some(
    (field) => Array.isArray(field) ? field.length > 0 : field !== void 0
  );
});
var RequestsViewFilterValidation = Yup97.object({
  types: Yup97.array().of(Yup97.string().oneOf(requestsDisplayedTypes).required()).default([]),
  requestStatuses: Yup97.array().of(Yup97.string().oneOf(requestStatuses).required()).default([]),
  orientationUnitIds: Yup97.array().of(Yup97.string().required()).default([]),
  originUnitIds: Yup97.array().of(Yup97.string().required()).default([]),
  destinationUnitIds: Yup97.array().of(Yup97.string().required()).default([]),
  createdSince: Yup97.string().oneOf(requestsCreatedSinceOptions).notRequired(),
  createdSinceDirection: Yup97.string().oneOf(requestsCreatedSinceDirections).notRequired(),
  specificities: Yup97.array().of(Yup97.string().required()).default([]),
  accommodated: Yup97.array().of(Yup97.boolean().required()).default([]),
  search: Yup97.string().default("")
}).test("at-least-one-field", i18n.atLeastOneField, (value) => {
  const {
    types,
    requestStatuses: statuses,
    orientationUnitIds,
    originUnitIds,
    destinationUnitIds,
    createdSince,
    specificities,
    accommodated,
    search
  } = value || {};
  return [
    types,
    statuses,
    orientationUnitIds,
    originUnitIds,
    destinationUnitIds,
    createdSince,
    specificities,
    accommodated,
    search
  ].some((field) => Array.isArray(field) ? field.length > 0 : field !== void 0 && field !== "" && field !== null);
});

// src/cloud/view/createView.ts
var createViewRoute = "create-view";
var CreateViewValidation = Yup98.object({
  healthCenterId: Yup98.string().required(),
  name: Yup98.string().trim().required(i18n.nameFieldRequired),
  type: Yup98.string().oneOf(configurableViewTypes).required(),
  filter: Yup98.mixed().test("filter-validation", i18n.invalidViewFilter, function(value) {
    const { type } = this.parent;
    switch (type) {
      case "unit":
        return UnitViewFilterValidation.isValidSync(value);
      case "service":
        return ServiceViewFilterValidation.isValidSync(value);
      case "movements":
        return MovementsViewFilterValidation.isValidSync(value);
      case "emergency":
        return EmergencyViewFilterValidation.isValidSync(value);
      case "healthCenter":
        return HealthCenterViewFilterValidation.isValidSync(value);
      case "territory":
        return TerritoryViewFilterValidation.isValidSync(value);
      case "requests":
        return RequestsViewFilterValidation.isValidSync(value);
      default:
        return Yup98.object().isValidSync(value);
    }
  }).required()
});
var createView = buildCloudFunctionRunner(
  createViewRoute
);

// src/cloud/view/manageViews.ts
import * as Yup99 from "yup";
var manageViewsRoute = "manage-views";
var ManageViewsValidation = Yup99.object({
  type: Yup99.string().oneOf(configurableViewTypes).required(),
  views: Yup99.array().of(
    Yup99.object({
      id: Yup99.string().required(),
      name: Yup99.string().required(),
      index: Yup99.number().min(0).required(),
      shouldDelete: Yup99.boolean().required()
    })
  ).required()
});
var manageViews = buildCloudFunctionRunner(manageViewsRoute);

// src/cloud/acknowledgeFareAssignation.ts
import * as Yup100 from "yup";
var AcknowledgeFareAssignationValidation = Yup100.object({
  fareId: Yup100.string().required()
});
var acknowledgeFareAssignation = (params, options) => {
  return parse_instance_browser_default.Cloud.run("acknowledge-fare-assignation", params, options);
};
var acknowledgeFareAssignation_default = acknowledgeFareAssignation;

// src/cloud/assignFare.ts
import * as Yup101 from "yup";
var AssignFareValidation = Yup101.object({
  fareId: Yup101.string().required(),
  porterId: Yup101.string().required()
});
var assignFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("assign-fare", params, options);
};
var assignFare_default = assignFare;

// src/cloud/cancelConfirmFare.ts
import * as Yup102 from "yup";
var CancelConfirmFareValidation = Yup102.object({
  fareId: Yup102.string().required(i18n.fareIdRequired)
});
var cancelConfirmFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "cancel-confirm-fare",
    params,
    options
  );
};
var cancelConfirmFare_default = cancelConfirmFare;

// src/cloud/cancelFare.ts
var cancelFare = buildCloudFunctionRunner("cancel-fare");

// src/cloud/cancelJourney/cancelJourney.ts
import * as Yup103 from "yup";
var CancelJourneyValidation = Yup103.object({
  journeyId: Yup103.string().required()
});
var cancelJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("cancel-journey", params, options);
};

// src/cloud/clearAnomaly.ts
import * as Yup104 from "yup";
var ClearAnomalyValidation = Yup104.object({
  anomalyId: Yup104.string().required()
});
var clearAnomaly = (params, options) => parse_instance_browser_default.Cloud.run("clear-anomaly", params, options);
var clearAnomaly_default = clearAnomaly;

// src/cloud/confirmFare.ts
import * as Yup105 from "yup";
var ConfirmFareValidation = Yup105.object({
  fareId: Yup105.string().required(i18n.fareIdRequired)
});
var confirmFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("confirm-fare", params, options);
};
var confirmFare_default = confirmFare;

// src/cloud/create-partial-patient/create-partial-patient.ts
import * as Yup106 from "yup";
var CreatePartialPatientValidation = Yup106.object({
  gender: Yup106.mixed().required(),
  firstName: Yup106.string().required(),
  lastName: Yup106.string().required(),
  legalName: Yup106.string(),
  legalFirstName: Yup106.string(),
  birthdate: Yup106.date().required(),
  ipp: Yup106.string(),
  pan: Yup106.string(),
  healthCenterId: Yup106.string(),
  createdFrom: Yup106.string().oneOf(patientCreationSources),
  admitReason: Yup106.string(),
  thesaurusItemId: Yup106.string()
});
var createPartialPatientRoute = "create-partial-patient";
var createPartialPatient = buildCloudFunctionRunner(
  createPartialPatientRoute
);

// src/cloud/createExternalAuthUnitRule.ts
import * as Yup107 from "yup";
var CreateExternalAuthUnitRuleValidation = Yup107.object({
  healthCenterId: Yup107.string().required(),
  name: Yup107.string().required(),
  externalIdentifiers: Yup107.array(Yup107.string().required()).required(),
  internalIdentifiers: Yup107.array(Yup107.string().required()).required()
});
var createExternalAuthUnitRule = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-external-auth-unit-rule",
    params,
    options
  );
};

// src/cloud/createFare.ts
import * as Yup108 from "yup";
var CreateFareValidation = Yup108.object({
  patientId: Yup108.string().required(i18n.patientRequired),
  specificities: Yup108.array(Yup108.string().required()),
  position: Yup108.string().oneOf(farePositions, i18n.positionRequired).required(i18n.positionRequired),
  comment: Yup108.string(),
  isEmergency: Yup108.boolean().required(),
  wantedDate: Yup108.date().when("isEmergency", { is: false, then: () => Yup108.date().required(i18n.dateRequired) }),
  roundTrip: Yup108.boolean(),
  fromAreaId: Yup108.string(),
  toAreaId: Yup108.string(),
  fromUnitId: Yup108.string().required(i18n.unitRequired),
  toUnitId: Yup108.string().required(i18n.unitRequired),
  isReturnTripFromFareId: Yup108.string(),
  procedureExternalId: Yup108.string(),
  needUnitConfirmation: Yup108.boolean(),
  fromStep: Yup108.object().shape({
    id: Yup108.string().required(),
    type: Yup108.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0),
  toStep: Yup108.object().shape({
    id: Yup108.string().required(),
    type: Yup108.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0)
});
var createFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-fare", params, options);
};
var createFare_default = createFare;

// src/cloud/createGamExport.ts
import * as Yup109 from "yup";
var CreateGamExportValidation = Yup109.object({
  source: Yup109.string().required(),
  fileDate: Yup109.date().required(),
  surnumeraryPatients: Yup109.array().required(),
  exportPatients: Yup109.array().required()
});
var createGamExport = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-gam-export", params, options);
};
var createGamExport_default = createGamExport;

// src/cloud/createHealthCenter.ts
import * as Yup112 from "yup";

// src/cloud/validations/healthCenterConfig.ts
import * as Yup111 from "yup";

// src/cloud/validations/occupancyLevel.ts
import * as Yup110 from "yup";
var OccupancyLevelValidation = Yup110.object({
  maxOccupancyRate: Yup110.number().min(0).nullable().defined(),
  color: Yup110.string().oneOf(OCCUPANCY_LEVEL_COLORS).required()
});

// src/cloud/validations/healthCenterConfig.ts
var InteropRulesValidation = Yup111.object({
  emptyDischargeDateManualOverride: Yup111.boolean(),
  autoConfirmDischarges: Yup111.boolean(),
  movementProcessingEnabled: Yup111.boolean(),
  requestLinkFromInteropEnabled: Yup111.boolean(),
  enabledMovementTypes: Yup111.array(Yup111.string().oneOf(Object.values(InteropMovementTypes)).required()).optional(),
  pendingLocationMutationEnabled: Yup111.boolean(),
  responsiblePractitionerEnabled: Yup111.boolean(),
  dischargeDestinationEnabled: Yup111.boolean(),
  admitMessageStorageEnabled: Yup111.boolean()
});
var MovementRequestTypeConfigValidation = Yup111.object({
  routingMode: Yup111.string().oneOf(movementRequestRoutingModeOptions).required(),
  orientationEnabled: Yup111.boolean().required()
});
var MovementRequestConfigValidation = Yup111.object({
  hospitalization: MovementRequestTypeConfigValidation.required(),
  mutation: MovementRequestTypeConfigValidation.required(),
  directAdmission: MovementRequestTypeConfigValidation.required()
});
var ContextualLinkValidation = Yup111.object({
  label: Yup111.string().required().min(1).max(50),
  url: Yup111.string().required()
});
var MetabaseConfigValidationSchema = Yup111.object({
  dashboardId: Yup111.string().required(),
  isActivated: Yup111.boolean().required(),
  enableAggregateCompute: Yup111.boolean(),
  qaDashboardId: Yup111.string(),
  patientTransportDashboardId: Yup111.string(),
  isPatientTransportActivated: Yup111.boolean()
});
var CapacityConfigValidation = Yup111.object({
  enabled: Yup111.boolean().default(false),
  adjustmentMode: Yup111.string().oneOf(capacityPeriodAdjustmentModes).default("override"),
  mode: Yup111.string().oneOf(capacityModes).default("fixed"),
  allowHistoryActions: Yup111.boolean().default(false)
});
var HealthCenterConfigValidation = Yup111.object({
  environmentalCleaning: Yup111.string().oneOf(environmentalCleaningOptions),
  roomDetailsDisplayEnabled: Yup111.boolean(),
  hospitalizationReasonDisplayEnabled: Yup111.boolean(),
  bufferZoneDisplayEnabled: Yup111.boolean(),
  crisisBannerEnabled: Yup111.boolean(),
  crisisBannerTitle: Yup111.string().when("crisisBannerEnabled", {
    is: true,
    then: (schema) => schema.required(i18n.crisisBannerTitleRequired).test("not-empty", i18n.crisisBannerTitleRequired, (value) => !!value && value.trim().length > 0),
    otherwise: (schema) => schema.notRequired()
  }),
  crisisBannerContent: Yup111.string(),
  crisisBannerColor: Yup111.string().oneOf(crisisBannerColors).when("crisisBannerEnabled", {
    is: true,
    then: (schema) => schema.required(i18n.crisisBannerColorRequired),
    otherwise: (schema) => schema.notRequired()
  }),
  customSpecificitiesEnabled: Yup111.boolean(),
  thesaurusEnabled: Yup111.boolean(),
  thesaurusReasonEnabled: Yup111.boolean(),
  thesaurusUnitsSuggestionsEnabled: Yup111.boolean(),
  thesaurusAutocomputeDischargeDateEnabled: Yup111.boolean(),
  multiUnitOnKurtViews: Yup111.boolean(),
  interopStructureConnectorEnabled: Yup111.boolean(),
  medicalSpecialtiesEnabled: Yup111.boolean(),
  computeEmergencyOccupancies: Yup111.string().oneOf(computeEmergencyOccupanciesOptions),
  viaTrajectoireEnabled: Yup111.boolean(),
  viaTrajectoireCodeSih: Yup111.string(),
  autoDispatchEnabled: Yup111.boolean(),
  autoDispatchAnticipationTime: Yup111.number(),
  autoDispatchDelayBetweenAssignations: Yup111.number(),
  fareGroupEnabled: Yup111.boolean(),
  fareGroupTimeInterval: Yup111.number(),
  portersLimitByFarePosition: Yup111.object().shape({
    LYING_DOWN: Yup111.number().required(),
    LYING_DOWN_BED: Yup111.number().required(),
    SITTING_UP: Yup111.number().required(),
    WALKING: Yup111.number().required()
  }).default(void 0),
  nightAndWeekendEnabled: Yup111.boolean(),
  nightAndWeekendStartAt: Yup111.date().nullable(),
  updateOccupanciesDelay: Yup111.number(),
  quotasReachedDisplayEnabled: Yup111.boolean(),
  bedClosingReasonEnabled: Yup111.boolean(),
  bedClosingReasonRequired: Yup111.boolean(),
  bedBlockReasonRequired: Yup111.boolean(),
  capacityAdjustmentReasonRequired: Yup111.boolean(),
  reservationReasonRequired: Yup111.boolean(),
  appointmentsDisplayEnabled: Yup111.boolean(),
  appointmentFaresEnabled: Yup111.boolean(),
  interopRules: InteropRulesValidation.default(void 0),
  patientAddressDisplayEnabled: Yup111.boolean(),
  occupancyLevels: Yup111.array(OccupancyLevelValidation),
  showFaresFromKurtDialogs: Yup111.boolean(),
  medicallyOutgoingDisplayEnabled: Yup111.boolean(),
  hidePatientSearchInDirectAdmissionForm: Yup111.boolean(),
  directAdmissionOccurrenceDateEnabled: Yup111.boolean(),
  hospitalizationRequestOccurrenceDateEnabled: Yup111.boolean(),
  internalMutationOccurrenceDateEnabled: Yup111.boolean(),
  appBarSearchEnabled: Yup111.boolean(),
  patientPlacementWeekViewEnabled: Yup111.boolean(),
  dataExportToOPBIEnabled: Yup111.boolean(),
  dataExportToCustomerEnabled: Yup111.boolean(),
  overrideExternalAuthProfile: Yup111.boolean(),
  overrideExternalAuthUnits: Yup111.boolean(),
  multifinessMutationEnabled: Yup111.boolean(),
  metabaseConfig: MetabaseConfigValidationSchema.default(void 0),
  searchPatientWithSearchIndex: Yup111.boolean(),
  displayPatientJourneyInDetailsDialog: Yup111.boolean(),
  contextualLink: Yup111.string(),
  contextualLinks: Yup111.array(ContextualLinkValidation).max(4),
  closedAndAdditionalBedsInManualOccupancyEnabled: Yup111.boolean(),
  patientSearchVersion: Yup111.string(),
  patientSearchAutocompleteVersion: Yup111.string(),
  movementRequestConfig: MovementRequestConfigValidation.default(void 0),
  bedClosingFromStructureEnabled: Yup111.boolean(),
  transitUnitsEnabled: Yup111.boolean(),
  capacityConfig: CapacityConfigValidation.default(void 0),
  financialAxisEnabled: Yup111.boolean()
});

// src/cloud/createHealthCenter.ts
var HealthCenterGroupValidationSchema = Yup112.object({
  name: Yup112.string().required()
});
var CreateHealthCenterValidation = Yup112.object({
  name: Yup112.string().required(),
  endOfShiftPorterActivated: Yup112.boolean(),
  fareGroupActivated: Yup112.boolean(),
  username: Yup112.string(),
  externalCpageId: Yup112.string(),
  fareGroupTimeInterval: Yup112.number(),
  location: Yup112.object().optional().default(void 0).shape({
    longitude: Yup112.number().required(),
    latitude: Yup112.number().required()
  }),
  autodispatchActivated: Yup112.boolean(),
  autoComputeOccupanciesActivated: Yup112.boolean(),
  autodispatchTimeInMinutesAnticipation: Yup112.number(),
  groups: Yup112.array().optional().of(HealthCenterGroupValidationSchema.required()),
  finess: Yup112.string(),
  assigningAuthority: Yup112.string(),
  rorOptions: Yup112.object({
    username: Yup112.string(),
    isActivated: Yup112.boolean(),
    affiliatedRor: Yup112.string().oneOf(rorTypes),
    receiverEmail: Yup112.string().email()
  }),
  computeAnomaliesActivated: Yup112.boolean(),
  bookedBedDelayRule: Yup112.object().shape({
    type: Yup112.string().oneOf(delayRuleTypes).required(),
    value: Yup112.number().required()
  }).default(void 0),
  autoComputeDischarge: Yup112.boolean(),
  config: HealthCenterConfigValidation.default(void 0)
});
var createHealthCenter = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "create-health-center",
    params,
    {
      useMasterKey: true
    }
  );
};
var createHealthCenter_default = createHealthCenter;

// src/cloud/createIncident.ts
import * as Yup113 from "yup";
var CreateIncidentValidation = Yup113.object({
  fareId: Yup113.string().required(),
  reason: Yup113.string().oneOf(incidentReasons).required(),
  comment: Yup113.string(),
  delayInMinutes: Yup113.number(),
  adequateTransport: Yup113.string().oneOf(farePositions),
  helpRequired: Yup113.number(),
  unassignmentRequested: Yup113.boolean()
});
var createIncident = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-incident", params, options);
};
var createIncident_default = createIncident;

// src/cloud/createJourney/createJourney.ts
import * as Yup114 from "yup";
var CreateJourneyStepValidation = Yup114.object({
  toUnitId: Yup114.string().required(i18n.unitRequired),
  toAreaId: Yup114.string(),
  wantedDate: Yup114.date().required(i18n.dateRequired)
});
var CreateJourneyValidation = Yup114.object({
  patientId: Yup114.string().required(i18n.patientRequired),
  roundTrip: Yup114.boolean().required(),
  position: Yup114.string().oneOf(farePositions).required(i18n.positionRequired),
  comment: Yup114.string(),
  isEmergency: Yup114.boolean(),
  specificities: Yup114.array().of(Yup114.string().required()),
  customSpecificities: Yup114.array().of(
    Yup114.object({
      id: Yup114.string().required(),
      name: Yup114.string().required(),
      icon: Yup114.string(),
      color: Yup114.string().required(),
      description: Yup114.string()
    })
  ),
  fromUnitId: Yup114.string().required(i18n.unitRequired),
  fromAreaId: Yup114.string(),
  steps: Yup114.array().of(CreateJourneyStepValidation.required()).required()
});
var createJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-journey", params, options);
};

// src/cloud/createPathDefaultTime.ts
import * as Yup115 from "yup";
var CreatePathDefaultTimeValidation = Yup115.object({
  fromAreaId: Yup115.string().required(),
  toAreaId: Yup115.string().required(),
  durationInSeconds: Yup115.number().required(),
  weight: Yup115.number().required(),
  position: Yup115.string().oneOf(farePositions).required()
});
var pathDefaultTime = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "create-path-default-time",
    params,
    {
      useMasterKey: true
    }
  );
};
var createPathDefaultTime_default = pathDefaultTime;

// src/cloud/createPractitioner/createPractitioner.ts
import * as Yup117 from "yup";

// src/cloud/validations/interopIdentifier.ts
import * as Yup116 from "yup";
var InteropIdentifierValidation = Yup116.object({
  value: Yup116.string().required(),
  type: Yup116.string()
});

// src/cloud/createPractitioner/createPractitioner.ts
var CreatePractitionerValidation = Yup117.object({
  firstName: Yup117.string().required(),
  lastName: Yup117.string().required(),
  unitIds: Yup117.array().of(Yup117.string().required()).required().min(1),
  color: Yup117.string(),
  identifiers: Yup117.array().of(InteropIdentifierValidation.required())
});
var createPractitionerRoute = "create-practitioner";
var createPractitioner = buildCloudFunctionRunner(
  createPractitionerRoute
);

// src/cloud/createSpecificity/createSpecificity.ts
import * as Yup119 from "yup";

// src/cloud/validations/specificityQuickAccess.ts
import * as Yup118 from "yup";
var SpecificityQuickAccessSettingValidation = Yup118.object({
  index: Yup118.number().integer().min(0).required().nullable()
});
var SpecificityQuickAccessValidation = Yup118.object({
  hospitalization: SpecificityQuickAccessSettingValidation.default(void 0),
  mutation: SpecificityQuickAccessSettingValidation.default(void 0),
  directAdmission: SpecificityQuickAccessSettingValidation.default(void 0)
});

// src/cloud/createSpecificity/createSpecificity.ts
var CreateSpecificityValidation = Yup119.object({
  healthCenterId: Yup119.string().required(),
  type: Yup119.string().oneOf(specificityTypes).required(),
  name: Yup119.string().required(),
  icon: Yup119.string(),
  color: Yup119.string().required(),
  description: Yup119.string(),
  externalHl7Identifiers: Yup119.array(Yup119.string().required()),
  isIsolation: Yup119.boolean(),
  showInUnitStats: Yup119.boolean(),
  showInHealthCenterStats: Yup119.boolean(),
  isPrivateRoom: Yup119.boolean(),
  quickAccess: SpecificityQuickAccessValidation.default(void 0)
});
var createSpecificity = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-specificity",
    params,
    options
  );
};

// src/cloud/deleteExternalAuthUnitRule.ts
import * as Yup120 from "yup";
var DeleteExternalAuthUnitRuleValidation = Yup120.object({
  id: Yup120.string().required()
});
var deleteExternalAuthUnitRule = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "delete-external-auth-unit-rule",
    params,
    options
  );
};

// src/cloud/dispatchFare.ts
var dispatchFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("dispatch-fare", params, options);
};
var dispatchFare_default = dispatchFare;

// src/cloud/emergencyOccupancy/getHealthCenterEmergencyOccupancies.ts
import * as Yup121 from "yup";
var GetHealthCenterEmergencyOccupanciesValidation = Yup121.object({
  healthCenter: Yup121.string().required()
});
var getHealthCenterEmergencyOccupancies = (params, options) => {
  return parse_instance_browser_default.Cloud.run("get-healthcenter-emergency-occupancies", params, options);
};
var getHealthCenterEmergencyOccupancies_default = getHealthCenterEmergencyOccupancies;

// src/cloud/emergencyOccupancy/updateEmergencyOccupancy.ts
import * as Yup122 from "yup";
var UpdateEmergencyOccupancyValidation = Yup122.object({
  key: Yup122.string().oneOf(emergencyOccupancyKey).required(),
  healthCenterId: Yup122.string().required(),
  service: Yup122.string().oneOf(emergencyOccupancyService).required(),
  averageWaitingTime: Yup122.number().integer(),
  waitingPatients: Yup122.number().integer(),
  currentPatients: Yup122.number().integer().required(),
  availableBeds: Yup122.number().integer(),
  waitingPatientsBySector: Yup122.object({
    Chirurgie: Yup122.number().integer(),
    M\u00E9decine: Yup122.number().integer(),
    Obst\u00E9trique: Yup122.number().integer(),
    P\u00E9diatrie: Yup122.number().integer(),
    R\u00E9animation: Yup122.number().integer(),
    PSY: Yup122.number().integer(),
    SMR: Yup122.number().integer(),
    Urgences: Yup122.number().integer()
  }),
  comment: Yup122.string()
});
var updateEmergencyOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-emergency-occupancy",
    params,
    options
  );
};
var updateEmergencyOccupancy_default = updateEmergencyOccupancy;

// src/cloud/getOverviewStatistics.ts
import * as Yup123 from "yup";
var GetOverviewStatisticsValidation = Yup123.object({
  startDate: Yup123.date().required(),
  endDate: Yup123.date().required(),
  healthCenterId: Yup123.string().required()
});
var getOverviewStatistics = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-overview-statistics",
    params,
    options
  );
};
var getOverviewStatistics_default = getOverviewStatistics;

// src/cloud/getPatientsByName.ts
import * as Yup124 from "yup";
var GetPatientsByNameValidation = Yup124.object({
  name: Yup124.string().required(),
  limit: Yup124.number(),
  unitId: Yup124.string(),
  healthCenterId: Yup124.string().required(),
  onlyActiveVisits: Yup124.boolean(),
  version: Yup124.string()
});
var getPatientsByName = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-patients-by-name",
    params,
    options
  );
};
var getPatientsByName_default = getPatientsByName;

// src/cloud/getPorters.ts
import * as Yup125 from "yup";
var GetPortersValidation = Yup125.object({
  qrCodeKey: Yup125.string().required(),
  healthCenterId: Yup125.string().required()
});
var getPorters = (params, options) => {
  return parse_instance_browser_default.Cloud.run("get-porters", params, options);
};
var getPorters_default = getPorters;

// src/cloud/getSamlLoginRequest.ts
import * as Yup126 from "yup";
var GetSamlLoginRequestValidation = Yup126.object({
  providerId: Yup126.string().required(),
  webRedirectUrl: Yup126.string().required()
});
var getSamlLoginRequest = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "get-saml-login-request",
    params,
    options
  );
};

// src/cloud/getSamlLogoutRequest.ts
import * as Yup127 from "yup";
var GetSamlLogoutRequestValidation = Yup127.object({
  webRedirectUrl: Yup127.string().required()
});
var getSamlLogoutRequest = (params, options) => parse_instance_browser_default.Cloud.run(
  "get-saml-logout-request",
  params,
  options
);

// src/cloud/import-users/import-users.ts
import * as Yup128 from "yup";
var importUsersRoute = "import-users";
var ImportUsersValidation = Yup128.object({
  source: Yup128.string().required(),
  users: Yup128.array().of(
    Yup128.object({
      username: Yup128.string().required(),
      profile: Yup128.string().optional(),
      units: Yup128.array(Yup128.string().required()).optional()
    })
  ).required()
});
var importUsers = buildCloudFunctionRunner(importUsersRoute);

// src/cloud/import-users-file/import-users-file.ts
import * as Yup129 from "yup";
var importUsersFileRoute = "import-users-file";
var ImportUsersFileValidation = Yup129.object({
  source: Yup129.string().required(),
  fileAsBase64: Yup129.string().required()
});
var importUsersFile = buildCloudFunctionRunner(
  importUsersFileRoute
);

// src/cloud/importVisit.ts
import * as Yup130 from "yup";
var ImportVisitValidation = Yup130.object({
  ipp: Yup130.string().required(),
  pan: Yup130.string().required(),
  birthdate: Yup130.date().required(),
  firstName: Yup130.string().required(),
  lastName: Yup130.string().required(),
  legalName: Yup130.string().required(),
  gender: Yup130.string().required(),
  admittedAt: Yup130.date().required(),
  movementStart: Yup130.date().required(),
  accommodationUnit: Yup130.string().required(),
  responsibleUnit: Yup130.string(),
  responsibleNursingUnit: Yup130.string(),
  room: Yup130.string(),
  bed: Yup130.string(),
  source: Yup130.string()
});
var importVisit = (params, options) => {
  return parse_instance_browser_default.Cloud.run("import-visit", params, options);
};
var importVisit_default = importVisit;

// src/cloud/leaveBreak.ts
var leaveBreak = (options) => {
  return parse_instance_browser_default.Cloud.run("leave-break", null, options);
};
var leaveBreak_default = leaveBreak;

// src/cloud/logoutPorter.ts
import * as Yup131 from "yup";
var LogoutPorterValidation = Yup131.object({
  porterId: Yup131.string()
});
var logoutPorter = (params, options) => {
  return parse_instance_browser_default.Cloud.run("logout-porter", params, options);
};
var logoutPorter_default = logoutPorter;

// src/cloud/notifications/acknowledgeNotification.ts
import * as Yup132 from "yup";
var AcknowledgeNotificationValidation = Yup132.object({
  notificationId: Yup132.string().required()
});
var acknowledgeNotification = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "acknowledge-notification",
    params,
    options
  );
};
var acknowledgeNotification_default = acknowledgeNotification;

// src/cloud/notifications/readAllNotifications.ts
import * as Yup133 from "yup";
var ReadAllNotificationsValidation = Yup133.object({
  notificationIds: Yup133.array(Yup133.string().required()).required()
});
var acknowledgeNotification2 = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "read-all-notifications",
    params,
    options
  );
};
var readAllNotifications_default = acknowledgeNotification2;

// src/cloud/notifications/unreadNotification.ts
import * as Yup134 from "yup";
var UnreadNotificationValidation = Yup134.object({
  id: Yup134.string().required()
});
var unreadNotification = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "unread-notification",
    params,
    options
  );
};
var unreadNotification_default = unreadNotification;

// src/cloud/refreshVisit.ts
import * as Yup135 from "yup";
var RefreshVisitValidation = Yup135.object({
  visitId: Yup135.string().required()
});
var refreshVisit = (params, options) => {
  return parse_instance_browser_default.Cloud.run("refresh-visit", params, options);
};
var refreshVisit_default = refreshVisit;

// src/cloud/removeFareAssignation.ts
import * as Yup136 from "yup";
var RemoveFareAssignationValidation = Yup136.object({
  fareId: Yup136.string().required(),
  porterId: Yup136.string().required(),
  fareAssignationId: Yup136.string().required()
});
var removeFareAssignation = (params, options) => {
  return parse_instance_browser_default.Cloud.run("remove-fare-assignation", params, options);
};
var removeFareAssignation_default = removeFareAssignation;

// src/cloud/removePractitioner/removePractitioner.ts
import * as Yup137 from "yup";
var RemovePractitionerValidation = Yup137.object({
  id: Yup137.string().required()
});
var removePractitionerRoute = "remove-practitioner";
var removePractitioner = buildCloudFunctionRunner(
  removePractitionerRoute
);

// src/cloud/replayInteropMessage.ts
import * as Yup138 from "yup";
var ReplayInteropMessageValidation = Yup138.object({
  interopMessageId: Yup138.string().required()
});
var replayInteropMessage = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "replay-interop-message",
    params,
    options
  );
};
var replayInteropMessage_default = replayInteropMessage;

// src/cloud/replayPatientInteropMessages.ts
import * as Yup139 from "yup";
var ReplayPatientInteropMessagesValidation = Yup139.object({
  pan: Yup139.string().required(),
  healthCenterId: Yup139.string().required()
});
var replayPatientInteropMessages = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "replay-patient-interop-messages",
    params,
    options
  );
};
var replayPatientInteropMessages_default = replayPatientInteropMessages;

// src/cloud/resetPorterAfterLogout.ts
import * as Yup140 from "yup";
var ResetPorterAfterLogoutValidation = Yup140.object({
  porterId: Yup140.string().required()
});
var resetPorterAfterLogout = (params) => {
  return parse_instance_browser_default.Cloud.run(
    "reset-porter-after-logout",
    params,
    {
      useMasterKey: true
    }
  );
};
var resetPorterAfterLogout_default = resetPorterAfterLogout;

// src/cloud/setConfigVersion.ts
import * as Yup141 from "yup";
var SetConfigVersionValidation = Yup141.object({
  version: Yup141.string().required(),
  forceUpdate: Yup141.boolean()
});
var setConfigVersion = (params) => {
  return parse_instance_browser_default.Cloud.run("set-config-version", params, {
    useMasterKey: true
  });
};
var setConfigVersion_default = setConfigVersion;

// src/cloud/setPorterUnits.ts
import * as Yup142 from "yup";
var SetPorterUnitsValidation = Yup142.object({
  porterId: Yup142.string().required(i18n.porterIdRequired),
  unitIds: Yup142.array(Yup142.string().required(i18n.unitIdRequired))
});
var setPorterUnits = (params, options) => {
  return parse_instance_browser_default.Cloud.run("set-porter-units", params, options);
};
var setPorterUnits_default = setPorterUnits;

// src/cloud/structure/closeMultipleBeds.ts
import * as Yup143 from "yup";
var CloseMultipleBedsValidation = Yup143.object({
  healthCenterId: Yup143.string().required(),
  areaIds: Yup143.array(Yup143.string().required()).required(),
  startAt: Yup143.date().required(),
  endAt: Yup143.date().min(Yup143.ref("startAt"), i18n.endAtMustBeAfterStartAt),
  comment: Yup143.string(),
  specificities: Yup143.array(Yup143.string().oneOf(accommodationSpecificities).required()),
  customSpecificityIds: Yup143.array(Yup143.string().required()),
  bedClosingReasonId: Yup143.string()
});
var closeMultipleBeds = (params, options) => parse_instance_browser_default.Cloud.run("close-multiple-beds", params, options);
var closeMultipleBeds_default = closeMultipleBeds;

// src/cloud/structure/createArea.ts
import * as Yup144 from "yup";
var AvailabilityPeriodValidation = Yup144.object({
  start: Yup144.date().required(),
  end: Yup144.date().required(),
  status: Yup144.string().oneOf(availabilityPeriodStatus).required()
});
var CreateAreaValidation = Yup144.object({
  name: Yup144.string().required(),
  healthCenterId: Yup144.string().required(),
  externalTypeCode: Yup144.string().oneOf(externalTypeCodes),
  parentId: Yup144.string(),
  externalIds: Yup144.array(Yup144.string().required()),
  isSearchable: Yup144.boolean(),
  availabilityPeriods: Yup144.array().of(AvailabilityPeriodValidation.required()),
  excludedFromOccupancy: Yup144.boolean(),
  supernumerary: Yup144.boolean(),
  geoFiness: Yup144.string(),
  managingOrganizationId: Yup144.string(),
  specificityIds: Yup144.array().of(Yup144.string().required())
});
var createArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-area", params, options);
};
var createArea_default = createArea;

// src/cloud/structure/deleteArea.ts
import * as Yup145 from "yup";
var DeleteAreaValidation = Yup145.object({
  id: Yup145.string().required()
});
var deleteArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("delete-area", params, options);
};
var deleteArea_default = deleteArea;

// src/cloud/structure/getHealthCenterGroups.ts
var getHealthCenterGroups = (options) => {
  return parse_instance_browser_default.Cloud.run("get-healthcenter-groups", null, options);
};
var getHealthCenterGroups_default = getHealthCenterGroups;

// src/cloud/structure/importStructure.ts
import * as Yup146 from "yup";
var ImportStructureValidation = Yup146.object({
  healthCenterId: Yup146.string().required(),
  fileContent: Yup146.string().required()
});
var importStructure = (params, options) => {
  return parse_instance_browser_default.Cloud.run("import-structure", params, options);
};
var importStructure_default = importStructure;

// src/cloud/structure/moveArea.ts
import * as Yup147 from "yup";
var MoveAreaValidation = Yup147.object({
  id: Yup147.string().required(),
  parentId: Yup147.string().required(),
  newExternalIds: Yup147.array(Yup147.string().required()),
  activationDate: Yup147.date()
});
var moveArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("move-area", params, options);
};
var moveArea_default = moveArea;

// src/cloud/structure/updateArea.ts
import * as Yup148 from "yup";
var UpdateAreaValidation = Yup148.object({
  id: Yup148.string().required(),
  name: Yup148.string(),
  healthCenterId: Yup148.string(),
  externalTypeCode: Yup148.string().oneOf(externalTypeCodes),
  parentId: Yup148.string(),
  externalIds: Yup148.array(Yup148.string().required()),
  isSearchable: Yup148.boolean(),
  excludedFromOccupancy: Yup148.boolean(),
  supernumerary: Yup148.boolean(),
  availabilityPeriods: Yup148.array().of(AvailabilityPeriodValidation.required()),
  careSectorId: Yup148.string(),
  geoFiness: Yup148.string(),
  managingOrganizationId: Yup148.string(),
  specificityIds: Yup148.array().of(Yup148.string().required())
});
var updateArea = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-area", params, options);
};
var updateArea_default = updateArea;

// src/cloud/structure/updateAreaAvailabilityPeriods.ts
import * as Yup149 from "yup";
var UpdateAreaAvailabilityPeriodsValidation = Yup149.object({
  id: Yup149.string().required(),
  start: Yup149.date(),
  end: Yup149.date(),
  status: Yup149.string().oneOf(availabilityPeriodStatus).required()
});
var updateAreaAvailabilityPeriods = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-area-availability-periods",
    params,
    options
  );
};
var updateAreaAvailabilityPeriods_default = updateAreaAvailabilityPeriods;

// src/cloud/structure/updateHealthCenter.ts
import * as Yup150 from "yup";
var rorOptionsValidationSchema = Yup150.object({
  username: Yup150.string(),
  isActivated: Yup150.boolean(),
  affiliatedRor: Yup150.string().oneOf(rorTypes),
  receiverEmail: Yup150.string().email()
});
var bookedBedDelayRuleValidationSchema = Yup150.object({
  type: Yup150.string().oneOf(delayRuleTypes).required(),
  value: Yup150.number().required()
});
var UpdateHealthCenterValidation = Yup150.object({
  id: Yup150.string().required(),
  name: Yup150.string(),
  autodispatchActivated: Yup150.boolean(),
  autoComputeOccupanciesActivated: Yup150.boolean(),
  fareGroupActivated: Yup150.boolean(),
  fareGroupTimeInterval: Yup150.number(),
  portersLimitByFarePositionLyingDownBed: Yup150.number(),
  portersLimitByFarePositionLyingDown: Yup150.number(),
  portersLimitByFarePositionSittingUp: Yup150.number(),
  portersLimitByFarePositionWalking: Yup150.number(),
  autodispatchTimeInMinutesAnticipation: Yup150.number(),
  groups: Yup150.array().of(HealthCenterGroupValidationSchema.required()),
  finess: Yup150.string(),
  rorOptions: rorOptionsValidationSchema.default(void 0),
  computeAnomaliesActivated: Yup150.boolean(),
  bookedBedDelayRule: bookedBedDelayRuleValidationSchema.notRequired().default(void 0),
  hasPediatricService: Yup150.boolean(),
  autoComputeDischarge: Yup150.boolean(),
  location: Yup150.object({
    latitude: Yup150.number().required(),
    longitude: Yup150.number().required()
  }).default(void 0),
  patientTransportEnabled: Yup150.boolean(),
  chatSupportEnabled: Yup150.boolean(),
  thesaurusEnabled: Yup150.boolean(),
  thesaurusReasonEnabled: Yup150.boolean(),
  thesaurusUnitsSuggestionsEnabled: Yup150.boolean(),
  samlConfig: Yup150.object({
    providerId: Yup150.string().required(),
    idpIssuer: Yup150.string().required(),
    idpCert: Yup150.string().required(),
    entryPoint: Yup150.string().required(),
    profileAttribute: Yup150.string(),
    unitsAttribute: Yup150.string()
  }).notRequired().default(void 0),
  microsoftAuthConfig: Yup150.object({
    domains: Yup150.array().of(Yup150.string().required()).required(),
    profileAttribute: Yup150.string(),
    unitsAttribute: Yup150.string()
  }).notRequired().default(void 0),
  config: HealthCenterConfigValidation.default(void 0)
});
var updateHealthCenter = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-healthcenter",
    params,
    options
  );
};
var updateHealthCenter_default = updateHealthCenter;

// src/cloud/takeBreak.ts
import * as Yup151 from "yup";
var TakeBreakValidation = Yup151.object({
  breakType: Yup151.string().oneOf(porterBreak, i18n.breakTypeRequired).required(i18n.breakTypeRequired)
});
var takeBreak = (params, options) => {
  return parse_instance_browser_default.Cloud.run("take-break", params, options);
};
var takeBreak_default = takeBreak;

// src/cloud/toggleAutodispatch.ts
var toggleAutodispatch = (options) => {
  return parse_instance_browser_default.Cloud.run("toggle-autodispatch", null, options);
};
var toggleAutodispatch_default = toggleAutodispatch;

// src/cloud/unitManualOccupancy/createUnitManualOccupancy.ts
import * as Yup152 from "yup";
var CreateUnitManualOccupancyValidation = Yup152.object({
  open: Yup152.number().required(),
  installed: Yup152.number(),
  reason: Yup152.string(),
  startDate: Yup152.date().required(),
  endDate: Yup152.date().required(),
  unitId: Yup152.string().required(),
  externalId: Yup152.string(),
  bedClosingReason: BedClosingReasonValidationSchema.notRequired().default(void 0)
});
var createUnitManualOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "create-unit-manual-occupancy",
    params,
    options
  );
};

// src/cloud/unitManualOccupancy/removeUnitManualOccupancy.ts
import * as Yup153 from "yup";
var RemoveUnitManualOccupancyValidation = Yup153.object({
  id: Yup153.string(),
  externalId: Yup153.string()
}).test("at-least-one-field", i18n.unitManualOccupancyFieldRequired, (value) => {
  return Boolean(value.id || value.externalId);
});
var removeUnitManualOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "remove-unit-manual-occupancy",
    params,
    options
  );
};

// src/cloud/unitManualOccupancy/updateUnitManualOccupancy.ts
import * as Yup154 from "yup";
var UpdateUnitManualOccupancyValidation = Yup154.object({
  id: Yup154.string(),
  open: Yup154.number(),
  installed: Yup154.number(),
  reason: Yup154.string(),
  startDate: Yup154.date(),
  endDate: Yup154.date(),
  bedClosingReason: BedClosingReasonValidationSchema.notRequired().default(void 0),
  externalId: Yup154.string()
}).test("at-least-one-field", i18n.unitManualOccupancyFieldRequired, (value) => {
  return Boolean(value.id || value.externalId);
});
var updateUnitManualOccupancy = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-unit-manual-occupancy",
    params,
    options
  );
};

// src/cloud/update-specificities/update-specificities.ts
import * as Yup156 from "yup";

// src/cloud/update-specificity.ts
import * as Yup155 from "yup";
var UpdateSpecificityValidation = Yup155.object({
  id: Yup155.string().required(),
  name: Yup155.string(),
  icon: Yup155.string().notRequired(),
  color: Yup155.string(),
  description: Yup155.string().notRequired(),
  externalHl7Identifiers: Yup155.array(Yup155.string().required()),
  isIsolation: Yup155.boolean(),
  showInUnitStats: Yup155.boolean(),
  showInHealthCenterStats: Yup155.boolean(),
  isPrivateRoom: Yup155.boolean(),
  quickAccess: SpecificityQuickAccessValidation.default(void 0)
});
var updateSpecificity = buildCloudFunctionRunner(
  "update-specificity"
);

// src/cloud/update-specificities/update-specificities.ts
var UpdateSpecificitiesValidation = Yup156.object({
  specificities: Yup156.array().of(UpdateSpecificityValidation.required()).required()
});
var updateSpecificitiesRoute = "update-specificities";
var updateSpecificities = buildCloudFunctionRunner(
  updateSpecificitiesRoute
);

// src/cloud/updateExternalAuthUnitRule.ts
import * as Yup157 from "yup";
var UpdateExternalAuthUnitRuleValidation = Yup157.object({
  id: Yup157.string().required(),
  name: Yup157.string(),
  externalIdentifiers: Yup157.array(Yup157.string().required()),
  internalIdentifiers: Yup157.array(Yup157.string().required())
});
var updateExternalAuthUnitRule = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-external-auth-unit-rule",
    params,
    options
  );
};

// src/cloud/updateFare.ts
import * as Yup158 from "yup";
var UpdateFareValidation = Yup158.object({
  patientId: Yup158.string(),
  specificities: Yup158.array(Yup158.string().required()).notRequired(),
  position: Yup158.string().oneOf(farePositions),
  comment: Yup158.string().notRequired(),
  wantedDate: Yup158.date().notRequired(),
  isEmergency: Yup158.boolean(),
  roundTrip: Yup158.boolean(),
  fromAreaId: Yup158.string().notRequired(),
  toAreaId: Yup158.string().notRequired(),
  fromUnitId: Yup158.string(),
  toUnitId: Yup158.string(),
  fareId: Yup158.string().required(i18n.fareIdRequired),
  procedureExternalId: Yup158.string(),
  fromStep: Yup158.object({
    id: Yup158.string().required(),
    type: Yup158.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0),
  toStep: Yup158.object({
    id: Yup158.string().required(),
    type: Yup158.string().oneOf(["accommodation", "appointment"]).required()
  }).default(void 0)
});
var updateFare = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-fare", params, options);
};
var updateFare_default = updateFare;

// src/cloud/updateInstallation.ts
import * as Yup159 from "yup";
var UpdateInstallationValidation = Yup159.object({
  installationId: Yup159.string().required(),
  deviceType: Yup159.string().required(),
  deviceToken: Yup159.string().required()
});
var updateInstallation = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "update-installation",
    params,
    options
  );
};
var updateInstallation_default = updateInstallation;

// src/cloud/updateJourney/updateJourney.ts
import * as Yup160 from "yup";
var UpdateJourneyStepValidation = Yup160.object({
  fareId: Yup160.string(),
  toUnitId: Yup160.string().required(i18n.unitRequired),
  toAreaId: Yup160.string(),
  wantedDate: Yup160.date().required(i18n.dateRequired)
});
var UpdateJourneyValidation = Yup160.object({
  journeyId: Yup160.string().required(),
  patientId: Yup160.string().required(i18n.patientRequired),
  roundTrip: Yup160.boolean().required(),
  position: Yup160.string().oneOf(farePositions).required(i18n.positionRequired).required(),
  comment: Yup160.string(),
  isEmergency: Yup160.boolean(),
  specificities: Yup160.array().of(Yup160.string().required()),
  customSpecificities: Yup160.array().of(
    Yup160.object({
      id: Yup160.string().required(),
      name: Yup160.string().required(),
      icon: Yup160.string(),
      color: Yup160.string().required(),
      description: Yup160.string()
    })
  ),
  fromUnitId: Yup160.string().required(i18n.unitRequired),
  fromAreaId: Yup160.string(),
  steps: Yup160.array().of(UpdateJourneyStepValidation.required()).required()
});
var updateJourney = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-journey", params, options);
};

// src/cloud/updateOccupancy.ts
import * as Yup161 from "yup";
var OccupancyGenderDistributionSchema = Yup161.object({
  indifferent: Yup161.number().integer().required(),
  male: Yup161.number().integer().required(),
  female: Yup161.number().integer().required()
});
var RoomAvailabilitiesSchema = Yup161.object({
  total: Yup161.number().integer().required(),
  single: Yup161.number().integer().required(),
  double: OccupancyGenderDistributionSchema.required()
});
var UpdateSpecificityCountSchema = Yup161.object({
  specificityId: Yup161.string().required(),
  count: Yup161.number().integer().required()
});
var UpdateCurrentOccupancySchema = Yup161.object({
  open: Yup161.number().integer().required(),
  close: Yup161.number().integer().required(),
  availabilities: OccupancyGenderDistributionSchema.required(),
  admissions: Yup161.number().integer().required(),
  discharges: Yup161.number().integer().required(),
  accommodated: Yup161.number().integer().required(),
  rate: Yup161.number().integer().required(),
  available: Yup161.number().integer().required(),
  covid: Yup161.number().integer().required(),
  isolated: Yup161.number().integer().required(),
  isolatedAir: Yup161.number().integer().required(),
  isolatedDroplet: Yup161.number().integer().required(),
  isolatedContact: Yup161.number().integer().required(),
  isolatedProtector: Yup161.number().integer().required(),
  waitingForDownstreamBed: Yup161.number().integer().required(),
  supernumerary: OccupancyGenderDistributionSchema.required(),
  roomAvailabilities: RoomAvailabilitiesSchema.default(void 0),
  booked: Yup161.number().integer().required(),
  specificityCounts: Yup161.array().of(UpdateSpecificityCountSchema.required()).default(void 0)
});
var UpdateOccupancyValidation = Yup161.object({
  covid: Yup161.number().integer().required(),
  isolated: Yup161.number().integer().required(),
  isolatedAir: Yup161.number().integer().required(),
  isolatedDroplet: Yup161.number().integer().required(),
  isolatedContact: Yup161.number().integer().required(),
  isolatedProtector: Yup161.number().integer().required(),
  waitingForDownstreamBed: Yup161.number().integer().required(),
  accomodated: Yup161.number().integer().required(),
  unitId: Yup161.string().required(),
  close: Yup161.number().integer().required(),
  h24Close: Yup161.number().integer().required(),
  h48Close: Yup161.number().integer().required(),
  open: Yup161.number().integer().required(),
  h24Open: Yup161.number().integer().required(),
  h48Open: Yup161.number().integer().required(),
  booked: Yup161.number().integer().required(),
  h24Booked: Yup161.number().integer().required(),
  h48Booked: Yup161.number().integer().required(),
  admission: Yup161.number().integer().required(),
  discharge: Yup161.number().integer().required(),
  dDaySupernumerary: OccupancyGenderDistributionSchema.default(void 0),
  h24Supernumerary: OccupancyGenderDistributionSchema.default(void 0),
  h48Supernumerary: OccupancyGenderDistributionSchema.default(void 0),
  dDayAvailabilities: OccupancyGenderDistributionSchema.required(),
  h24Availabilities: OccupancyGenderDistributionSchema.required(),
  h48Availabilities: OccupancyGenderDistributionSchema.required(),
  dDayRoomAvailabilities: RoomAvailabilitiesSchema.default(void 0),
  h24RoomAvailabilities: RoomAvailabilitiesSchema.default(void 0),
  h48RoomAvailabilities: RoomAvailabilitiesSchema.default(void 0),
  specificityCounts: Yup161.array().of(UpdateSpecificityCountSchema.required()).default(void 0),
  comment: Yup161.string(),
  currentOccupancy: UpdateCurrentOccupancySchema.default(void 0)
});
var updateOccupancyRoute = "update-occupancy";
var updateOccupancy = buildCloudFunctionRunner(
  updateOccupancyRoute
);

// src/cloud/updatePractitioner/updatePractitioner.ts
import * as Yup162 from "yup";
var UpdatePractitionerValidation = Yup162.object({
  id: Yup162.string().required(),
  firstName: Yup162.string(),
  lastName: Yup162.string(),
  color: Yup162.string(),
  unitIds: Yup162.array().of(Yup162.string().required()).min(1),
  identifiers: Yup162.array().of(InteropIdentifierValidation.required())
});
var updatePractitionerRoute = "update-practitioner";
var updatePractitioner = buildCloudFunctionRunner(
  updatePractitionerRoute
);

// src/cloud/users/createUser.ts
import * as Yup163 from "yup";
var CreateUserValidation = Yup163.object({
  username: Yup163.string(),
  role: Yup163.string().oneOf(userRoles).required(),
  firstName: Yup163.string().when("role", {
    is: "PORTER",
    then: () => Yup163.string().required()
  }),
  lastName: Yup163.string().when("role", {
    is: "PORTER",
    then: () => Yup163.string().required()
  }),
  unitId: Yup163.string().when("role", {
    is: "MANAGER",
    then: () => Yup163.string().required()
  }),
  notificationConfigurations: Yup163.array().of(notificationConfigurationValidation.required()),
  units: Yup163.array().of(Yup163.string().required()),
  password: Yup163.string(),
  isUnsafePassword: Yup163.boolean(),
  whitelistedIPs: Yup163.array().of(Yup163.string().required()),
  healthCenterId: Yup163.string().required(),
  userProfileId: Yup163.string(),
  navigationACL: Yup163.array().of(Yup163.string().oneOf(NAVIGATION_ROUTES).required()),
  isReadOnly: Yup163.boolean()
}).required();
var createUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run("create-user", params, options);
};
var createUser_default = createUser;

// src/cloud/users/linkExternalUser.ts
import * as Yup164 from "yup";
var LinkExternalUserValidation = Yup164.object({
  id: Yup164.string().required(),
  username: Yup164.string().required(),
  accessToken: Yup164.string().required(),
  installationId: Yup164.string()
}).required();
var linkExternalUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run(
    "link-external-user",
    params,
    options
  );
};
var linkExternalUser_default = linkExternalUser;

// src/cloud/users/updateUser.ts
import * as Yup165 from "yup";
var UpdateUserValidation = Yup165.object({
  id: Yup165.string().required(),
  firstName: Yup165.string(),
  lastName: Yup165.string(),
  unitId: Yup165.string(),
  healthCenterId: Yup165.string(),
  notificationConfigurations: Yup165.array().of(notificationConfigurationValidation.required()),
  units: Yup165.array().of(Yup165.string().required()),
  password: Yup165.string(),
  isUnsafePassword: Yup165.boolean(),
  whitelistedIPs: Yup165.array().of(Yup165.string().required()),
  disabled: Yup165.boolean(),
  disabledReason: Yup165.string(),
  userProfileId: Yup165.string(),
  navigationACL: Yup165.array().of(Yup165.string().oneOf(NAVIGATION_ROUTES).required()),
  isReadOnly: Yup165.boolean(),
  overrideExternalProfile: Yup165.boolean(),
  overrideExternalUnits: Yup165.boolean()
}).required();
var updateUser = (params, options) => {
  return parse_instance_browser_default.Cloud.run("update-user", params, options);
};
var updateUser_default = updateUser;

// src/cloud/userTick.ts
var userTick = (options) => {
  return parse_instance_browser_default.Cloud.run("user-tick", null, options);
};
var userTick_default = userTick;

// src/domain/environmental-cleaning/api/assign-cleaning-mission.ts
import * as Yup166 from "yup";
var AssignCleaningMissionValidation = Yup166.object({
  missionId: Yup166.string().required()
});
var assignCleaningMissionRoute = "assign-cleaning-mission";
var assignCleaningMission = buildCloudFunctionRunner(assignCleaningMissionRoute);

// src/domain/environmental-cleaning/api/cancel-cleaning-mission.ts
import * as Yup167 from "yup";
var CancelCleaningMissionValidation = Yup167.object({
  missionId: Yup167.string().required(),
  comment: Yup167.string().required()
});
var cancelCleaningMissionRoute = "cancel-cleaning-mission";
var cancelCleaningMission = buildCloudFunctionRunner(cancelCleaningMissionRoute);

// src/domain/environmental-cleaning/api/comment-cleaning-mission.ts
import * as Yup168 from "yup";
var CommentCleaningMissionValidation = Yup168.object({
  missionId: Yup168.string().required(),
  text: Yup168.string().required()
});
var commentCleaningMissionRoute = "comment-cleaning-mission";
var commentCleaningMission = buildCloudFunctionRunner(commentCleaningMissionRoute);

// src/domain/environmental-cleaning/api/declare-bed-clean.ts
import * as Yup169 from "yup";
var DeclareBedCleanValidation = Yup169.object({
  bedId: Yup169.string().required(),
  comment: Yup169.string()
});
var declareBedCleanRoute = "declare-bed-clean";
var declareBedClean = buildCloudFunctionRunner(
  declareBedCleanRoute
);

// src/domain/environmental-cleaning/api/declare-bed-dirty.ts
import * as Yup170 from "yup";
var DeclareBedDirtyValidation = Yup170.object({
  bedId: Yup170.string().required()
});
var declareBedDirtyRoute = "declare-bed-dirty";
var declareBedDirty = buildCloudFunctionRunner(
  declareBedDirtyRoute
);

// src/domain/environmental-cleaning/api/finish-cleaning-mission.ts
import * as Yup171 from "yup";
var FinishCleaningMissionValidation = Yup171.object({
  missionId: Yup171.string().required()
});
var finishCleaningMissionRoute = "finish-cleaning-mission";
var finishCleaningMission = buildCloudFunctionRunner(finishCleaningMissionRoute);

// src/domain/environmental-cleaning/api/interrupt-cleaning-mission.ts
import * as Yup172 from "yup";
var InterruptCleaningMissionValidation = Yup172.object({
  missionId: Yup172.string().required(),
  comment: Yup172.string().required()
});
var interruptCleaningMissionRoute = "interrupt-cleaning-mission";
var interruptCleaningMission = buildCloudFunctionRunner(interruptCleaningMissionRoute);

// src/domain/environmental-cleaning/api/request-cleaning.ts
import * as Yup173 from "yup";

// src/domain/environmental-cleaning/mission/cleaningMissionPriority.ts
var cleaningMissionPriorities = ["P0", "P1", "P2"];
var PRIORITY_OF_FORMER_VALUE = { high: "P0", normal: "P1" };
var cleaningMissionPriorityOf = (value) => {
  if (cleaningMissionPriorities.includes(value)) {
    return value;
  }
  return PRIORITY_OF_FORMER_VALUE[value ?? ""];
};

// src/domain/environmental-cleaning/api/request-cleaning.ts
var RequestCleaningValidation = Yup173.object({
  bedId: Yup173.string().required(),
  priority: Yup173.string().oneOf(cleaningMissionPriorities),
  isolationSpecificities: Yup173.array(),
  cleaningSpecificities: Yup173.array().of(Yup173.string().required()),
  comment: Yup173.string()
});
var requestCleaningRoute = "request-cleaning";
var requestCleaning = buildCloudFunctionRunner(
  requestCleaningRoute
);

// src/domain/environmental-cleaning/api/set-cleaning-instructions.ts
import * as Yup174 from "yup";
var SetCleaningInstructionsValidation = Yup174.object({
  missionId: Yup174.string().required(),
  priority: Yup174.string().oneOf(cleaningMissionPriorities).nullable(),
  isolationSpecificities: Yup174.array(),
  cleaningSpecificities: Yup174.array().of(Yup174.string().required())
});
var setCleaningInstructionsRoute = "set-cleaning-instructions";
var setCleaningInstructions = buildCloudFunctionRunner(setCleaningInstructionsRoute);

// src/domain/environmental-cleaning/api/start-cleaning-mission.ts
import * as Yup175 from "yup";
var StartCleaningMissionValidation = Yup175.object({
  missionId: Yup175.string().required()
});
var startCleaningMissionRoute = "start-cleaning-mission";
var startCleaningMission = buildCloudFunctionRunner(
  startCleaningMissionRoute
);

// src/domain/environmental-cleaning/api/unassign-cleaning-mission.ts
import * as Yup176 from "yup";
var UnassignCleaningMissionValidation = Yup176.object({
  missionId: Yup176.string().required()
});
var unassignCleaningMissionRoute = "unassign-cleaning-mission";
var unassignCleaningMission = buildCloudFunctionRunner(unassignCleaningMissionRoute);

// src/domain/environmental-cleaning/api/legacy/cancel-biocleaning.ts
import * as Yup177 from "yup";
var CancelBiocleaningValidation = Yup177.object({
  id: Yup177.string().required()
});
var cancelBiocleaningRoute = "cancel-biocleaning";
var cancelBiocleaning = buildCloudFunctionRunner(
  cancelBiocleaningRoute
);

// src/domain/environmental-cleaning/api/legacy/cleaning-status.ts
var legacyCleaningStatuses = ["PLANNED", "TODO", "IN_PROGRESS", "DONE", "CANCELED"];

// src/domain/environmental-cleaning/api/legacy/create-biocleaning.ts
import * as Yup178 from "yup";
var CreateBiocleaningValidation = Yup178.object({
  bedId: Yup178.string().required(),
  startAt: Yup178.date().required(),
  status: Yup178.string().oneOf(legacyCleaningStatuses),
  comment: Yup178.string()
});
var createBiocleaningRoute = "create-biocleaning";
var createBiocleaning = buildCloudFunctionRunner(
  createBiocleaningRoute
);

// src/domain/environmental-cleaning/api/legacy/create-bionet.ts
import * as Yup179 from "yup";
var CreateBionetValidation = Yup179.object({
  finess: Yup179.string().required(),
  locationId: Yup179.string().required(),
  status: Yup179.string().oneOf(legacyCleaningStatuses).required(),
  startAt: Yup179.date(),
  endAt: Yup179.date(),
  externalId: Yup179.string()
});
var createBionetRoute = "create-bionet";
var createBionet = buildCloudFunctionRunner(createBionetRoute);

// src/domain/environmental-cleaning/api/legacy/delete-biocleaning.ts
import * as Yup180 from "yup";
var DeleteBiocleaningValidation = Yup180.object({
  ids: Yup180.array(Yup180.string().required()).required()
});
var deleteBiocleaningRoute = "delete-biocleaning";
var deleteBiocleaning = buildCloudFunctionRunner(
  deleteBiocleaningRoute
);

// src/domain/environmental-cleaning/api/legacy/update-biocleaning.ts
import * as Yup181 from "yup";
var UpdateBiocleaningValidation = Yup181.object({
  id: Yup181.string().required(),
  status: Yup181.string().oneOf(legacyCleaningStatuses),
  startAt: Yup181.date(),
  endAt: Yup181.date().nullable()
});
var updateBiocleaningRoute = "update-biocleaning";
var updateBiocleaning = buildCloudFunctionRunner(
  updateBiocleaningRoute
);

// src/domain/environmental-cleaning/api/legacy/update-bionet.ts
import * as Yup182 from "yup";
var UpdateBionetValidation = Yup182.object({
  locationId: Yup182.string(),
  externalId: Yup182.string(),
  status: Yup182.string().oneOf(legacyCleaningStatuses),
  startAt: Yup182.date(),
  endAt: Yup182.date()
});
var updateBionetRoute = "update-bionet";
var updateBionet = buildCloudFunctionRunner(updateBionetRoute);

// src/domain/dashboard/api/get-metabase-dashboard.ts
import * as Yup183 from "yup";
var GetMetabaseDashboardValidation = Yup183.object({
  healthCenterId: Yup183.string().required()
});
var getMetabaseDashboardRoute = "get-metabase-dashboard";
var getMetabaseDashboard = buildCloudFunctionRunner(
  getMetabaseDashboardRoute
);

// src/domain/dashboard/api/get-metabase-patient-transport-dashboard.ts
var GetMetabasePatientTransportDashboardValidation = GetMetabaseDashboardValidation;
var getMetabasePatientTransportDashboardRoute = "get-metabase-patient-transport-dashboard";
var getMetabasePatientTransportDashboard = buildCloudFunctionRunner(getMetabasePatientTransportDashboardRoute);

// src/domain/dashboard/api/get-metabase-qa-dashboard.ts
var GetMetabaseQaDashboardValidation = GetMetabaseDashboardValidation;
var getMetabaseQaDashboardRoute = "get-metabase-qa-dashboard";
var getMetabaseQaDashboard = buildCloudFunctionRunner(getMetabaseQaDashboardRoute);

// src/domain/health-center/api/webhook-link.ts
import * as Yup184 from "yup";
var WebhookLinkValidation = Yup184.object({
  healthCenterId: Yup184.string().required()
});
var getWebhookLinkRoute = "get-webhook-link";
var getWebhookLink = buildCloudFunctionRunner(getWebhookLinkRoute);
var SaveWebhookLinkValidation = Yup184.object({
  healthCenterId: Yup184.string().required(),
  url: Yup184.string().trim().required(),
  secret: Yup184.string().trim()
});
var saveWebhookLinkRoute = "save-webhook-link";
var saveWebhookLink = buildCloudFunctionRunner(saveWebhookLinkRoute);
var removeWebhookLinkRoute = "remove-webhook-link";
var removeWebhookLink = buildCloudFunctionRunner(removeWebhookLinkRoute);

// src/domain/health-center/api/test-webhook-link.ts
var TestWebhookLinkValidation = WebhookLinkValidation;
var testWebhookLinkRoute = "test-webhook-link";
var testWebhookLink = buildCloudFunctionRunner(
  testWebhookLinkRoute
);

// src/domain/thesaurus/api/clear-thesaurus.ts
import * as Yup185 from "yup";
var ClearThesaurusValidation = Yup185.object({
  healthCenterId: Yup185.string().required(),
  force: Yup185.boolean()
});
var clearThesaurusRoute = "clear-thesaurus";
var clearThesaurus = buildCloudFunctionRunner(
  clearThesaurusRoute
);

// src/domain/thesaurus/api/create-thesaurus-item.ts
import * as Yup186 from "yup";
var CreateThesaurusItemValidation = Yup186.object({
  healthCenterId: Yup186.string().required(),
  // Rogné des deux côtés : l'unicité du libellé compare des valeurs exactes.
  reason: Yup186.string().trim().min(1).required(),
  // Ses bornes sont une règle du protocole : l'agrégat les applique, quelle que soit la porte.
  expectedDurationInMinutes: Yup186.number(),
  redirectionUnitIds: Yup186.array(Yup186.string().required()),
  // Un espace de bord casse le rapprochement des messages du SIH sans qu'aucun écran ne le montre.
  externalIds: Yup186.array(Yup186.string().trim().min(1).required())
});
var createThesaurusItemRoute = "create-thesaurus-item";
var createThesaurusItem = buildCloudFunctionRunner(
  createThesaurusItemRoute
);

// src/domain/thesaurus/api/edit-thesaurus-item.ts
import * as Yup187 from "yup";
var EditThesaurusItemValidation = Yup187.object({
  thesaurusItemId: Yup187.string().required(),
  reason: Yup187.string().trim().min(1),
  // Ses bornes sont une règle du protocole : l'agrégat les applique, quelle que soit la porte.
  expectedDurationInMinutes: Yup187.number().nullable(),
  redirectionUnitIds: Yup187.array(Yup187.string().required())
});
var editThesaurusItemRoute = "edit-thesaurus-item";
var editThesaurusItem = buildCloudFunctionRunner(
  editThesaurusItemRoute
);

// src/domain/thesaurus/api/import-thesaurus.ts
import * as Yup188 from "yup";
var ImportThesaurusValidation = Yup188.object({
  file: Yup188.string().required(),
  healthCenterId: Yup188.string().required()
});
var importThesaurusRoute = "import-thesaurus";
var importThesaurus = buildCloudFunctionRunner(
  importThesaurusRoute
);

// src/interop/index.ts
var interop_exports = {};
__export(interop_exports, {
  message: () => message_exports
});

// src/interop/message/index.ts
var message_exports = {};
__export(message_exports, {
  APPOINTMENT_MESSAGE_TYPES: () => APPOINTMENT_MESSAGE_TYPES,
  TYPES: () => TYPES,
  VISIT_TYPES: () => VISIT_TYPES,
  data: () => data_exports,
  isAppointmentMessage: () => isAppointmentMessage,
  isVisitMessage: () => isVisitMessage,
  movementActions: () => movementActions
});

// src/interop/message/data.ts
var data_exports = {};

// src/interop/message/type.ts
var APPOINTMENT_MESSAGE_TYPES = ["CREATE_APPOINTMENT", "UPDATE_APPOINTMENT"];
var VISIT_TYPES = [
  "ADMIT_PATIENT",
  "CANCEL_ADMIT_PATIENT",
  "DISCHARGE_PATIENT",
  "CANCEL_DISCHARGE_PATIENT",
  "TRANSFER_PATIENT",
  "CANCEL_TRANSFER_PATIENT",
  "PRE_ADMIT_PATIENT",
  "CANCEL_PRE_ADMIT_PATIENT",
  "CHANGE_OUTPATIENT_TO_INPATIENT",
  "PENDING_DISCHARGE_PATIENT",
  "CANCEL_PENDING_DISCHARGE_PATIENT",
  "UPDATE_RESPONSIBLE_UNIT",
  "CHANGE_INPATIENT_TO_OUTPATIENT",
  "RETURN_FROM_LEAVE_OF_ABSENCE"
];
var TYPES = [
  ...VISIT_TYPES,
  ...APPOINTMENT_MESSAGE_TYPES,
  "CREATE_PATIENT",
  "UPDATE_PATIENT",
  "MERGE_PATIENT"
];

// src/interop/message/message.ts
var movementActions = ["INSERT", "UPDATE", "CANCEL"];
var isAppointmentMessage = (message) => APPOINTMENT_MESSAGE_TYPES.includes(message.type);
var isVisitMessage = (message) => VISIT_TYPES.includes(message.type);

// src/domain/environmental-cleaning/bed-preparation/BedPreparationPeriod.ts
var bedPreparationStatuses = ["dirty", "clean"];
var bedPreparationCauses = [
  "patient-left",
  "patient-installed",
  "patient-returned",
  "declared-dirty",
  "declared-clean",
  "cleaning-finished"
];
var SILBO_AUTHOR_NAME = "Silbo";
var BedPreparationPeriod = class extends ParseClass {
  constructor(attributes) {
    super("BedPreparationPeriod", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get bed() {
    return this.Get("bed");
  }
  set bed(val) {
    this.Set("bed", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  get startAt() {
    return this.Get("startAt");
  }
  set startAt(val) {
    this.Set("startAt", val);
  }
  get endAt() {
    return this.Get("endAt");
  }
  set endAt(val) {
    this.Set("endAt", val);
  }
  get author() {
    return this.Get("author");
  }
  set author(val) {
    this.Set("author", val);
  }
  get authorName() {
    return this.Get("authorName");
  }
  set authorName(val) {
    this.Set("authorName", val);
  }
  get cause() {
    return this.Get("cause");
  }
  set cause(val) {
    this.Set("cause", val);
  }
  get accommodation() {
    return this.Get("accommodation");
  }
  set accommodation(val) {
    this.Set("accommodation", val);
  }
  get isolationSpecificities() {
    return this.Get("isolationSpecificities");
  }
  set isolationSpecificities(val) {
    this.Set("isolationSpecificities", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("BedPreparationPeriod", BedPreparationPeriod);

// src/domain/environmental-cleaning/bed-preparation/computeBedPreparationStateAt.ts
var READY_SINCE_ALWAYS = { status: "clean" };
var stateOf = (period) => ({
  status: period.status,
  since: period.startAt,
  authorName: period.authorName
});
var covers = (period, date46) => period.startAt <= date46 && (period.endAt === void 0 || date46 < period.endAt);
var openPeriodOf = (periods2) => periods2.find((period) => period.endAt === void 0);
var computeBedPreparationStateAt = (params) => {
  const isPast = params.date < params.now;
  if (isPast) {
    const period = params.periods.find((candidate) => covers(candidate, params.date));
    return period ? stateOf(period) : READY_SINCE_ALWAYS;
  }
  const open = openPeriodOf(params.periods);
  const current = open ? stateOf(open) : READY_SINCE_ALWAYS;
  const isDischargeForeseen = params.plannedDischargeAt !== void 0 && params.plannedDischargeAt <= params.date;
  if (current.status === "clean" && isDischargeForeseen) {
    return { status: "dirty", since: params.plannedDischargeAt };
  }
  return current;
};

// src/domain/environmental-cleaning/bed-preparation/bedCleaningIndicator.ts
var bedCleaningIndicators = ["in-progress", "requested", "dirty"];
var bedCleaningIndicatorOf = (params) => {
  if (params.missionStatus === "in-progress") {
    return "in-progress";
  }
  if (params.missionStatus === "todo") {
    return "requested";
  }
  if (params.preparation === "dirty") {
    return "dirty";
  }
  return void 0;
};

// src/domain/environmental-cleaning/mission/CleaningMission.ts
var cleaningMissionStatuses = ["todo", "in-progress", "done", "canceled"];
var OPEN_CLEANING_MISSION_STATUSES = ["todo", "in-progress"];
var cleaningMissionCancellationReasons = [
  "user",
  "patient-installed",
  "patient-returned",
  "bed-declared-clean",
  "external-system"
];
var cleaningMissionActions = [
  "created",
  "updated",
  "commented",
  "started",
  "interrupted",
  "finished",
  "canceled",
  "assigned",
  "unassigned"
];
var CleaningMission = class extends ParseClass {
  constructor(attributes) {
    super("CleaningMission", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get bed() {
    return this.Get("bed");
  }
  set bed(val) {
    this.Set("bed", val);
  }
  get status() {
    return this.Get("status");
  }
  set status(val) {
    this.Set("status", val);
  }
  /** À défaut de valeur enregistrée, la demande est datée du geste de création, puis de l'enregistrement. */
  get requestedAt() {
    return this.Get("requestedAt") ?? this.history?.find((entry) => entry.action === "created")?.at ?? this.createdAt;
  }
  set requestedAt(val) {
    this.Set("requestedAt", val);
  }
  get priority() {
    return cleaningMissionPriorityOf(this.Get("priority"));
  }
  set priority(val) {
    this.Set("priority", val);
  }
  get isolationSpecificities() {
    return this.Get("isolationSpecificities");
  }
  set isolationSpecificities(val) {
    this.Set("isolationSpecificities", val);
  }
  get cleaningSpecificities() {
    return this.Get("cleaningSpecificities");
  }
  set cleaningSpecificities(val) {
    this.Set("cleaningSpecificities", val);
  }
  get assignee() {
    return this.Get("assignee");
  }
  set assignee(val) {
    this.Set("assignee", val);
  }
  get assigneeName() {
    return this.Get("assigneeName");
  }
  set assigneeName(val) {
    this.Set("assigneeName", val);
  }
  get cleaner() {
    return this.Get("cleaner");
  }
  set cleaner(val) {
    this.Set("cleaner", val);
  }
  get cleanerName() {
    return this.Get("cleanerName");
  }
  set cleanerName(val) {
    this.Set("cleanerName", val);
  }
  get comments() {
    return this.Get("comments");
  }
  set comments(val) {
    this.Set("comments", val);
  }
  get externalId() {
    return this.Get("externalId");
  }
  set externalId(val) {
    this.Set("externalId", val);
  }
  get history() {
    return this.Get("history");
  }
  set history(val) {
    this.Set("history", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("CleaningMission", CleaningMission);

// src/domain/environmental-cleaning/mission/cleaningMissionWorkOrder.ts
var cleaningMissionSortOrders = ["requested", "priority", "planned-entry"];
var DEFAULT_CLEANING_MISSION_SORT_ORDER = "requested";
var PRIORITY_RANK = { P0: 0, P1: 1, none: 2, P2: 3 };
var compareCleaningMissionsByRequest = (a, b) => a.requestedAt.getTime() - b.requestedAt.getTime();
var compareByPriority = (a, b) => PRIORITY_RANK[a.priority ?? "none"] - PRIORITY_RANK[b.priority ?? "none"];
var compareByPlannedEntry = (a, b) => {
  if (a.plannedEntryAt && b.plannedEntryAt) {
    return a.plannedEntryAt.getTime() - b.plannedEntryAt.getTime();
  }
  if (a.plannedEntryAt) {
    return -1;
  }
  return b.plannedEntryAt ? 1 : 0;
};
var CLEANING_MISSION_COMPARATORS = {
  requested: compareCleaningMissionsByRequest,
  priority: (a, b) => compareByPriority(a, b) || compareCleaningMissionsByRequest(a, b),
  "planned-entry": (a, b) => compareByPlannedEntry(a, b) || compareCleaningMissionsByRequest(a, b)
};
var sortCleaningMissions = (missions, order) => [...missions].sort(CLEANING_MISSION_COMPARATORS[order]);

// src/domain/environmental-cleaning/mission/cleaningMissionHistory.ts
var entriesOf = (mission, action) => mission.history.filter((entry) => entry.action === action);
var isCreatedBySilbo = (mission) => !entriesOf(mission, "created")[0]?.by;
var cancellationReasonOf = (mission) => entriesOf(mission, "canceled").at(-1)?.reason;

// src/domain/thesaurus/thesaurus-item/ThesaurusItem.ts
var ThesaurusItem = class extends ParseClass {
  constructor(attributes) {
    super("ThesaurusItem", attributes);
  }
  get healthCenter() {
    return this.Get("healthCenter");
  }
  set healthCenter(val) {
    this.Set("healthCenter", val);
  }
  get reason() {
    return this.Get("reason");
  }
  set reason(val) {
    this.Set("reason", val);
  }
  get expectedDurationInMinutes() {
    return this.Get("expectedDurationInMinutes");
  }
  set expectedDurationInMinutes(val) {
    this.Set("expectedDurationInMinutes", val);
  }
  get redirection() {
    return this.Get("redirection");
  }
  set redirection(val) {
    this.Set("redirection", val);
  }
  get externalIds() {
    return this.Get("externalIds");
  }
  set externalIds(val) {
    this.Set("externalIds", val);
  }
  get lastEditedAt() {
    return this.Get("lastEditedAt");
  }
  set lastEditedAt(val) {
    this.Set("lastEditedAt", val);
  }
  get lastEditedBy() {
    return this.Get("lastEditedBy");
  }
  set lastEditedBy(val) {
    this.Set("lastEditedBy", val);
  }
  get lastEditedByName() {
    return this.Get("lastEditedByName");
  }
  set lastEditedByName(val) {
    this.Set("lastEditedByName", val);
  }
};
parse_instance_browser_default.Object.registerSubclass("ThesaurusItem", ThesaurusItem);

// src/domain/thesaurus/thesaurus-item-limits.ts
var MINUTES_IN_A_DAY = 24 * 60;
var EXPECTED_DURATION_MAX_IN_MINUTES = 365 * MINUTES_IN_A_DAY;

// src/utils/bookedBedDelay.ts
import { addDays, addHours, setHours, subHours } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
var getMaxStartDateToBeBooked = (bookedBedDelayRule, date46) => {
  const { type, value: hours } = bookedBedDelayRule;
  const localDate = new Date(date46);
  if (type !== "HOURS") {
    localDate.setMinutes(0, 0, 0);
  }
  const zonedDate = utcToZonedTime(localDate, DEFAULT_HEALTH_CENTER_TIMEZONE);
  let targetDate;
  switch (type) {
    case "HOURS":
      targetDate = addHours(zonedDate, hours);
      break;
    case "TODAY_AT":
      targetDate = setHours(zonedDate, hours);
      break;
    case "TOMORROW_AT":
      targetDate = setHours(addDays(zonedDate, 1), hours);
      break;
    default:
      targetDate = setHours(addDays(zonedDate, 1), hours);
      break;
  }
  return zonedTimeToUtc(targetDate, DEFAULT_HEALTH_CENTER_TIMEZONE);
};
var isArrivalWithinDelayWindow = (arrival, bookedBedDelayRule, date46) => getMaxStartDateToBeBooked(bookedBedDelayRule, date46).getTime() >= arrival.getTime();
var WINDOW_SEARCH_MARGIN_HOURS = 72;
var getDelayWindowEntryDate = (accommodation, bookedBedDelayRule) => {
  if (!accommodation?.startAt || !bookedBedDelayRule) {
    return void 0;
  }
  const arrival = accommodation.startAt;
  if (!isArrivalWithinDelayWindow(arrival, bookedBedDelayRule, arrival)) {
    return void 0;
  }
  const searchHours = (bookedBedDelayRule.type === "HOURS" ? bookedBedDelayRule.value : 0) + WINDOW_SEARCH_MARGIN_HOURS;
  let rejected = subHours(arrival, searchHours).getTime();
  let validated = arrival.getTime();
  while (validated - rejected > 1) {
    const middle = Math.floor((rejected + validated) / 2);
    if (isArrivalWithinDelayWindow(arrival, bookedBedDelayRule, new Date(middle))) {
      validated = middle;
    } else {
      rejected = middle;
    }
  }
  return new Date(validated);
};
var isBookedAccommodation = (accommodation, bookedBedDelayRule, date46 = /* @__PURE__ */ new Date()) => {
  if (!bookedBedDelayRule || !accommodation) {
    return false;
  }
  return accommodation.startAt > date46 && isArrivalWithinDelayWindow(accommodation.startAt, bookedBedDelayRule, date46);
};
var isDelayReservationOutOfWindow = (accommodation, bookedBedDelayRule, date46 = /* @__PURE__ */ new Date()) => {
  if (accommodation.type !== "RESERVATION" || accommodation.origin !== "DELAY") {
    return false;
  }
  if (!bookedBedDelayRule) {
    return true;
  }
  if (!accommodation.endAt) {
    return false;
  }
  return !isBookedAccommodation({ startAt: accommodation.endAt }, bookedBedDelayRule, date46);
};

// src/utils/dashboard/map-widgets-question-ids.utils.ts
var mapWidgetsQuestionIds = (widgets, mapQuestionId) => widgets.map((widget) => mapWidget(widget, mapQuestionId));
var mapSource = (source, mapQuestionId) => Object.assign({}, source, { questionId: mapQuestionId(source.questionId) });
var mapWidget = (widget, mapQuestionId) => {
  if (!widget || typeof widget !== "object") {
    return widget;
  }
  switch (widget.displayType) {
    case "table":
      if (!widget.options?.source) {
        return widget;
      }
      return {
        ...widget,
        options: { ...widget.options, source: mapSource(widget.options.source, mapQuestionId) }
      };
    case "stat":
      if (!widget.options?.source) {
        return widget;
      }
      return {
        ...widget,
        options: { ...widget.options, source: mapSource(widget.options.source, mapQuestionId) }
      };
    case "select": {
      const source = widget.options?.source;
      if (!source || source.type === "static") {
        return widget;
      }
      return { ...widget, options: { ...widget.options, source: mapSource(source, mapQuestionId) } };
    }
    case "unitsStatisticsTable": {
      if (!widget.options) {
        return widget;
      }
      const { questionId, specialtiesQuestionId } = widget.options;
      return {
        ...widget,
        options: {
          ...widget.options,
          ...questionId !== void 0 ? { questionId: mapQuestionId(questionId) } : {},
          ...specialtiesQuestionId !== void 0 ? { specialtiesQuestionId: mapQuestionId(specialtiesQuestionId) } : {}
        }
      };
    }
    case "tabs":
      if (!Array.isArray(widget.options?.tabs)) {
        return widget;
      }
      return {
        ...widget,
        options: {
          ...widget.options,
          tabs: widget.options.tabs.map((tab) => {
            if (!tab || !Array.isArray(tab.widgets)) {
              return tab;
            }
            return { ...tab, widgets: mapWidgetsQuestionIds(tab.widgets, mapQuestionId) };
          })
        }
      };
    case "group":
      if (!Array.isArray(widget.options?.widgets)) {
        return widget;
      }
      return {
        ...widget,
        options: { ...widget.options, widgets: mapWidgetsQuestionIds(widget.options.widgets, mapQuestionId) }
      };
    default:
      return widget;
  }
};

// src/utils/dashboard/question-title-placeholder.utils.ts
var buildQuestionTitlePlaceholder = (title) => `<${title.trim()}>`;
var parseQuestionTitlePlaceholder = (questionId) => {
  if (typeof questionId !== "string") {
    return void 0;
  }
  const title = questionId.match(/^<([\s\S]+)>$/)?.[1].trim();
  return title || void 0;
};
var isQuestionTitlePlaceholder = (questionId) => parseQuestionTitlePlaceholder(questionId) !== void 0;

// src/utils/formatINS/formatINS.ts
var formatINS = (ins) => {
  if (!ins) {
    return "";
  }
  const cleaned = ins.replace(/\s+/g, "");
  if (cleaned.length !== 15 || !/^\d+$/.test(cleaned)) {
    return ins.trim();
  }
  return [
    cleaned.slice(0, 1),
    cleaned.slice(1, 3),
    cleaned.slice(3, 5),
    cleaned.slice(5, 7),
    cleaned.slice(7, 10),
    cleaned.slice(10, 13),
    cleaned.slice(13, 15)
  ].join(" ");
};

// src/utils/getPatientAge.ts
import { differenceInCalendarDays, differenceInMonths, differenceInYears } from "date-fns";
var getPatientAge = (birthdate) => differenceInYears(/* @__PURE__ */ new Date(), birthdate);
var getPatientAgeToDisplay = (birthdate, now = /* @__PURE__ */ new Date()) => {
  const years = differenceInYears(now, birthdate);
  if (years >= 2) {
    return { unit: "year", value: years };
  }
  const months = differenceInMonths(now, birthdate);
  if (months >= 1) {
    return { unit: "month", value: months };
  }
  return { unit: "day", value: Math.max(differenceInCalendarDays(now, birthdate), 0) };
};

// src/utils/LocationUtils.ts
var encodeExternalIdToUtf8 = (stringToEncode) => Buffer.from(stringToEncode, "utf8").toString();
var getUnitFromArea = async (area, context) => {
  if (!area.healthCenter) {
    return;
  }
  const unit = await new parse_instance_browser_default.Query(Unit).equalTo("healthCenter", HealthCenter.createWithoutData(area.healthCenter.id)).equalTo("areas", Area.createWithoutData(area.id)).first({ sessionToken: context?.user?.getSessionToken() ?? void 0, useMasterKey: context?.master });
  if (unit) {
    return unit;
  }
  if (!area.parent?.id) {
    return;
  }
  const parent = await new parse_instance_browser_default.Query(Area).equalTo("objectId", area.parent.id).select(["healthCenter", "parent"]).first({ sessionToken: context?.user?.getSessionToken() ?? void 0, useMasterKey: context?.master });
  if (!parent) {
    return;
  }
  return getUnitFromArea(parent, context);
};

// src/utils/defaultNotificationConfigurationsByRole.ts
var REGULATOR_NOTIFICATIONS = [
  "NEW_FARE_INCIDENT",
  "PORTER_START_OF_SERVICE",
  "PORTER_END_OF_SERVICE"
];
var MOVEMENT_NOTIFICATIONS = [
  "NEW_PERFORMER_REQUEST",
  "PERFORMER_REQUEST_ACCEPTED",
  "PERFORMER_REQUEST_REJECTED"
];
var PORTER_NOTIFICATIONS = [
  "FARE_ASSIGNED",
  "FARE_UNASSIGNED",
  "FARE_UPDATED",
  "PORTER_SUPPORT_ASSIGNED",
  "PORTER_SUPPORT_UNASSIGNED"
];
var NOTIFICATIONS_BY_ROLE = {
  REGULATOR: REGULATOR_NOTIFICATIONS,
  ADMIN_REGULATOR: REGULATOR_NOTIFICATIONS,
  ADMIN: REGULATOR_NOTIFICATIONS,
  BED_MANAGER: [],
  MANAGER: ["NEW_FARE_INCIDENT"],
  PORTER: PORTER_NOTIFICATIONS
};
var getDefaultNotificationConfigurationsByRole = (role) => {
  const enabledEvents = NOTIFICATIONS_BY_ROLE[role] || [];
  return enabledEvents.map((triggerEvent) => {
    const defaultConfig = DEFAULT_NOTIFICATION_CONFIGURATION[triggerEvent];
    return {
      triggerEvent,
      notificationsProviders: [...defaultConfig.notificationsProviders],
      ...defaultConfig.isAcknowledgeNeeded !== void 0 && {
        isAcknowledgeNeeded: defaultConfig.isAcknowledgeNeeded
      },
      ...defaultConfig.retryPolicy && { retryPolicy: { ...defaultConfig.retryPolicy } }
    };
  });
};
var AVAILABLE_NOTIFICATIONS_BY_ROLE = {
  REGULATOR: REGULATOR_NOTIFICATIONS,
  ADMIN_REGULATOR: [...REGULATOR_NOTIFICATIONS, ...MOVEMENT_NOTIFICATIONS],
  ADMIN: [...REGULATOR_NOTIFICATIONS, ...MOVEMENT_NOTIFICATIONS],
  BED_MANAGER: [...REGULATOR_NOTIFICATIONS, ...MOVEMENT_NOTIFICATIONS],
  MANAGER: ["NEW_FARE_INCIDENT", ...MOVEMENT_NOTIFICATIONS],
  PORTER: PORTER_NOTIFICATIONS
};
var getAvailableNotificationTriggerEventsByRole = (role) => AVAILABLE_NOTIFICATIONS_BY_ROLE[role] || [];

// src/utils/notifications.ts
var findUserConfigurationOrDefault = (user, triggerEvent) => {
  return user.notificationConfigurations?.find((config) => config.triggerEvent === triggerEvent) || DEFAULT_NOTIFICATION_CONFIGURATION[triggerEvent];
};

// src/utils/occupancy/apply-manual-occupancy-to-open-beds.ts
var applyManualOccupancyToOpenBeds = (beds, open, manualOccupancy) => {
  const excludedBeds = beds - open;
  if (manualOccupancy.open > beds) {
    return Math.max(0, manualOccupancy.open - excludedBeds);
  }
  if (excludedBeds > beds - manualOccupancy.open) {
    return open;
  }
  return manualOccupancy.open;
};

// src/utils/occupancy/computeOccupancy.ts
var mergeCounts = (existing = [], incoming = []) => {
  if (!existing && !incoming) {
    return void 0;
  }
  const merged = /* @__PURE__ */ new Map();
  for (const item of existing || []) {
    merged.set(item.specificity.id, { ...item });
  }
  for (const item of incoming || []) {
    const current = merged.get(item.specificity.id);
    if (current) {
      current.count += item.count;
    } else {
      merged.set(item.specificity.id, { ...item });
    }
  }
  return merged.size > 0 ? Array.from(merged.values()) : void 0;
};
var getAvailableBeds = (male, female, indifferent) => {
  return male === void 0 && female === void 0 && indifferent === void 0 ? void 0 : (male || 0) + (female || 0) + (indifferent || 0);
};
var computeOccupancy = (occupancies) => {
  let open = 0;
  let booked = 0;
  let covid = 0;
  let isolated = 0;
  let isolatedAir = 0;
  let isolatedDroplet = 0;
  let isolatedContact = 0;
  let isolatedProtector = 0;
  let waitingForDownstreamBed = 0;
  let accomodated = 0;
  let close = 0;
  let dDayAvailabilities = { female: 0, male: 0, indifferent: 0 };
  let h24Availabilities = { female: 0, male: 0, indifferent: 0 };
  let h48Availabilities = { female: 0, male: 0, indifferent: 0 };
  let dDayRoomAvailabilities = {
    total: 0,
    single: 0,
    double: { male: 0, female: 0, indifferent: 0 }
  };
  let h24RoomAvailabilities = {
    total: 0,
    single: 0,
    double: { male: 0, female: 0, indifferent: 0 }
  };
  let h48RoomAvailabilities = {
    total: 0,
    single: 0,
    double: { male: 0, female: 0, indifferent: 0 }
  };
  let admission = 0;
  let discharge = 0;
  let updatedAt = /* @__PURE__ */ new Date();
  let available = 0;
  let supernumerary = 0;
  let currentOccupancy = void 0;
  let specificityCounts = void 0;
  for (let occupancy of occupancies) {
    if (occupancy?.open !== void 0) {
      open = open + occupancy.open;
    }
    if (occupancy?.booked !== void 0) {
      booked = booked + occupancy.booked;
    }
    if (occupancy?.covid !== void 0) {
      covid = covid + occupancy.covid;
    }
    isolated += occupancy?.isolated ?? 0;
    isolatedAir += occupancy?.isolatedAir ?? 0;
    isolatedDroplet += occupancy?.isolatedDroplet ?? 0;
    isolatedContact += occupancy?.isolatedContact ?? 0;
    isolatedProtector += occupancy?.isolatedProtector ?? 0;
    if (occupancy?.waitingForDownstreamBed !== void 0) {
      waitingForDownstreamBed = waitingForDownstreamBed + occupancy.waitingForDownstreamBed;
    }
    if (occupancy?.supernumerary !== void 0) {
      supernumerary = supernumerary + occupancy.supernumerary;
    }
    const availableUnitBeds = getAvailableBeds(
      occupancy?.dDayAvailabilities?.male,
      occupancy?.dDayAvailabilities?.female,
      occupancy?.dDayAvailabilities?.indifferent
    );
    if (availableUnitBeds !== void 0) {
      available = available + availableUnitBeds;
    }
    if (occupancy?.accomodated !== void 0) {
      accomodated = accomodated + occupancy.accomodated;
    }
    if (occupancy?.close !== void 0) {
      close = close + occupancy.close;
    }
    if (occupancy?.dDayAvailabilities !== void 0) {
      if (occupancy?.dDayAvailabilities.male !== void 0) {
        dDayAvailabilities.male = dDayAvailabilities.male + occupancy.dDayAvailabilities.male;
      }
      if (occupancy?.dDayAvailabilities.female !== void 0) {
        dDayAvailabilities.female = dDayAvailabilities.female + occupancy.dDayAvailabilities.female;
      }
      if (occupancy?.dDayAvailabilities.indifferent !== void 0) {
        dDayAvailabilities.indifferent = dDayAvailabilities.indifferent + occupancy.dDayAvailabilities.indifferent;
      }
    }
    if (occupancy?.h24Availabilities !== void 0) {
      if (occupancy?.h24Availabilities.male !== void 0) {
        h24Availabilities.male = h24Availabilities.male + occupancy.h24Availabilities.male;
      }
      if (occupancy?.h24Availabilities.female !== void 0) {
        h24Availabilities.female = h24Availabilities.female + occupancy.h24Availabilities.female;
      }
      if (occupancy?.h24Availabilities.indifferent !== void 0) {
        h24Availabilities.indifferent = h24Availabilities.indifferent + occupancy.h24Availabilities.indifferent;
      }
    }
    if (occupancy?.h48Availabilities !== void 0) {
      if (occupancy?.h48Availabilities.male !== void 0) {
        h48Availabilities.male = h48Availabilities.male + occupancy.h48Availabilities.male;
      }
      if (occupancy?.h48Availabilities.female !== void 0) {
        h48Availabilities.female = h48Availabilities.female + occupancy.h48Availabilities.female;
      }
      if (occupancy?.h48Availabilities.indifferent !== void 0) {
        h48Availabilities.indifferent = h48Availabilities.indifferent + occupancy.h48Availabilities.indifferent;
      }
    }
    if (occupancy?.dDayRoomAvailabilities !== void 0) {
      if (occupancy?.dDayRoomAvailabilities.total !== void 0) {
        dDayRoomAvailabilities.total = dDayRoomAvailabilities.total + occupancy.dDayRoomAvailabilities.total;
      }
      if (occupancy?.dDayRoomAvailabilities.single !== void 0) {
        dDayRoomAvailabilities.single = dDayRoomAvailabilities.single + occupancy.dDayRoomAvailabilities.single;
      }
      if (occupancy?.dDayRoomAvailabilities.double !== void 0) {
        dDayRoomAvailabilities.double = {
          female: occupancy.dDayRoomAvailabilities.double.female,
          male: occupancy.dDayRoomAvailabilities.double.male,
          indifferent: occupancy.dDayRoomAvailabilities.double.indifferent
        };
      }
    }
    if (occupancy?.h24RoomAvailabilities !== void 0) {
      if (occupancy?.h24RoomAvailabilities.total !== void 0) {
        h24RoomAvailabilities.total = h24RoomAvailabilities.total + occupancy.h24RoomAvailabilities.total;
      }
      if (occupancy?.h24RoomAvailabilities.single !== void 0) {
        h24RoomAvailabilities.single = h24RoomAvailabilities.single + occupancy.h24RoomAvailabilities.single;
      }
      if (occupancy?.h24RoomAvailabilities.double !== void 0) {
        h24RoomAvailabilities.double = {
          female: occupancy.h24RoomAvailabilities.double.female,
          male: occupancy.h24RoomAvailabilities.double.male,
          indifferent: occupancy.h24RoomAvailabilities.double.indifferent
        };
      }
    }
    if (occupancy?.h48RoomAvailabilities !== void 0) {
      if (occupancy?.h48RoomAvailabilities.total !== void 0) {
        h48RoomAvailabilities.total = h48RoomAvailabilities.total + occupancy.h48RoomAvailabilities.total;
      }
      if (occupancy?.h48RoomAvailabilities.single !== void 0) {
        h48RoomAvailabilities.single = h48RoomAvailabilities.single + occupancy.h48RoomAvailabilities.single;
      }
      if (occupancy?.h48RoomAvailabilities.double !== void 0) {
        h48RoomAvailabilities.double = {
          female: occupancy.h48RoomAvailabilities.double.female,
          male: occupancy.h48RoomAvailabilities.double.male,
          indifferent: occupancy.h48RoomAvailabilities.double.indifferent
        };
      }
    }
    if (occupancy?.admission !== void 0) {
      admission = admission + occupancy.admission;
    }
    if (occupancy?.discharge !== void 0) {
      discharge = discharge + occupancy.discharge;
    }
    if (occupancy?.updatedAt) {
      updatedAt = new Date(Math.min(updatedAt.getTime(), occupancy.updatedAt.getTime()));
    }
    specificityCounts = mergeCounts(specificityCounts, occupancy?.specificityCounts);
    if (occupancy?.currentOccupancy) {
      if (currentOccupancy) {
        currentOccupancy = {
          booked: currentOccupancy.booked + occupancy.currentOccupancy.booked,
          open: currentOccupancy.open + occupancy.currentOccupancy.open,
          close: currentOccupancy.close + occupancy.currentOccupancy.close,
          available: currentOccupancy.available + occupancy.currentOccupancy.available,
          rate: 0,
          admissions: currentOccupancy.admissions + occupancy.currentOccupancy.admissions,
          discharges: currentOccupancy.discharges + occupancy.currentOccupancy.discharges,
          availabilities: {
            male: currentOccupancy.availabilities.male + occupancy.currentOccupancy.availabilities.male,
            female: currentOccupancy.availabilities.female + occupancy.currentOccupancy.availabilities.female,
            indifferent: currentOccupancy.availabilities.indifferent + occupancy.currentOccupancy.availabilities.indifferent
          },
          accommodated: currentOccupancy.accommodated + occupancy.currentOccupancy.accommodated,
          covid: currentOccupancy.covid + occupancy.currentOccupancy.covid,
          isolated: currentOccupancy.isolated + occupancy.currentOccupancy.isolated,
          isolatedAir: currentOccupancy.isolatedAir + occupancy.currentOccupancy.isolatedAir,
          isolatedDroplet: currentOccupancy.isolatedDroplet + occupancy.currentOccupancy.isolatedDroplet,
          isolatedContact: currentOccupancy.isolatedContact + occupancy.currentOccupancy.isolatedContact,
          isolatedProtector: currentOccupancy.isolatedProtector + occupancy.currentOccupancy.isolatedProtector,
          waitingForDownstreamBed: currentOccupancy.waitingForDownstreamBed + occupancy.currentOccupancy.waitingForDownstreamBed,
          supernumerary: {
            male: currentOccupancy.supernumerary.male + occupancy.currentOccupancy.supernumerary.male,
            female: currentOccupancy.supernumerary.female + occupancy.currentOccupancy.supernumerary.female,
            indifferent: currentOccupancy.supernumerary.indifferent + occupancy.currentOccupancy.supernumerary.indifferent
          },
          roomAvailabilities: {
            total: (currentOccupancy.roomAvailabilities?.total ?? 0) + (occupancy.currentOccupancy.roomAvailabilities?.total ?? 0),
            single: (currentOccupancy.roomAvailabilities?.single ?? 0) + (occupancy.currentOccupancy.roomAvailabilities?.single ?? 0),
            double: {
              male: (currentOccupancy.roomAvailabilities?.double?.male ?? 0) + (occupancy.currentOccupancy.roomAvailabilities?.double?.male ?? 0),
              female: (currentOccupancy.roomAvailabilities?.double?.female ?? 0) + (occupancy.currentOccupancy.roomAvailabilities?.double?.female ?? 0),
              indifferent: (currentOccupancy.roomAvailabilities?.double?.indifferent ?? 0) + (occupancy.currentOccupancy.roomAvailabilities?.double?.indifferent ?? 0)
            }
          },
          specificityCounts: mergeCounts(
            currentOccupancy.specificityCounts ?? currentOccupancy.customSpecificityCounts,
            occupancy.currentOccupancy.specificityCounts ?? occupancy.currentOccupancy.customSpecificityCounts
          )
        };
        currentOccupancy.rate = currentOccupancy.open ? Math.round(
          (currentOccupancy.open - currentOccupancy.available - currentOccupancy.booked) * 100 / currentOccupancy.open
        ) : 0;
      } else {
        currentOccupancy = occupancy.currentOccupancy;
      }
    }
  }
  const occupied = open - available - booked;
  const rate = open ? Math.round(occupied * 100 / open) : 0;
  const total = open + close;
  return {
    covid,
    isolated,
    isolatedAir,
    isolatedDroplet,
    isolatedContact,
    isolatedProtector,
    waitingForDownstreamBed,
    accomodated,
    open,
    available,
    occupied,
    booked,
    rate,
    updatedAt,
    close,
    admission,
    dDayAvailabilities,
    h24Availabilities,
    h48Availabilities,
    dDayRoomAvailabilities,
    h24RoomAvailabilities,
    h48RoomAvailabilities,
    discharge,
    specificityCounts,
    supernumerary,
    total,
    currentOccupancy
  };
};

// src/utils/occupancy/getBedOccupancy.ts
var getBedOccupancy = (dDaySnapshot, h24Snapshot, h48Snapshot, dDayAdmission, dDayDischarge) => {
  let close = 0;
  let h24Close = 0;
  let h48Close = 0;
  let open = 0;
  let h24Open = 0;
  let h48Open = 0;
  let booked = 0;
  let h24Booked = 0;
  let h48Booked = 0;
  let dDayAvailabilities = { male: 0, female: 0, indifferent: 0 };
  let h24Availabilities = { male: 0, female: 0, indifferent: 0 };
  let h48Availabilities = { male: 0, female: 0, indifferent: 0 };
  let admission = 0;
  let discharge = 0;
  let dDaySupernumerary = void 0;
  let h24Supernumerary = void 0;
  let h48Supernumerary = void 0;
  if (!dDaySnapshot.bed.excludedFromOccupancy) {
    if (dDaySnapshot.bed.supernumerary) {
      if (dDaySnapshot.status === "BUSY") {
        dDaySupernumerary = getSnapshotGender(dDaySnapshot);
      }
    } else {
      if (dDaySnapshot.status === "CLOSED") {
        close++;
      } else {
        open++;
      }
      if (h24Snapshot.status === "CLOSED") {
        h24Close++;
      } else {
        h24Open++;
      }
      if (h48Snapshot.status === "CLOSED") {
        h48Close++;
      } else {
        h48Open++;
      }
      if (dDaySnapshot.status === "BOOKED") {
        booked++;
      }
      if (h24Snapshot.status === "BOOKED") {
        h24Booked++;
      }
      if (h48Snapshot.status === "BOOKED") {
        h48Booked++;
      }
    }
    if (h24Snapshot.bed.supernumerary && h24Snapshot.status === "BUSY") {
      h24Supernumerary = getSnapshotGender(h24Snapshot);
    }
    if (h48Snapshot.bed.supernumerary && h48Snapshot.status === "BUSY") {
      h48Supernumerary = getSnapshotGender(h48Snapshot);
    }
    dDayAvailabilities = getGenderAvailability(dDaySnapshot);
    h24Availabilities = getGenderAvailability(h24Snapshot);
    h48Availabilities = getGenderAvailability(h48Snapshot);
    admission = dDayAdmission;
    discharge = dDayDischarge;
  }
  const isAccommodated = dDaySnapshot.isAccommodated || dDaySnapshot.specificities.includes("ACCOMMODATED");
  const specificityCounts = dDaySnapshot.customSpecificities?.length ? dDaySnapshot.customSpecificities.map((s) => ({ specificity: s, count: 1 })) : void 0;
  return {
    covid: dDaySnapshot.specificities.includes("COVID") ? 1 : 0,
    accomodated: isAccommodated ? 1 : 0,
    isolated: dDaySnapshot.specificities.includes("ISOLATED") ? 1 : 0,
    isolatedAir: dDaySnapshot.specificities.includes("ISOLATED_AIR") ? 1 : 0,
    isolatedDroplet: dDaySnapshot.specificities.includes("ISOLATED_DROPLET") ? 1 : 0,
    isolatedContact: dDaySnapshot.specificities.includes("ISOLATED_CONTACT") ? 1 : 0,
    isolatedProtector: dDaySnapshot.specificities.includes("ISOLATED_PROTECTOR") ? 1 : 0,
    waitingForDownstreamBed: dDaySnapshot.specificities.includes("WAITING_FOR_DOWNSTREAM_BED") ? 1 : 0,
    specificityCounts,
    booked,
    h24Booked,
    h48Booked,
    close,
    h24Close,
    h48Close,
    open,
    h24Open,
    h48Open,
    dDaySupernumerary,
    h24Supernumerary,
    h48Supernumerary,
    dDayAvailabilities,
    h24Availabilities,
    h48Availabilities,
    admission,
    discharge,
    updatedAt: /* @__PURE__ */ new Date()
  };
};
var getSnapshotGender = (snapshot) => {
  return {
    female: snapshot.gender === "FEMALE" ? 1 : 0,
    indifferent: snapshot.gender === "UNKNOWN" ? 1 : 0,
    male: snapshot.gender === "MALE" ? 1 : 0
  };
};
var getGenderAvailability = (snapshot) => {
  if (!snapshot.bed.supernumerary) {
    return {
      female: snapshot.gender === "FEMALE" && snapshot.status === "AVAILABLE" ? 1 : 0,
      indifferent: snapshot.gender === "UNKNOWN" && snapshot.status === "AVAILABLE" ? 1 : 0,
      male: snapshot.gender === "MALE" && snapshot.status === "AVAILABLE" ? 1 : 0
    };
  }
  return {
    male: 0,
    female: 0,
    indifferent: 0
  };
};

// src/utils/occupancy/getBedSnapshot.ts
var getBedStatus = (accommodation) => {
  if (accommodation?.type === "RESERVATION") {
    return "BOOKED";
  }
  if (accommodation) {
    const hasVisit = !!accommodation.visit;
    return hasVisit ? "BUSY" : "CLOSED";
  }
  return "AVAILABLE";
};
var getBedGender = (accommodationsRoom, accommodation) => {
  if (!accommodationsRoom.length && !accommodation) {
    return "UNKNOWN";
  }
  if (accommodation?.visit) {
    return accommodation.visit.gender;
  }
  const female = accommodationsRoom.some((accommodation2) => accommodation2.visit?.gender === "FEMALE");
  const male = accommodationsRoom.some((accommodation2) => accommodation2.visit?.gender === "MALE");
  if (female === male) {
    return "UNKNOWN";
  }
  if (female) {
    return "FEMALE";
  }
  return "MALE";
};
var getBedSnapshot = ({
  bed,
  accommodationsRoom,
  accommodation
}) => ({
  bed,
  gender: getBedGender(accommodationsRoom, accommodation),
  specificities: accommodation?.specificities || [],
  customSpecificities: accommodation?.customSpecificities,
  isAccommodated: accommodation?.isAccommodated ?? false,
  unit: accommodation?.unit,
  responsibleUnit: accommodation?.responsibleUnit,
  status: getBedStatus(accommodation)
});

// src/utils/url.utils.ts
function buildUrl(baseUrl, path) {
  const originOnly = extractOrigin(baseUrl);
  const trimmedPath = path.replace(/^\/+/, "");
  if (!trimmedPath) {
    return originOnly;
  }
  return `${originOnly}/${trimmedPath}`;
}
function extractOrigin(base) {
  try {
    const url = new URL(base);
    return url.origin;
  } catch {
    return base;
  }
}
function validateUrl(url) {
  const parsed = new URL(url);
  if (!["http:", "https:"].includes(parsed.protocol)) {
    throw new Error(`Invalid URL protocol: ${parsed.protocol}. Expected http: or https:`);
  }
  return parsed.href;
}
function buildAndValidateUrl(baseUrl, path, fallbackOrigin) {
  const effectiveBase = baseUrl || fallbackOrigin || "";
  if (!effectiveBase) {
    throw new Error("No base URL or fallback origin provided");
  }
  const fullUrl = buildUrl(effectiveBase, path);
  return validateUrl(fullUrl);
}

// src/utils/users/password.ts
var generatePassword = (length = 20, characters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$") => Array.from(crypto.getRandomValues(new Uint32Array(length))).map((x) => characters[x % characters.length]).join("");
var isPinValid = (pin) => {
  const is4Digits = pin.length === 4;
  const hasOnlyDigits = /^\d+$/.test(pin);
  return {
    valid: is4Digits && hasOnlyDigits,
    is4Digits,
    hasOnlyDigits
  };
};
var generateRandomPin = () => generatePassword(4, "0123456789");
var isPasswordValid = (password) => {
  const isAtLeast12Characters = password.length >= 12;
  const hasAtLeastOneUppercaseLetter = /[A-Z]/.test(password);
  const hasAtLeastOneDigit = /[0-9]/.test(password);
  const hasAtLeastOneSpecialCharacter = /[!@#$%^&*()_+\-=\]{};':"\\|,.<>?]+/.test(password);
  return {
    valid: isAtLeast12Characters && hasAtLeastOneUppercaseLetter && hasAtLeastOneDigit && hasAtLeastOneSpecialCharacter,
    isAtLeast12Characters,
    hasAtLeastOneUppercaseLetter,
    hasAtLeastOneDigit,
    hasAtLeastOneSpecialCharacter
  };
};
var generateRandomPassword = () => {
  const password = generatePassword(20);
  return isPasswordValid(password).valid ? password : generateRandomPassword();
};
var generateRandomUserPassword = (role) => {
  if (true) {
    return role === "PORTER" ? "1234" : "foo";
  }
  return role === "PORTER" ? generateRandomPin() : generateRandomPassword();
};
var validateUserPassword = (password, role) => role === "PORTER" ? isPinValid(password).valid : isPasswordValid(password).valid;

// src/utils/users/role.ts
var ACCESSIBLE_ROLES = {
  PORTER: [],
  REGULATOR: ["PORTER", "REGULATOR", "MANAGER"],
  MANAGER: ["PORTER", "REGULATOR", "MANAGER"],
  BED_MANAGER: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER"],
  ADMIN_REGULATOR: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER", "ADMIN_REGULATOR", "ADMIN"],
  ADMIN: ["PORTER", "REGULATOR", "MANAGER", "BED_MANAGER", "ADMIN_REGULATOR", "ADMIN"]
};
var CREATABLE_ROLES = {
  PORTER: [],
  REGULATOR: ["PORTER", "BED_MANAGER"],
  MANAGER: ["PORTER", "BED_MANAGER"],
  BED_MANAGER: ["PORTER", "BED_MANAGER"],
  ADMIN_REGULATOR: ["PORTER", "BED_MANAGER", "ADMIN"],
  ADMIN: ["PORTER", "BED_MANAGER", "ADMIN"]
};
var getAccessibleRoles = (role) => ACCESSIBLE_ROLES[role];
var getCreatableRoles = (role) => CREATABLE_ROLES[role];
var hasUserAccessToRole = (user, role) => getAccessibleRoles(user?.role).includes(role);
var canUserCreateRole = (user, role) => (getCreatableRoles(user?.role) ?? []).includes(role);

// src/index.esm.ts
var index_esm_default = parse_instance_browser_default;
export {
  ACCESSIBLE_ROLES,
  ACCOMMODATION_REQUEST_TYPES,
  ACCOMMODATION_TYPES,
  ADMIN_ROUTES,
  Accommodation,
  AccommodationHistory,
  AccommodationRequest,
  Anomaly,
  Appointment,
  Area,
  AreaAvailabilityPeriod,
  AreaTree,
  BED_REASON_TYPES,
  BED_STATUSES,
  BedBlock,
  BedClosingReason,
  BedPreparationPeriod,
  CLEANING_MISSION_COMPARATORS,
  COLUMN_RENDERER_TYPES,
  COLUMN_THRESHOLD_COLORS,
  COLUMN_THRESHOLD_MODES,
  CapacityPeriod,
  CareSector,
  CleaningMission,
  cloud_exports as Cloud,
  CodeSystemConcept,
  ConceptMap,
  Config,
  DASHBOARD_SELECT_SOURCE_TYPES,
  DASHBOARD_TABLE_GROUP_MODES,
  DEFAULT_ACTION_PERMISSIONS,
  DEFAULT_CAPACITY_CONFIG,
  DEFAULT_CLEANING_MISSION_SORT_ORDER,
  DEFAULT_HEALTH_CENTER_TIMEZONE,
  DEFAULT_MOVEMENT_REQUEST_CONFIG,
  DEFAULT_MOVEMENT_REQUEST_TYPE_CONFIG,
  DEFAULT_NOTIFICATION_CONFIGURATION,
  DEFAULT_OCCUPANCY_LEVELS,
  DEFAULT_VISIBILITY_CONFIG_BY_TYPE,
  Dashboard,
  DashboardSlot,
  DischargeDestination,
  EMPTY_VISIBILITY_CONFIG,
  EXPECTED_DURATION_MAX_IN_MINUTES,
  EmergencyOccupancy,
  ExternalAuthUnitRule,
  ExternalPatientTransport,
  FARE_ASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UNASSIGNED_DEFAULT_CONFIGURATION,
  FARE_UPDATED_DEFAULT_CONFIGURATION,
  Fare,
  FareAssignation,
  FareHistory,
  GamExport,
  HealthCenter,
  HealthCenterConfig,
  Incident,
  interop_exports as Interop,
  InteropAppointment,
  InteropLocation,
  InteropMessage,
  InteropMessageRaw,
  InteropMessageSIU,
  InteropMovement,
  InteropMovementTypes,
  InteropOrganization,
  InteropPatientAccount,
  InteropPatientIdentity,
  InteropPatientVisit,
  Journey,
  KURT_ROUTES,
  Locale,
  MAX_SLOT_CACHE_DURATION_MS,
  MAX_SLOT_REFRESH_INTERVAL_MS,
  MINUTES_PER_WEEK,
  MOBILE_ROUTES,
  Migration,
  Movement,
  NAVIGATION_ROUTES,
  NEW_FARE_INCIDENT_DEFAULT_CONFIGURATION,
  NEW_PERFORMER_REQUEST_DEFAULT_CONFIGURATION,
  Notification,
  OCCUPANCY_LEVEL_COLORS,
  OPEN_CLEANING_MISSION_STATUSES,
  OrganizationAffiliation,
  PENDING_PAN,
  PERFORMER_REQUEST_ACCEPTED_DEFAULT_CONFIGURATION,
  PERFORMER_REQUEST_REJECTED_DEFAULT_CONFIGURATION,
  PORTER_END_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_START_OF_SERVICE_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_ASSIGNED_DEFAULT_CONFIGURATION,
  PORTER_SUPPORT_UNASSIGNED_DEFAULT_CONFIGURATION,
  PathDefaultTime,
  Patient,
  PatientIdentity,
  PerformerRequest,
  Porter,
  Practitioner,
  REQUEST_END_CAUSES,
  REQUEST_STATUS_RANK,
  ACCOMMODATION_REQUEST_TYPES as REQUEST_TYPES,
  Reservation,
  SABRI_ROUTES,
  SILBO_AUTHOR_NAME,
  SLOT_KEYS,
  STAT_LABEL_COLORS,
  STAT_LABEL_RENDERER_TYPES,
  STAT_RENDERER_TYPES,
  Specialty,
  Specificity,
  SpecificityUtils,
  StringUtils,
  TERMINAL_PERFORMER_REQUEST_STATUSES,
  ThesaurusItem,
  Unit,
  UnitHistory,
  UnitManualOccupancy,
  UnitOccupancy,
  User,
  UserConfig,
  UserHealthCenterConfig,
  UserProfile,
  View,
  WIDGET_COL_SPAN,
  WIDGET_DERIVED_COLUMN_FORMULAS,
  WIDGET_DISPLAY_TYPES,
  WIDGET_TABS_HEADER_ALIGNMENT,
  WIDGET_UNITS_STATISTICS_TABLE_STRUCTURE,
  accommodationSpecificities,
  accommodationStatus,
  addMonths,
  anomalyStatus,
  anomalyType,
  anonymousModes,
  applyManualOccupancyToOpenBeds,
  appointmentStatus,
  areColumnThresholdsValid,
  availabilityPeriodStatus,
  bedCleaningIndicatorOf,
  bedCleaningIndicators,
  bedPreparationCauses,
  bedPreparationStatuses,
  buildAndValidateUrl,
  buildPatientSearch,
  buildQuestionTitlePlaceholder,
  buildUrl,
  canUserCreateRole,
  cancellableConfirmedFareStatus,
  cancellationReasonOf,
  capacityModes,
  capacityPeriodAdjustmentModes,
  capacityPeriodTypes,
  careSectorOverflowModes,
  cleaningMissionActions,
  cleaningMissionCancellationReasons,
  cleaningMissionPriorities,
  cleaningMissionPriorityOf,
  cleaningMissionSortOrders,
  cleaningMissionStatuses,
  compactActivityProfile,
  compareCleaningMissionsByRequest,
  computeBedPreparationStateAt,
  computeEmergencyOccupanciesOptions,
  computeOccupancy,
  conceptRelationships,
  configurableViewTypes,
  contactPointSystems,
  contactPointUses,
  convertToSpecificityObject,
  crisisBannerColors,
  decodeServiceConfig,
  decodeServiceConfigRoomKey,
  index_esm_default as default,
  defaultFilterByType,
  defaultRequestStatuses,
  delayRuleTypes,
  emergencyOccupancyKey,
  emergencyOccupancyService,
  emergencyPages,
  encodeExternalIdToUtf8,
  encodeServiceConfig,
  encodeServiceConfigRoomKey,
  environmentalCleaningOptions,
  errorTypes,
  exclusionReasons,
  externalPatientTransportPosition,
  externalTypeCodes,
  farePositions,
  fareStatus,
  findUserConfigurationOrDefault,
  formatFirstname,
  formatINS,
  formatName,
  formatNameShort,
  generateRandomPassword,
  generateRandomPin,
  generateRandomUserPassword,
  getAccessibleRoles,
  getAvailableBeds,
  getAvailableNotificationTriggerEventsByRole,
  getBedGender,
  getBedOccupancy,
  getBedSnapshot,
  getBedStatus,
  getCreatableRoles,
  getDefaultNotificationConfigurationsByRole,
  getDelayWindowEntryDate,
  getFaresDifferences,
  getMaxStartDateToBeBooked,
  getPatientAge,
  getPatientAgeToDisplay,
  getSectorBySpecialty,
  getSectorsBySpecialties,
  getSpecialtiesBySector,
  getSpecialtiesBySectors,
  getUnitFromArea,
  hasAccessToRoute,
  hasMedicalResponsibility,
  hasUserAccessToRole,
  healthCenterFlowTypes,
  hospitalizationModes,
  incidentReasons,
  invalidColumnThresholdIndexes,
  invalidTextThresholdIndexes,
  invalidThresholdIndexes,
  isBedBlock,
  isBookedAccommodation,
  isCreatedBySilbo,
  isDelayReservationOutOfWindow,
  isEmergencyUnit,
  isEmptyReservation,
  isEnvironmentalCleaningActive,
  isInteropMessageHprimData,
  isNavigationRouteOffered,
  isPasswordValid,
  isPinValid,
  isQuestionTitlePlaceholder,
  isReservation,
  isSystemReservation,
  isUnitActiveAt,
  isUserProfileActionOffered,
  isWithoutEnd,
  isolatedSpecificities,
  mapWidgetsQuestionIds,
  maxDate,
  mergeCounts,
  migrationStatuses,
  minDate,
  movementRequestRoutingModeOptions,
  movementStatusesFilters,
  movementTypesFilters,
  movementsFlowTypes,
  movementsViewTypes,
  normalizeTableColumns,
  notificationConfigurationValidation,
  notificationProvider,
  notificationTriggerEvent,
  occupancyFiltersType,
  occupiesNoInstant,
  openPeriodOf,
  organizationParentFields,
  parseQuestionTitlePlaceholder,
  patientCreationOrigins,
  patientCreationSources,
  patientGender,
  patientOutcomeTypes,
  patientPlacementViews,
  periods,
  porterBreak,
  quickAccessSpecificityTypes,
  requestStatuses,
  requestsCreatedSinceDirections,
  requestsCreatedSinceOptions,
  requestsDisplayedTypes,
  resolveSlotValue,
  resolveThresholdMode,
  roomAlignments,
  rorTypes,
  serviceOrientations,
  sortCleaningMissions,
  specificityQuickAccessFormTypes,
  specificityTypes,
  structureAxes,
  subMonths,
  supportsQuickAccess,
  territoryFlowTypes,
  territoryViewTypes,
  unitSectors,
  unitSpecialties,
  unitTypes,
  unitViewsTypes,
  unitVisibilityConfigOptions,
  userProfileActions,
  userProfileEnvironmentalCleaningActions,
  userProfileKurtActions,
  userProfileSabriActions,
  userRoles,
  validateUrl,
  validateUserPassword,
  webUserRoles,
  writableStructureAxes
};
